(function(){
"use strict";

/* ══════════════════════════════════════════════════════════════════════════
   ██  SHOPIFY PORT — SECTION ROOT  ██
   On the standalone page this script owned the document: it looked elements
   up with document.getElementById and it hung its own state on <body>.
   Inside a theme, <body> belongs to the storefront and the id namespace is
   shared with the theme and with every installed app. Both now resolve to
   the section wrapper instead, which is the element that carries data-state
   and the is-* state classes in the stylesheet.

   Falling back to documentElement rather than throwing: if the wrapper is
   somehow absent the lookups return null exactly as they would have before,
   which is a case this code already handles, instead of a TypeError that
   would take the storefront's other scripts down with it.

   THE BOOT GUARD: a section can be placed twice. Two copies would both read
   ?v= and both start playing. The second one initialises nothing and is left
   inert rather than removed from the DOM.
   ══════════════════════════════════════════════════════════════════════════ */
if (window.__BMVH_BOOTED) { return; }
window.__BMVH_BOOTED = true;
var BMVH_ROOT = document.querySelector('.bmvh') || document.documentElement;


/* ══════════════════════════════════════════════════════════════════════════
   ██  CONFIG — THE API GATEWAY INVOKE URL. THE ONLY THING TO CHANGE HERE.  ██
   ══════════════════════════════════════════════════════════════════════════ */
var API_BASE = "https://7pfc0pd7vc.execute-api.us-east-1.amazonaws.com/prod";
var API = {
  next:   API_BASE + "/next",
  regen:  API_BASE + "/regen",
  custom: API_BASE + "/custom",
  status: API_BASE + "/status",
  job:    API_BASE + "/job",
  photo:  API_BASE + "/photo",
  upload: API_BASE + "/upload-url"
};
/* ══════════════════════════════════════════════════════════════════════════ */

/* ══ ONE RENDER PER PAGE LOAD — THE INVARIANT AND ITS CHOKE POINT ═══════
   The client's rule, verbatim: "1 render per page load. when you click
   'i'm still watching' you don't render new videos, you just show more
   history."

   ONLY a /next carrying mode:"fresh" commissions a render. Archive requests
   are served from rows already rendered and cost nothing. So the entire
   budget for a page load is ONE fresh request, and it is enforced in two
   places on purpose:

     chFreshMode()  the only thing in the page that may return the string
                    'fresh'. It hands it out once and answers 'archive'
                    forever after. Every path that builds a /next body asks
                    here instead of deciding for itself.

     post()         the last door before the wire. Any /next body still
                    carrying mode:"fresh" after one has already gone out is
                    rewritten to "archive" there. Belt and braces: a future
                    edit that adds a caller, or reinstates one of the paths
                    listed below, cannot spend a second render even by
                    forgetting this rule exists.

   THE SLOT IS NEVER GIVEN BACK. Not when the viewer exhausts the library and
   starts a new lap, not on START OVER, not on the still-watching gate, and
   not on a failed request — a call that timed out may well have reached the
   server and commissioned its render already, the page has no way to tell,
   and guessing wrong spends real money. A new render needs a new page load,
   which is exactly what the rule says.

   WHAT THE VIEWER LOSES BY THIS: nothing they can see. A lap restart and
   START OVER still wipe the seen-set and still hand back the whole library
   to walk again — they just walk it out of the archive, which is what every
   film after the first was always coming from anyway. */
var chFreshBudget = 1;    /* fresh requests this page load may still hand out */
var chFreshOnWire = false; /* one has actually been sent — post()'s own guard */

function chFreshMode(){
  if(chFreshBudget <= 0) return 'archive';
  chFreshBudget--;
  return 'fresh';
}

/* The form and the photo upload are NOT governed by this. They go to /custom
   and /photo, which are different routes entirely — this budget only ever
   looks at /next — and the client's own words draw the line: "when they fill
   the form. THEIR video is displayed." A visitor deliberately asking for a
   film of their own is the product, not the channel rolling on by itself, so
   it renders when they ask and the two budgets never touch each other. */

/* Tunables, set against measured live latencies:
   /status 0.69s · /next 0.46s + buffering · /regen 7.8s · /custom 30.7s
   The gateway cuts a long render at 60s and answers with its own 504 JSON, so
   the two long budgets sit just past that on purpose — better to show the
   server's honest "the render ran long" than to abort first. */
var T_SHORT          = 15000;   // next + status
var T_REGEN          = 70000;   // regen: usually ~8s, gateway-capped at 60s
var T_CUSTOM         = 70000;   // custom: usually ~31s, gateway-capped at 60s
/* A photo render measured 32-47s end to end but always answers with a job id
   rather than a finished video: the render alone has run past the gateway's 60s
   ceiling, so the queue path carries the whole wait. These two budgets only have
   to cover the short accept call and the direct-to-S3 upload. */
var T_PHOTO          = 30000;   // /photo returns a job id in well under a second
var T_UPLOAD         = 120000;  // the browser's PUT straight to S3
/* A render can come back QUEUED instead of finished. Then we poll /job.
   Deadline: 4 minutes. A queued custom is ~30s of render behind however many
   are ahead of it; four minutes covers roughly six deep and still refuses to
   poll forever. */
var T_QUEUE          = 240000;
var JOB_POLL_EVERY   = 2000;
var JOB_SOFT_FAILS   = 4;      // transient poll blips tolerated before giving up
var EMPTY_DEADLINE   = 90000;   // how long we wait on an empty cache before erroring
var POLL_EVERY       = 3000;    // cache-status poll interval

/* ── POLL BACKOFF ───────────────────────────────────────────────────
   Every poll below is one metered n8n workflow execution, so a flat interval
   held for minutes is what turns a single forgotten browser tab into a crowd.
   On 2026-09-03 two flat pollers and one deadline-less one helped burn a whole
   month of executions in about fifteen hours.

   The shape is the same in all three places: stay FAST for the first few
   tries, while the thing being waited on plausibly just finished, then grow
   geometrically to a cap. The viewer never feels it, because the part they are
   most likely to experience is the part that stayed fast. */
var JOB_POLL_FAST    = 5;       // /job polls held at JOB_POLL_EVERY before backing off
var JOB_POLL_MAX     = 8000;    // /job ceiling — 8s against a 240s queue deadline
var STOCK_POLL_FAST  = 3;       // /status polls held at POLL_EVERY before backing off
var STOCK_POLL_MAX   = 10000;   // /status ceiling while the shelf is bare
var POLL_GROWTH      = 1.5;     // geometric factor once the fast tries are spent
/* There is no "wait for a new render" ladder any more, and no deadline for one.
   Running out of archive is a terminal END CARD now rather than a waiting
   screen, so the page stops asking instead of polling for material that only a
   new session would go and fetch. */
var VIDEO_LOAD_LIMIT = 30000;   // per-source patience before falling back / failing

/* ──────────────────────────────────────────────────────────────
   DOM
   ────────────────────────────────────────────────────────────── */
var $ = function(id){ return BMVH_ROOT.querySelector('#' + id); };
var body       = BMVH_ROOT,
    /* THE PAIR. `video` is not a fixed element any more — it is whichever of
       the two players is currently lit. Everything downstream keeps talking to
       `video` exactly as it always did and never needs to know which one that
       is; only chFastCut() below ever reassigns it. */
    videoA     = $('video'),
    videoB     = $('videoB'),
    video      = videoA,
    films      = [videoA, videoB],
    soundBtn   = $('soundBtn'),
    navBurger  = $('navBurger'),
    navDrawer  = $('navDrawer'),
    navDrawerClose = $('navDrawerClose'),
    navDrawerBackdrop = $('navDrawerBackdrop'),
    soundLabel = $('soundLabel'),
    statusEl   = $('status'),
    railFill   = $('railFill'),
    readout    = $('readout'),
    endCard    = $('endCard'),
    shareHoldCard      = $('shareHoldCard'),
    shareHoldShareBtn  = $('shareHoldShareBtn'),
    shareHoldRepeatBtn = $('shareHoldRepeatBtn'),
    shareHoldMoreBtn   = $('shareHoldMoreBtn'),
    endRewindBtn = $('endRewindBtn'),
    endAgainBtn  = $('endAgainBtn'),
    customForm = $('customForm'),
    customBtn  = $('customBtn'),
    fLocation  = $('fLocation'),
    fPeople    = $('fPeople'),
    fActivity  = $('fActivity'),
    formErr    = $('formErr'),
    makeActs   = $('makeActs'),
    makeRowProgress = $('makeRowProgress'),
    rowRailFill = $('rowRailFill'),
    rowReadout  = $('rowReadout'),
    rowStatus   = $('rowStatus'),
    photoTgl   = $('photoToggle'),
    photoWrap  = $('photoWrap'),
    photoForm  = $('photoForm'),
    photoBtn   = $('photoBtn'),
    photoInput = $('fPhoto'),
    dropZone   = $('dropZone'),
    dzTitle    = $('dzTitle'),
    photoPrev  = $('photoPreview'),
    photoThumb = $('photoThumb'),
    photoName  = $('photoName'),
    photoDims  = $('photoDims'),
    photoClear = $('photoClear'),
    photoErr   = $('photoErr'),
    seedFrame  = $('seedFrame'),
    pLocation  = $('pLocation'),
    pPeople    = $('pPeople'),
    pActivity  = $('pActivity'),
    tpIc       = $('tpIc'),
    tpIcArt    = $('tpIcArt'),
    formToggle = $('formToggle'),
    retryBtn   = $('retryBtn'),
    errMsg     = $('errMsg'),
    errDetail  = $('errDetail'),
    gateResumeBtn = $('gateResumeBtn'),
    ownHoldCard = $('ownHoldCard'),
    ownHoldContinueBtn = $('ownHoldContinueBtn'),
    ownHoldRepeatBtn = $('ownHoldRepeatBtn'),
    tpCtl = $('tpCtl'),
    tpFit = $('tpFit'),
    buyNowLink = $('buyNowLink'),
    shareBtn    = $('shareBtn'),
    shareStatus = $('shareStatus');

var REDUCED = window.matchMedia &&
              window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/* ──────────────────────────────────────────────────────────────
   DEMO MODE — ?demo=1 | ?demo=empty | ?demo=error
   Bypasses the network entirely so every state can be exercised and demoed
   before the Lambda exists. Custom deliberately runs the async job path.
   ────────────────────────────────────────────────────────────── */
var DEMO = (function(){
  try{ return new URLSearchParams(location.search).get('demo'); }
  catch(e){ return null; }
})();

/* ── DEEP LINK — ?v=<library id> ────────────────────────────────────────────
   CLIENT: "I want the link to the specific video to be what's shared ... pass
   something like DrinkBlackMarket.com/?v=1234 and then the page just starts by
   playing that video."

   READ ONCE, HERE, AT PARSE TIME — before boot(), before anything strips it
   from the address bar, and before any handler can navigate. Everything after
   this point reads DEEP_ID, never location.search, so there is exactly one
   parse of one string and no second place for the two to disagree.

   VALIDATED IN THE BROWSER, NOT JUST AT THE API. Digits only, no sign, no
   decimal point, and a length cap that matches the API's own EXCLUDE_ID_MAX.
   Anything else is dropped to null right here and the page simply opens on
   the normal channel — a share link that has been mangled in transit (a
   trailing bracket from a chat client, someone's "?v=undefined") must cost
   nothing and must never reach the network.

   THE ONE PLACE IT IS ALLOWED TO FAIL IS SILENTLY. See chDeepLink(). */
var DEEP_ID = (function(){
  try{
    var raw = new URLSearchParams(location.search).get('v');
    if(raw === null) return null;
    raw = raw.trim();
    /* isascii is not a thing in JS, so the character class does it: "٤" is a
       digit to some Unicode-aware checks and is not a library id. */
    if(!raw || raw.length > 20 || !/^[0-9]+$/.test(raw)) return null;
    return raw;
  }catch(e){ return null; }
})();

/* ── SHARED-LINK VIEW — ?hl=1 ───────────────────────────────────────────────
   CLIENT: "when the video is done playing, their options should be the share
   button, repeat button, see more button that then takes you to the website".

   THAT IS A LANDING PAGE, NOT THE CHANNEL, AND THE DIFFERENCE IS THE WHOLE
   POINT. Somebody followed a link to ONE film. When it ends, rolling straight
   into a random second film throws away the thing they came for and the
   moment they are most likely to act. So a shared-link view HOLDS on the last
   frame and offers three things. The channel does not: it auto-advances
   exactly as it always has, and none of this code runs there.

   SET ONLY BY THE SHARE LANDING SERVICE, never by a human typing a URL. The
   pre-baked page at highlights.drinkblackmarket.com/<id> sends the visitor on
   with ?v=<id>&hl=1; nothing else adds it.

   WHY IT IS PINNED TO ONE FILM ID AND NOT A SESSION-WIDE FLAG. If it were a
   bare boolean, a viewer who pressed NEXT out of the landing film would carry
   the end screen into every film after it and turn the channel into a
   dead-end. Pinning it to the id the link actually named means the hold fires
   for THAT film and nothing else: press Repeat and it fires again (same film);
   press NEXT and you are simply in the channel, behaving normally, forever. */
var SHARE_FILM_ID = (function(){
  try{
    if(!DEEP_ID) return null;            /* no film named, nothing to hold on */
    var raw = new URLSearchParams(location.search).get('hl');
    return (raw === '1') ? DEEP_ID : null;
  }catch(e){ return null; }
})();

/* THE PARAMETER COMES OFF THE ADDRESS BAR ONCE THE PAGE HAS IT.
   Decided rather than defaulted, and the reason is the refresh: this page is a
   CHANNEL. Leaving ?v= in place would make F5 replay the same film forever,
   which is the one behaviour a channel must not have, and it would also mean a
   viewer who deep-linked in could never get back to a normal random open
   without hand-editing a URL. Nothing depends on the parameter surviving —
   the share link is rebuilt from the id of whatever is ON SCREEN (see
   shareLink()), not from the address bar — so removing it costs nothing and
   the shared link the viewer copies is still the film they are watching.

   replaceState, not pushState: the deep link is where they arrived, not a
   place to go BACK to. A browser with no History API (or a page opened from
   file://, where replaceState throws a SecurityError) simply keeps the
   parameter; that is cosmetic and nothing else reads it. */
function deepLinkStripUrl(){
  if(!DEEP_ID) return;
  try{
    if(!window.history || !history.replaceState) return;
    var u = new URL(location.href);
    u.searchParams.delete('v');
    /* the shared-link marker goes with it, for the same reason: it has
       already been read into SHARE_FILM_ID, and leaving it on the address bar
       would make a refresh re-enter the landing view forever. */
    u.searchParams.delete('hl');
    history.replaceState(history.state, '', u.pathname + u.search + u.hash);
  }catch(e){}
}

/* tiny on-brand demo clip, embedded so demo mode works offline and from file:// */
var DEMO_MP4 = "data:video/mp4;base64,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";

/* ──────────────────────────────────────────────────────────────
   THE PLATE — canvas loading animation
   One idea, executed: a latent frame is written line by line, pass after
   pass, each pass at a finer resolution and with less noise, until an image
   resolves out of static. The bright head of the scan is where the machine
   is writing right now.
   ────────────────────────────────────────────────────────────── */
var Plate = (function(){
  var cv  = $('plate');
  var ctx = cv.getContext('2d', { alpha:false });
  var W = cv.width, H = cv.height;
  var img = ctx.createImageData(W, H);
  var px  = img.data;

  /* colour ramp: near-black -> deep violet -> violet -> a whisper of magenta */
  var STOPS = [
    [0.00,   5,   4,  10],
    [0.26,  18,  10,  36],
    [0.48,  46,  17,  96],
    [0.68, 107,  35, 201],
    [0.86, 169,  92, 240],
    [1.00, 240, 163, 255]
  ];
  var LUT = new Uint8Array(256 * 3);
  (function buildLUT(){
    for(var i=0;i<256;i++){
      var t = i/255, a = STOPS[0], b = STOPS[STOPS.length-1], j;
      for(j=0;j<STOPS.length-1;j++){
        if(t >= STOPS[j][0] && t <= STOPS[j+1][0]){ a = STOPS[j]; b = STOPS[j+1]; break; }
      }
      var span = (b[0]-a[0]) || 1, k = (t-a[0])/span;
      k = k*k*(3-2*k);
      LUT[i*3]   = (a[1] + (b[1]-a[1])*k)|0;
      LUT[i*3+1] = (a[2] + (b[2]-a[2])*k)|0;
      LUT[i*3+2] = (a[3] + (b[3]-a[3])*k)|0;
    }
  })();

  /* passes: coarse + pure static  ->  fine + almost clean */
  var PASSES = [
    { block:32, noise:1.00 },
    { block:16, noise:0.74 },
    { block: 8, noise:0.50 },
    { block: 4, noise:0.30 },
    { block: 2, noise:0.15 },
    { block: 1, noise:0.05 }
  ];
  var PASS_SECONDS = 2.0;   /* retuned per flow so the resolve fills the whole wait */
  var RUSH_PASS = 0.17;     /* sprint speed once the payload has landed */

  var SIN_N = 1024, SIN = new Float32Array(SIN_N);
  for(var s=0;s<SIN_N;s++) SIN[s] = Math.sin(s / SIN_N * Math.PI * 2);
  function stab(v){
    var i = (v * (SIN_N / (Math.PI*2))) | 0;
    return SIN[((i % SIN_N) + SIN_N) % SIN_N];
  }

  var seed = 0x9e3779b9 >>> 0;
  function rnd(){
    seed ^= seed << 13; seed >>>= 0;
    seed ^= seed >>> 17;
    seed ^= seed << 5;  seed >>>= 0;
    return seed / 4294967296;
  }
  /* stable per-cell hash: a block keeps its value for the whole pass, so the
     mosaic visibly REFINES between passes instead of boiling like TV static */
  var salt = 1;
  function cell(a, b, c){
    var h = (a*374761393 ^ b*668265263 ^ c*2246822519 ^ salt*3266489917) >>> 0;
    h = (h ^ (h >>> 13)) >>> 0;
    h = Math.imul(h, 1274126177) >>> 0;
    return ((h ^ (h >>> 16)) >>> 0) / 4294967296;
  }

  var rowPass = new Uint8Array(H);
  var rowVal  = new Float32Array(W);

  var raf = 0, running = false, last = 0, acc = 0, pend = 0, t = 0, rushing = 0;
  var sweep = 0, curPass = 0, startedAt = 0;
  var FRAME = 1/30;
  var c1x, c1y, c2x, c2y;

  function field(x, y){
    var dx1 = x - c1x, dy1 = y - c1y;
    var dx2 = x - c2x, dy2 = y - c2y;
    var d1 = dx1*dx1*3.4 + dy1*dy1*6.4;
    var d2 = dx2*dx2*2.6 + dy2*dy2*4.4;
    var v = 0.86/(1 + d1*5.0) + 0.46/(1 + d2*6.5);
    v += 0.155 * stab(x*6.1 + t*0.33) * stab(y*4.3 - t*0.21 + 0.6);
    v += 0.085 * stab(x*15.0 - y*9.0 + t*0.8);
    v -= 0.24 * y;
    return v;
  }

  function draw(){
    c1x = 0.62 + 0.045*stab(t*0.17);
    c1y = 0.38 + 0.030*stab(t*0.13 + 1.7);
    c2x = 0.27 + 0.050*stab(t*0.11 + 3.1);
    c2y = 0.68 + 0.026*stab(t*0.19 + 0.4);

    for(var y=0; y<H; y++){
      var p = PASSES[rowPass[y]];
      var block = p.block, nmix = p.noise;
      var by = (((y/block)|0)*block + block*0.5) / H;

      var byi = (y/block)|0;
      for(var bx=0; bx<W; bx+=block){
        var v = field(((bx + block*0.5)/W), by);
        var n = cell((bx/block)|0, byi, rowPass[y]);
        n = n*n*n * 0.92;              /* dark-biased: a black ground, rare violet sparks */
        var base = v*(1-nmix) + n*nmix;
        var end = bx + block; if(end > W) end = W;
        for(var x=bx; x<end; x++){
          rowVal[x] = base + (rnd()-0.5) * 0.05 * (0.25 + nmix);
        }
      }

      /* the write head: freshly-written rows glow and split chromatically */
      var d = sweep - y, boost = 0, chroma = 0;
      if(d >= 0 && d < 16){
        var f = 1 - d/16;
        boost = 0.50 * f * f;
        if(d < 2){ boost = 0.78; chroma = 1; }
      }

      var row = y*W*4;
      for(var xx=0; xx<W; xx++){
        var c = rowVal[xx] + boost;
        c = c < 0 ? 0 : (c > 1 ? 1 : c);
        var ig = (c*255)|0, ir = ig, ib = ig;
        if(chroma){
          var cr = rowVal[xx>0?xx-1:0] + boost;
          var cb = rowVal[xx<W-1?xx+1:W-1] + boost;
          cr = cr<0?0:(cr>1?1:cr); cb = cb<0?0:(cb>1?1:cb);
          ir = (cr*255)|0; ib = (cb*255)|0;
        }
        var o = row + xx*4;
        px[o]   = LUT[ir*3];
        px[o+1] = LUT[ig*3+1];
        px[o+2] = LUT[ib*3+2];
        px[o+3] = 255;
      }
    }
    ctx.putImageData(img, 0, 0);
  }

  function tick(now){
    if(!running) return;
    raf = requestAnimationFrame(tick);
    var dt = last ? Math.min((now - last)/1000, 0.1) : 0;
    last = now;
    acc += dt; pend += dt;
    if(acc < FRAME) return;
    acc -= FRAME;
    t += pend;

    sweep += pend * (H / (rushing ? RUSH_PASS : PASS_SECONDS));
    pend = 0;
    if(sweep >= H){
      sweep = 0;
      if(curPass < PASSES.length-1) curPass++;
    }
    var lim = sweep|0; if(lim > H-1) lim = H-1;
    for(var y=0; y<=lim; y++) rowPass[y] = curPass;

    draw();
  }

  return {
    reset: function(expectSeconds){
      /* stretch the resolve to cover the wait we actually expect: a 35s custom
         render keeps refining the whole time instead of finishing in 12s */
      var ps = (expectSeconds || 6) / PASSES.length;
      PASS_SECONDS = ps < 0.55 ? 0.55 : (ps > 6.5 ? 6.5 : ps);
      seed = (Date.now() ^ 0x9e3779b9) >>> 0;
      salt = (Date.now() & 0xffff) | 1;
      rowPass.fill(0);
      sweep = 0; curPass = 0; rushing = 0; t = Math.random()*40; acc = 0; pend = 0; last = 0;
      startedAt = Date.now();
    },
    start: function(){
      if(running) return;
      running = true;
      if(REDUCED){
        rowPass.fill(PASSES.length-1);
        sweep = -99; curPass = PASSES.length-1;
        draw();
        return;
      }
      last = 0; raf = requestAnimationFrame(tick);
    },
    stop: function(){
      running = false;
      if(raf) cancelAnimationFrame(raf);
      raf = 0;
    },
    /* re-fit the remaining resolve to a real, server-supplied ETA */
    repace: function(secondsLeft){
      if(REDUCED || rushing) return;
      var left = (PASSES.length - 1 - curPass) + (1 - sweep/H);
      if(left <= 0.05) return;               /* already resolved — let it breathe */
      var ps = secondsLeft / left;
      PASS_SECONDS = ps < 0.55 ? 0.55 : (ps > 12 ? 12 : ps);
    },
    /* Finish the resolve at speed; returns how long to hold before revealing.
       `cap` is an optional ceiling in ms, and the cold load is the one caller
       that passes one — see present(). The ceiling matters MORE now than it
       used to, not less: this hold is sized by how much of the plate is still
       unresolved, so shortening the opening hold from 5s to 2.5s left the
       plate further from the end when the film arrived and pushed this from
       ~200ms up against its own 900ms roof. That is 900ms of the client's
       3-second budget spent finishing an animation which, on a phone, the
       cold-load strip-back has hidden from view anyway. */
    rush: function(cap){
      if(REDUCED) return 120;
      rushing = 1;
      var left = (PASSES.length - 1 - curPass) + (1 - sweep/H);
      var ms = 140 + left * RUSH_PASS * 1000;
      var roof = (cap && cap > 0) ? cap : 900;
      return ms > roof ? roof : ms;
    },
    pass: function(){ return REDUCED ? PASSES.length : curPass + 1; },
    passes: function(){ return PASSES.length; }
  };
})();

/* ──────────────────────────────────────────────────────────────
   STATUS LINES — dry, a little conspiratorial
   ────────────────────────────────────────────────────────────── */
var LINES_FIRST = [
  "Cutting the plate",
  "Seeding noise · waiting for it to confess",
  "Pulling light out of nothing"
];
var LINES = [
  "Negotiating with the dark",
  "Purple is a temperature, not a colour",
  "Developing · don’t open the door",
  "Nobody else gets this one",
  "Resolving something that shouldn’t exist",
  "Eight seconds. Worth the wait.",
  "The good stuff never shows up on time",
  "Frame by frame, off the books",
  "If anyone asks, you found it",
  "Holding the shutter open"
];
var LINES_REGEN = [
  "Running it back",
  "Same prompt, different night",
  "Cutting a second pressing"
];
var LINE_EMPTY = "Shelf’s bare · pressing more right now";
/* Two different silences. EMPTY is an empty shelf — nothing exists for anyone.
   SEEN_ALL is a full shelf you have already cleared: the library is fine, you
   are simply ahead of it, and the only thing left to wait for is a new press. */
/* LINE_SEEN_ALL retired — the end of the reel is an end card now, not a line. */

/* the custom flow gets a film-slate voice, so free text can never break grammar */
function customLines(a){
  function clip(s){ s = String(s||'').replace(/\s+/g,' ').trim();
                    return s.length > 42 ? s.slice(0,41) + '…' : s; }
  a = a || {};
  var cycle = [];
  /* only the answered fields get narrated — a blank one would read
     "Setting · " with nothing after it */
  if(a.location) cycle.push("Setting · " + clip(a.location));
  if(a.people)   cycle.push("Cast · "    + clip(a.people));
  if(a.activity) cycle.push("Action · "  + clip(a.activity));
  return {
    seed: ["Writing your scene", "Loading the slate", "Casting the shot"],
    cycle: cycle.concat([
      "Scoring it in the dark",
      "This take does not get cached",
      "Purple is a temperature, not a colour",
      "Print it once, then burn the negative"
    ])
  };
}

/* queue copy — same register as the rest, just with honest numbers in it */
var ORDINALS = ['','Next','Second','Third','Fourth','Fifth','Sixth','Seventh',
                'Eighth','Ninth','Tenth'];
function etaWords(sec){
  sec = Math.max(0, Math.round(sec || 0));
  if(!sec)      return '';
  if(sec < 15)  return 'seconds out';
  if(sec < 45)  return 'about ' + (Math.round(sec/15)*15) + ' seconds';
  if(sec < 90)  return 'about a minute';
  return 'about ' + Math.round(sec/60) + ' minutes';
}
function queueLine(pos, eta){
  var head = pos <= 0 ? 'Holding in line'
           : (ORDINALS[pos] ? ORDINALS[pos] + ' in line' : '#' + pos + ' in line');
  var tail = etaWords(eta);
  return tail ? head + ' · ' + tail : head;
}

var lineTimer = 0, lineIdx = 0, linePinned = null, lineSet = LINES;

/* mirrored into #rowStatus too — a live region at the SAME cadence as this
   one already runs at (a few seconds between lines, never per-tick), so the
   row's progress display announces exactly as often as the copy zone's own
   status line always has, and no more. */
function setStatus(text){
  if(rowStatus) rowStatus.textContent = text;
  if(REDUCED){ statusEl.textContent = text; return; }
  statusEl.classList.add('swap');
  setTimeout(function(){
    statusEl.textContent = text;
    statusEl.classList.remove('swap');
  }, 320);
}
function startLines(seedList, cycleList){
  stopLines();
  lineSet = cycleList || LINES;
  lineIdx = Math.floor(Math.random()*lineSet.length);
  statusEl.classList.remove('swap');
  statusEl.textContent = seedList[Math.floor(Math.random()*seedList.length)];
  lineTimer = setInterval(function(){
    if(linePinned) return;
    setStatus(lineSet[lineIdx % lineSet.length]);
    lineIdx++;
  }, 3400);
}
function pinLine(text){
  if(linePinned === text) return;   /* don't re-fade an unchanged line */
  linePinned = text; setStatus(text);
}
function unpinLine(){ linePinned = null; }
function resumeLines(){
  if(!linePinned) return;
  linePinned = null;
  setStatus(lineSet[lineIdx++ % lineSet.length]);
}
function stopLines(){ if(lineTimer){ clearInterval(lineTimer); lineTimer = 0; } linePinned = null; }

/* ──────────────────────────────────────────────────────────────
   HUD
   ────────────────────────────────────────────────────────────── */
var hudTimer = 0, hudStart = 0, hudScale = 11, hudNote = '';

function pad2(n){ return n<10 ? '0'+n : ''+n; }
/* setRail/setReadout — the SAME numbers this HUD has always computed, just
   painted into both the copy-zone HUD and the make-row's progress mirror
   (#rowRailFill/#rowReadout) in one place, so the two can never drift out of
   sync and nothing here recomputes progress a second time. */
function setRail(v){ railFill.style.width = v; if(rowRailFill) rowRailFill.style.width = v; }
function setReadout(v){ readout.textContent = v; if(rowReadout) rowReadout.textContent = v; }
function startHud(expectSeconds){
  hudScale = Math.max(2, (expectSeconds || 6) / 2);
  hudNote = '';
  hudStart = Date.now();
  setRail('2%');
  clearInterval(hudTimer);
  hudTimer = setInterval(function(){
    var s = (Date.now()-hudStart)/1000;
    /* asymptotic: feels like real progress and never lies about being done */
    var pct = (1 - Math.exp(-s/hudScale)) * 94;
    setRail(pct.toFixed(1) + '%');
    setReadout(
      pad2(Math.floor(s/60)) + ':' + pad2(Math.floor(s%60)) +
      '  ·  1344×768  ·  8S  ·  ' +
      (hudNote || ('PASS ' + Plate.pass() + '/' + Plate.passes())));
  }, 220);
}
function finishHud(){
  clearInterval(hudTimer); hudTimer = 0;
  setRail('100%');
}

/* ──────────────────────────────────────────────────────────────
   STATE
   ────────────────────────────────────────────────────────────── */
/* current.own — true only while the film ON SCREEN is this visitor's own
   commissioned render (question form or photo upload), see adopt() below.
   This is the ONLY signal chOnEnded() reads to decide whether the channel
   holds instead of auto-advancing, and it is deliberately narrower than
   .oneOff: a history replay of a past custom film is still .oneOff-shaped
   but must NOT re-trigger the hold, so 'history' explicitly clears .own
   while leaving .oneOff carrying forward as it always did. */
/* .jobId — the handle of the render that produced a ONE-OFF film, kept so
   REPRESS can name it to the API. It replaces the prompt this record used to
   carry: the prompt is the product, it never leaves the server, and this page
   never receives it. A re-press sends a REFERENCE (.id for a library film,
   .jobId for a one-off) and the API looks the text up itself. */
var current = { id:'', jobId:'', product:'', videoUrl:'', s3Url:'', oneOff:false, own:false, source:'' };
var busy = false;

function setState(s){
  body.setAttribute('data-state', s);
  /* CLIENT BUG FIX: beginRequest() calls setBusy(true) — which itself calls
     chRender() — BEFORE enterLoading() gets here to flip data-state to
     "loading". chRender() reads data-state at the top of its own run, so
     without this second call PLAY kept computing its disabled state off
     the stale, pre-render value and stayed lit (not clickable in practice —
     chTogglePlay() re-checks data-state itself — but visibly wrong) for the
     length of a custom/photo render. chRender() no-ops safely if the
     transport isn't wired up yet (see its own `if(!tpBack) return` guard),
     so calling it on every state change here is always safe. */
  chRender();
}
function setBusy(on){
  busy = on;
  customBtn.disabled = on;
  /* the three questions are on the page now, not behind a modal that hid
     itself during a render — so they disable with everything else */
  fLocation.disabled = on;
  fPeople.disabled   = on;
  fActivity.disabled = on;
  if(photoBtn) photoBtn.disabled = on;
  if(photoTgl) photoTgl.disabled = on;
  chRender();   /* the transport tells the truth about busy too */
}
/* Kill the outgoing video before any new request. Pausing alone leaves the
   element buffering an 8MB clip it will never show, so the source goes too —
   that is the only way playback and its AUDIO stop and cannot resume. */
function stopPlayback(){
  detachLiveErr();
  try{ video.pause(); }catch(e){}
  video.removeAttribute('src');
  try{ video.load(); }catch(e){}
}

/* every flow — boot, regen, custom — starts here, so the stop can never
   regress on one path and not the others */
function beginRequest(seedList, cycleList, expectSeconds){
  setBusy(true);
  stopPlayback();
  enterLoading(seedList, cycleList, expectSeconds);
}

function enterLoading(seedList, cycleList, expectSeconds){
  setState('loading');
  Plate.reset(expectSeconds); Plate.start();
  startLines(seedList || LINES_FIRST, cycleList || LINES);
  startHud(expectSeconds);
}
function leaveLoading(){
  hudNote = '';
  finishHud();
  stopLines();
  Plate.stop();
}

/* ──────────────────────────────────────────────────────────────
   ERRORS
   ────────────────────────────────────────────────────────────── */
/* the backend always answers JSON and always carries a code on failure */
var CODE_MSG = {
  timeout:        'The render ran long and the line got cut. It usually lands on a second try.',
  missing_prompt: 'We lost the prompt for this one. Pull another off the shelf and start again.',
  bad_body:       'That request came out malformed. Try again.',
  unknown_route:  'That door is not there any more. Reload the page.',
  render_failed:  'The render fell over on the far end. It usually takes on a second run.',
  queue_timeout:  'The queue never got round to us. It is busy right now — try again in a minute.',
  /* photo-flow refusals. Every one of these is decided before a render is paid
     for, so each has to say plainly what to do differently. */
  bad_content_type:         'That file is not a photo we can read. Use a JPG, PNG or WEBP. (HEIC will not work — save it as a JPG.)',
  file_too_large:           'That photo is over 30MB. Pick a smaller one.',
  unreadable_image:         'That file did not open as a photo. Try a different one.',
  image_too_small:          'That photo is too small to build from. Each side needs to be at least 256px.',
  image_too_large:          'That photo is too big to build from. Each side has to be 5760px or under.',
  image_aspect_ratio_error: 'That photo is the wrong shape — too wide or too tall to become a video. A normal phone photo works.',
  image_size_error:         'That photo is the wrong size to build a video from. A normal phone photo works.',
  safety_rejected:          'That photo could not be used. Try a different one.',
  photo_not_found:          'That photo went missing before we could use it. Upload it again.',
  photo_unreadable:         'That photo could not be read back. Upload it again.',
  bad_image_url:            'That upload did not stick. Choose the photo again.',
  bad_photo:                'That upload did not stick. Choose the photo again.'
};
function msgForCode(code, serverText){
  if(code && CODE_MSG[code]) return CODE_MSG[code];
  if(code === 'missing_fields') return 'Give us one thing to go on — any one of the three will do.';
  if(serverText) return String(serverText);
  return 'The server turned us away.';
}

function AppError(msg, detail){ this.name='AppError'; this.message=msg; this.detail=detail||''; }
AppError.prototype = Object.create(Error.prototype);

/* THE END OF THE REEL. Thrown when /next answers `exhausted`: the library has
   films and this viewer has been shown every one of them this session.
   Deliberately NOT an AppError — nothing failed, so it must never reach the
   failure panel. Every caller that can receive it shows the end card instead. */
function EndOfReel(){ this.name='EndOfReel'; this.message='end of reel'; }
EndOfReel.prototype = Object.create(Error.prototype);
function isEndOfReel(e){ return !!e && e.name === 'EndOfReel'; }

function describe(err){
  if(!err) return { msg:'Something went wrong on the way here.', detail:'' };
  if(err.name === 'AbortError'){
    return { msg:'The render took longer than we were willing to wait. It might still land — try again.',
             detail:'TIMEOUT' };
  }
  if(err.name === 'AppError'){
    return { msg: err.message, detail: err.detail || '' };
  }
  if(err instanceof TypeError){
    return { msg:'Couldn’t reach the supply. Check your connection and try again.',
             detail:'NETWORK / CORS — ' + (err.message||'fetch failed') };
  }
  return { msg:'Something went wrong on the way here.', detail:(err.message||String(err)).slice(0,240) };
}

/* ── THE HERO HOLD ────────────────────────────────────────────────────────
   The photograph behind everything is the bottle we are selling, and on a
   cold load it used to be on screen for however long the first fetch happened
   to take — which in the good case is under a second. It now stays for a
   MINIMUM of HERO_HOLD_MS (see below).

   A FLOOR, NOT A DELAY, AND NOT A SECOND REQUEST. The /next call goes out at
   exactly the same moment it always did and there is still exactly one of
   them per page load; what waits is the DISPLAY. If the film is ready early
   it is held to the floor and cut in there. If it takes eight seconds, it
   cuts in at eight with nothing added. Only the first presentation of the
   session is affected — every later cut runs through the preloader untouched.

   A failed first fetch does not go through here at all (the hold sits on the
   success path only), so an error still lands on the photograph plus the
   error card immediately rather than after the opening hold.

   IT IS INTERRUPTIBLE. Anyone who tells us what they want should not then be
   made to wait out a brand moment. The release is wired into
   chNoteInteraction(), which every deliberate control already funnels
   through. In practice that means the KEYBOARD during the hold — arrow keys,
   space, R — because the transport buttons and the sound pill are both
   disabled by the page's own loading state while a fetch is out, exactly as
   they always have been. Once they are live again the same release fires
   from them too. */
/* 5,000ms, MEASURED FROM THE MOMENT THE TAB OPENED.
   CLIENT, LATEST: "the bottle image should show for 5 seconds instead of 3
   before starting the first video." That is the only change — the floor was
   1,200ms and is now 5,000ms; the 400ms dissolve after it is untouched.

   WHAT HE WAS ACTUALLY TIMING. At 1,200 the floor had long expired by the
   time the film was playable, so the ~3s he counted was the BUFFERING, not
   this number. Raising the floor to 5,000 puts the cut back under this
   number's control on a normal connection. It changes nothing about the gate
   underneath it — see STILL A FLOOR at the end of this comment.

   The history that produced the shape of this thing follows, unchanged.
   CLIENT, THIRD PASS: "the transition is still too long from bottle to
   video." Two numbers had already been cut (5,000 → 2,500 hold, 3,000 → 500
   dissolve) and it was still wrong, so this time the opening was TIMED on the
   live page before anything was touched. What the clock said:

     fast connection   hero up 456ms · /next answered 817ms · then TWO FULL
                       SECONDS OF NOTHING while the hold ran with the network
                       idle · film's bytes not even requested until 2,809ms ·
                       playable 3,444ms · full opacity 4,229ms.
     throttled         same shape, worse: 2,020ms of idle hold, then 3,060ms
                       of buffering stacked on the far side of it, 10,906ms to
                       full opacity.

   So the dissolve was never the problem, and neither, mostly, was the length
   of the hold. The problem was the ORDER: the hold and the download ran one
   after the other when they should have run at the same time. That is fixed
   in present() — it now loads the film first and waits out whatever is left
   of this floor afterwards, so the bytes come down BEHIND the bottle. Two
   consequences worth stating plainly: on a fast line the buffering is now
   free, and on a slow line this floor costs nothing at all because it has
   long since expired by the time the film is ready.

   TWO CHANGES HERE, AND ONLY THE FIRST IS THE CLIENT'S NUMBER:
   1. 2,500 → 1,200, and later 1,200 → 5,000 at the client's request (see the
      top of this comment). At 1,200, with the dissolve at 400ms, that was a
      ~1.6s bottle-to-film opening on a normal connection; at 5,000 it is the
      ~5s stare he asked for, followed by the same 400ms dissolve.
   2. The clock now starts at NAVIGATION, not at the moment this script is
      evaluated. On a fast line those are ~300ms apart and it barely matters.
      On a phone they are four and a half seconds apart — this page is one
      430KB document and the closing script cannot run until all of it has
      arrived — and anchoring to script-eval meant a visitor who had already
      been staring at the bottle for four seconds was then made to stare at it
      for 2.5 seconds more. The floor is meant to guarantee the brand a
      minimum time ON SCREEN, so it is measured from when the screen started.

   STILL A FLOOR, NOT A DELAY. heroHold() subtracts the time already spent, so
   a film that takes 4s to arrive adds NOTHING — it cuts in the moment it is
   ready. Only a film ready sooner than 5s after the tab opened waits, and
   only for the remainder. Changing the number cannot make a slow load slower:
   raising it can only lengthen the stare on a load that was ALREADY quicker
   than the floor, and it can never cut to a film that is not yet playable —
   present() runs this gate on the FAR SIDE of loadVideo(), which does not
   resolve until readyState is HAVE_FUTURE_DATA. */
var HERO_HOLD_MS  = 5000;
/* Date.now() minus performance.now() is the instant the navigation began,
   expressed on the same clock the arithmetic below uses. Guarded because the
   floor must degrade to the old script-eval anchor, never to NaN. */
var heroHoldT0    = (function(){
  try{
    if(window.performance && typeof performance.now === 'function'){
      return Date.now() - performance.now();
    }
  }catch(e){}
  return Date.now();
})();
var heroHoldUsed  = false;
var heroHoldSkipped = false;
var heroHoldRelease = null;
function heroHoldSkip(){
  /* THE FLAG, NOT JUST THE RESOLVER. The hold is now claimed AFTER the film
     has buffered rather than before, so a keypress can easily land while the
     download is still in flight — earlier than heroHold() has ever been
     called, when there is no promise to release yet. Without this flag that
     press would be swallowed and the viewer would be made to sit through a
     brand moment they had already dismissed. Recording it means the hold is
     waived whenever it is eventually asked for. */
  heroHoldSkipped = true;
  var r = heroHoldRelease;
  heroHoldRelease = null;
  if(r) r();
}
function heroHold(){
  if(heroHoldUsed || heroHoldSkipped) return Promise.resolve();
  heroHoldUsed = true;
  var left = HERO_HOLD_MS - (Date.now() - heroHoldT0);
  if(left <= 0) return Promise.resolve();
  return new Promise(function(res){
    heroHoldRelease = res;
    window.setTimeout(heroHoldSkip, left);
  });
}

var retryAction = boot;
function fail(err, retryFn){
  leaveLoading();
  var d = describe(err);
  errMsg.textContent = d.msg;
  errDetail.textContent = d.detail || '';
  errDetail.style.display = d.detail ? '' : 'none';
  retryAction = retryFn || boot;
  setStatus('Dead air');
  setReadout('NO SIGNAL');
  setState('error');
}

/* ──────────────────────────────────────────────────────────────
   NETWORK
   One HTTP call per action — the backend is synchronous, every route returns
   its finished payload on the first response. Hard AbortController timeout,
   JSON parsed before status is judged so the server's own error code can pick
   the message the user reads.
   ────────────────────────────────────────────────────────────── */
function sleep(ms){ return new Promise(function(r){ setTimeout(r, ms); }); }

function post(url, bodyObj, timeoutMs){
  /* THE INVARIANT'S LAST GATE — see chFreshMode. Every request in the page
     funnels through here, so this is the one place a second "fresh" cannot
     get past, whoever built the body and for whatever reason. The first one
     through is let by; every later one is rewritten to "archive", which is
     served from rows already rendered and commissions nothing. Deliberately
     ahead of the DEMO branch so the offline demo obeys the same rule. */
  if(url === API.next && bodyObj && bodyObj.mode === 'fresh'){
    if(chFreshOnWire){
      bodyObj = { exclude: bodyObj.exclude, mode: 'archive' };
      if(window.console && console.warn){
        console.warn('[bm] one render per page load: a second fresh /next was downgraded to archive');
      }
    } else {
      chFreshOnWire = true;
      chFreshBudget = 0;
    }
  }
  if(DEMO) return demoPost(url, bodyObj);
  var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
  var timedOut = false;
  var timer = setTimeout(function(){ timedOut = true; if(ctrl) ctrl.abort(); }, timeoutMs);
  return fetch(url, {
    method:'POST',
    headers:{ 'Content-Type':'application/json' },
    body: JSON.stringify(bodyObj || {}),
    cache:'no-store',
    mode:'cors',
    signal: ctrl ? ctrl.signal : undefined
  })
    .then(function(res){
      return res.text().then(function(text){ return { res:res, text:text }; });
    })
    .then(function(r){
      clearTimeout(timer);
      var data = null;
      try{ data = JSON.parse(r.text); }catch(e){}
      if(!data || typeof data !== 'object' || Array.isArray(data)){
        throw new AppError(
          r.res.ok ? 'The response came back scrambled.' : 'The server turned us away.',
          (r.res.ok ? 'BAD JSON — ' : 'HTTP ' + r.res.status + ' — ') + (r.text||'').slice(0,160));
      }
      if(!r.res.ok){
        /* the Lambda migration added real rate limiting on /custom, /photo
           and /regen (1 per 30s) — a generic "server turned us away" reads
           as a hard failure when it is really just "wait a beat", so this
           gets its own honest line through the SAME error card rather than
           a new UI. Retry-After is read defensively: CORS only exposes it if
           the API opts in, so a missing/blocked header falls back to a
           sane default instead of showing a broken "in NaNs" message. */
        if(r.res.status === 429){
          var retryAfter = parseInt(r.res.headers.get('Retry-After'), 10);
          var waitFor = (retryAfter > 0) ? retryAfter : 30;
          throw new AppError(
            'That came back to back — give it about ' + waitFor + 's and try again.',
            'HTTP 429' + (data.code ? ' · ' + data.code : ''));
        }
        throw new AppError(msgForCode(data.code, data.error),
          'HTTP ' + r.res.status + (data.code ? ' · ' + data.code : ''));
      }
      return data;
    })
    .catch(function(e){
      clearTimeout(timer);
      if(timedOut){
        throw new AppError(
          'The render took longer than we were willing to wait. It might still land — try again.',
          'TIMEOUT after ' + Math.round(timeoutMs/1000) + 's');
      }
      throw e;
    });
}

/* ──────────────────────────────────────────────────────────────
   QUEUE
   Any route may answer {ok:true, queued:true, jobId, position, etaSeconds}
   instead of a finished render — the render queue exists to keep fal from
   tripping its concurrency limit. When that happens we poll /job until it
   says done or failed. Written against the flag, not the endpoint, so a
   queued /next behaves exactly like a queued /custom.
   ────────────────────────────────────────────────────────────── */
/* `q` is a mutable {quiet:bool} carried down the whole call. A prefetch that
   runs BEHIND a playing film must not touch the status line or the plate —
   but the instant that same in-flight call becomes the thing the viewer is
   waiting on, the break flips q.quiet to false and it starts narrating.
   Callers that pass nothing behave exactly as they always did. */
function showQueue(d, q){
  if(q && q.quiet) return;
  var pos = Number(d.position) || 0;
  var eta = Number(d.etaSeconds) || 0;
  var running = d.status === 'running';

  if(running){
    /* off the queue and on the machine — hand the voice back to the brand lines */
    resumeLines();
    hudNote = 'RENDERING' + (eta ? ' · ETA ' + Math.round(eta) + 'S' : '');
  } else {
    pinLine(queueLine(pos, eta));
    hudNote = 'QUEUE' + (pos > 0 ? ' ' + pos : '') + (eta ? ' · ETA ' + Math.round(eta) + 'S' : '');
  }
  /* the one thing the animation could never know before: how long this will take */
  if(eta) Plate.repace(eta);
}

function pollJob(jobId, firstResponse, q){
  var deadline = Date.now() + T_QUEUE;
  var tries = 0;
  showQueue(firstResponse, q);

  function step(softFails){
    if(Date.now() > deadline){
      throw new AppError(CODE_MSG.queue_timeout,
                         'QUEUE TIMEOUT after ' + Math.round(T_QUEUE/1000) + 's · ' + jobId);
    }
    /* Fast while the render plausibly just landed, then geometric to a cap.
       The first JOB_POLL_FAST tries stay at 2s, so a quick job is still seen
       quickly; a job sitting behind the queue drain gets checked every 8s
       instead of every 2s — a quarter of the executions, for a wait the viewer
       has already been told is minutes long. */
    tries++;
    var wait = Math.min(
      JOB_POLL_MAX,
      JOB_POLL_EVERY * Math.pow(POLL_GROWTH, Math.max(0, tries - JOB_POLL_FAST)));
    return sleep(wait).then(function(){
      return post(API.job, { jobId: jobId }, T_SHORT).then(
        function(d){
          if(d.status === 'failed' || d.ok === false){
            throw new AppError(msgForCode(d.code, d.error),
                               'JOB FAILED · ' + (d.code || jobId));
          }
          if(d.status === 'done'){
            if(!(q && q.quiet)){ hudNote = ''; unpinLine(); }
            return d;
          }
          showQueue(d, q);
          return step(0);
        },
        function(e){
          if(e.name === 'AppError' && /JOB FAILED|QUEUE TIMEOUT/.test(e.detail||'')) throw e;
          if((softFails||0) >= JOB_SOFT_FAILS) throw e;   /* a few blips are survivable */
          return step((softFails||0) + 1);
        }
      );
    });
  }
  return step(0);
}

/* one call, then the queue path if the server chose it */
function submit(url, bodyObj, timeoutMs, q){
  return post(url, bodyObj, timeoutMs).then(function(data){
    if(data && data.queued && data.jobId) return pollJob(data.jobId, data, q);
    return data;
  });
}

/* next, with the empty-cache poll loop.

   THE LIBRARY IS SHARED, "SEEN" IS NOT. Every film ever pressed stays in the
   library for good; what changes per person is which ones they have already
   watched. The API has no idea who is calling — no cookie, no id, nothing — so
   the browser carries that list itself and sends it up, and the server picks
   at random from whatever is left. Someone else watching a film does not take
   it away from you, and a film you have watched is still new to them. */
function getNext(q){
  var deadline = Date.now() + EMPTY_DEADLINE;
  /* THE LOOP GUARD. Scoped to this one getNext() call, not a module-level
     flag, so it cannot bleed between an exhausted boot() call and an
     unrelated background prefetch running at the same time. Exhaustion is
     allowed to trigger exactly one wipe-and-retry. If the archive is STILL
     exhausted immediately after that (exclude was just cleared to nothing
     and the server said exhausted anyway) the library itself has no eligible
     stock at all — every video muted, or a backend fault — and retrying
     again would hammer the server forever. That second case falls through to
     the ordinary AppError path below instead of recursing again. */
  var resetTried = false;

  function attempt(){
    /* WHICH TIER TO ASK FOR IS NOT THIS FUNCTION'S DECISION. It asks the one
       thing allowed to answer, which grants "fresh" once per page load and
       "archive" every other time — see chFreshMode. */
    return submit(API.next, {
      exclude: chSeenList(),
      mode: chFreshMode()
    }, T_SHORT, q).then(function(data){
      /* A PLAYABLE FILM IS EITHER URL, NOT SPECIFICALLY videoUrl.
         The API hands back two copies of the same film: videoUrl (the
         renderer's own file) and s3Url (our mirror of it). Some library rows
         only ever got the mirror — the renderer's signed URL was never
         recorded — and this check used to read those as a broken response and
         drop the whole page into THE LINE WENT DEAD, even though it had just
         been handed a perfectly playable file and the player below already
         falls back to it (see the source list in present()). Ten of the
         library's sixty-one servable rows are in that state today, so roughly
         one page load in six died on a film that was fine.
         The row data is a backend matter and is not this page's to repair;
         refusing to play a film we were given is this page's bug. */
      if(data.ok && (data.videoUrl || data.s3Url)){
        if(!(q && q.quiet)) unpinLine();
        return data;
      }
      if(data.ok){
        throw new AppError('The shelf handed back an empty box.', 'MISSING videoUrl');
      }
      /* THE END OF THE REEL — a different thing from an empty shelf, and it must
         not share the empty branch. `empty` means the shelf is bare for
         everybody, and waiting for stock can actually be satisfied. This means
         the shelf is full and THIS viewer has taken everything off it, which
         no amount of waiting fixes — until the client's own decision below.

         THE CLIENT'S OWN CALL: "when they've seen all the videos, it should
         just clear their appdata and start over. still history videos."
         So this is not shown as a dead end (the old end card is what used to
         sit here — see EndOfReel/isEndOfReel, now unreachable through this
         path). Wipe the seen-list and retry, and the whole library is
         eligible again because nothing is excluded any more.

         WHAT THE RETRY DOES NOT DO IS BUY A RENDER. It used to hand the
         one-fresh-per-load slot back, so every lap cost another render —
         which is precisely the behaviour the client ruled out: "the only way
         a new video is to be rendered via n8n call is on page load." The lap
         now reruns entirely off the archive: same full lap for the viewer,
         same no-dead-end, no spend.

         Guarded to one retry per getNext() call — see resetTried above — so
         a retry that itself comes back exhausted (the library has no
         eligible stock at all: everything muted, or a backend fault) falls
         through to the ordinary AppError path instead of wiping forever. */
      if(data.exhausted){
        if(!resetTried){
          resetTried = true;
          chSeenReset();
          /* NO fresh slot is handed back here. The lap restart is not a new
             page load, so under the one-render-per-load rule it buys nothing:
             chFreshMode() answers "archive" and the whole library — every
             film already rendered — becomes eligible again the moment the
             seen-set is empty. The viewer still gets a full new lap and still
             never meets a dead end; it just costs nothing. */
          return attempt();
        }
        throw new AppError(
          'The library looks empty — nothing eligible came back even after a reset.',
          'EXHAUSTED_AFTER_RESET');
      }
      if(data.empty){
        if(!(q && q.quiet)) pinLine(LINE_EMPTY);
        return waitForStock().then(attempt);
      }
      throw new AppError(msgForCode(data.code, data.error),
                         'ok:false' + (data.code ? ' · ' + data.code : ''));
    }, function(err){
      /* THE SLOT IS NOT HANDED BACK. A rejected call is not proof the server
         never saw it — a timeout, an aborted fetch or a dropped response can
         all follow a request that arrived and commissioned its render. The
         page cannot tell those apart from a request that never left, and the
         cheap guess is the wrong one. Worst case the load runs entirely off
         the archive, which is a full channel that cost nothing. */
      throw err;
    });
  }

  var stockTries = 0;
  function waitForStock(){
    if(Date.now() > deadline){
      throw new AppError(
        'Nothing finished rendering in time. The queue is backed up — give it a minute.',
        'CACHE EMPTY for ' + Math.round(EMPTY_DEADLINE/1000) + 's');
    }
    /* Same ladder as /job. The first STOCK_POLL_FAST tries stay at 3s, so a
       render landing in the first ten seconds is still caught at once; after
       that it grows to a 10s ceiling. Across the 90s deadline that is about
       thirteen /status calls instead of thirty. */
    stockTries++;
    var wait = Math.min(
      STOCK_POLL_MAX,
      POLL_EVERY * Math.pow(POLL_GROWTH, Math.max(0, stockTries - STOCK_POLL_FAST)));
    return sleep(wait).then(function(){
      return post(API.status, {}, T_SHORT).then(
        function(st){
          if(st && st.ok && Number(st.ready) > 0) return true;
          return waitForStock();
        },
        function(){ return waitForStock(); }   /* transient status blips are survivable */
      );
    });
  }

  return attempt();
}

/* ──────────────────────────────────────────────────────────────
   VIDEO
   ────────────────────────────────────────────────────────────── */
/* The late-failure watcher is bound to whichever player was live when it was
   installed. `video` can now change under it (chFastCut swaps the pair), so the
   ELEMENT it was attached to is remembered alongside the handler — removing it
   from `video` after a swap would detach nothing and leak a listener onto a
   player that is about to be reused. */
var liveErrHandler = null, liveErrEl = null;
function detachLiveErr(){
  if(liveErrHandler && liveErrEl){
    try{ liveErrEl.removeEventListener('error', liveErrHandler); }catch(e){}
  }
  liveErrHandler = null; liveErrEl = null;
}

function loadVideo(sources){
  sources = sources.filter(function(u){ return typeof u === 'string' && u; });
  if(!sources.length) return Promise.reject(new AppError('No video URL came back.','MISSING videoUrl'));

  detachLiveErr();

  /* PINNED. `video` can be swapped out from under a load in flight when the
     channel takes the seamless cut (chFastCut), and a load that kept following
     `video` would then start writing its source into the player that is on
     screen. It loads into the element it STARTED with; if that element has
     since been retired, present()'s own presentGen ticket discards the result. */
  var el = video;

  return new Promise(function(resolve, reject){
    var i = 0, guard = 0, onOk = null, onErr = null, lastDetail = '';

    function clean(){
      clearTimeout(guard);
      if(onOk){ el.removeEventListener('canplay', onOk);
                el.removeEventListener('loadeddata', onOk); }
      if(onErr) el.removeEventListener('error', onErr);
    }
    function next(reason){
      clean();
      if(reason) lastDetail = reason;
      if(i >= sources.length){
        reject(new AppError('The film came back damaged — it wouldn’t play.',
                            lastDetail || 'VIDEO LOAD FAILED'));
        return;
      }
      var src = sources[i++];
      onOk = function(){
        if(el.readyState < 3) return;   /* need HAVE_FUTURE_DATA, not just one frame */
        clean(); resolve(src);
      };
      onErr = function(){
        if(!el.getAttribute('src')) return;   /* stale empty-src event from stopPlayback */
        var code = el.error ? el.error.code : '?';
        next('MEDIA ERROR ' + code + ' — ' + String(src).slice(0,90));
      };
      el.addEventListener('canplay', onOk);
      el.addEventListener('loadeddata', onOk);
      el.addEventListener('error', onErr);
      guard = setTimeout(function(){ next('STALLED — ' + String(src).slice(0,90)); }, VIDEO_LOAD_LIMIT);
      el.src = src;
      try{ el.load(); }catch(e){}
    }
    next('');
  });
}

function watchVideoForLateFailure(){
  detachLiveErr();
  var el = video;
  liveErrHandler = function(){
    if(el !== video) return;          /* a retired player, not the live one */
    if(body.getAttribute('data-state') !== 'playing') return;
    var code = video.error ? video.error.code : '?';
    fail(new AppError('The film gave out mid-reel.', 'MEDIA ERROR ' + code), boot);
  };
  liveErrEl = el;
  el.addEventListener('error', liveErrHandler);
}

function play(){
  /* THE ONE DOOR INTO PLAYBACK, AND THEREFORE WHERE "IS ANYBODY WATCHING"
     BELONGS. The presence gate (see chApplyPresence) only runs on an EVENT —
     the tab being hidden, or the channel crossing the viewport midline. A
     visitor who scrolls away while the channel is mid-load or mid-break gets
     no further event, so without this the film that lands afterwards would
     start playing to an empty screen, finish, and roll the channel onward
     indefinitely. Refusing to start is done HERE rather than by pausing after
     the fact because pausing a play() already in flight rejects its promise
     as an AbortError, which this function's own catch below would then
     mistake for a blocked autoplay and mislabel the sound button.
     The flag is set so the ordinary resume path treats this exactly like any
     other film WE stopped, and starts it when the visitor comes back. */
  if(!chPresent()){ videoAutoPausedByPresence = true; return; }
  video.muted = !soundOn;
  var p = video.play();
  if(!p || !p.catch) return;
  p.catch(function(){
    if(soundOn){
      /* the browser refused audible autoplay — drop to muted and say so,
         rather than leaving a video that never starts */
      setSound(false);
      var q = video.play();
      if(q && q.catch) q.catch(function(){ soundLabel.textContent = 'Tap to play'; });
      return;
    }
    soundLabel.textContent = 'Tap to play';
    soundBtn.setAttribute('aria-label', 'Tap to play');
    soundBtn.title = 'Tap to play';
    soundBtn.classList.remove('is-on');
  });
}

/* ──────────────────────────────────────────────────────────────
   SOUND
   ────────────────────────────────────────────────────────────── */
var soundOn = false;   /* the user's audio preference, kept across video swaps */
function setSound(on){
  soundOn = on;
  video.muted = !on;
  soundBtn.classList.toggle('is-on', on);
  soundBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
  soundLabel.textContent = on ? 'Sound on' : 'Sound off · tap for audio';
  /* the button is a bare glyph now, so the state has to be stated in words
     somewhere a screen reader and a hovering mouse can both reach it */
  var say = on ? 'Sound on · tap to mute' : 'Sound off · tap for audio';
  soundBtn.setAttribute('aria-label', say);
  soundBtn.title = say + '  ·  m';
}
soundBtn.addEventListener('click', function(){
  heroHoldSkip();   /* a press is a press — end the opening hold early */
  setSound(!soundOn);
  if(video.paused) play();
});

/* ── SHARE ──
   SHARES A DEEP LINK TO THE FILM ON SCREEN — this page's URL with ?v=<id> on
   it, which the page reads back on load and opens on. See shareLink() for how
   the origin is derived (never hardcoded) and chDeepLink() for the other end.
   It is still a link to THIS PAGE, deliberately: a raw video URL would land
   the recipient on a bare MP4 with no storefront and no way to buy anything,
   and the renderer's own URL expires on top of that. The film travels as a
   parameter, not as the destination.
   The FILE itself is offered too, separately — see THE FILM AS A FILE below:
   "Download this video" saves the watermarked MP4, and "Send the video" hands
   it to the OS share sheet on the phones that can take one.
   navigator.share() is the primary path (native share sheet, whatever the
   OS offers); without it, the clipboard API; without THAT (an old browser
   with neither), a hidden-textarea execCommand('copy') as a last resort —
   still better than a dead button. A user backing out of the native share
   sheet rejects that promise, which is not a failure worth reporting. */
function shareFlash(msg){
  if(shareStatus) shareStatus.textContent = msg;
  if(shareBtn){
    shareBtn.classList.add('is-copied');
    setTimeout(function(){ shareBtn.classList.remove('is-copied'); }, 1600);
  }
}
function shareFallbackCopy(url){
  if(navigator.clipboard && navigator.clipboard.writeText){
    navigator.clipboard.writeText(url)
      .then(function(){ shareFlash('Link copied'); })
      .catch(function(){ shareLegacyCopy(url); });
    return;
  }
  shareLegacyCopy(url);
}
function shareLegacyCopy(url){
  try{
    var ta = document.createElement('textarea');
    ta.value = url;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    var ok = document.execCommand('copy');
    document.body.removeChild(ta);
    shareFlash(ok ? 'Link copied' : 'Could not copy the link');
  }catch(e){ shareFlash('Could not copy the link'); }
}

/* ── SHARE MENU ─────────────────────────────────────────────────────────────
   WHICH PLATFORMS, AND WHY THESE SIX. This is a premium, adult, cannabis-
   adjacent beverage, so the list is picked for two things at once: a
   platform has to actually accept an organic link to it, and it has to have
   a real web share endpoint (a URL you can link to, not an SDK).
     X, Reddit, Telegram — permissive on organic links, and Reddit in
       particular is where this product's audience already talks about it.
     WhatsApp — by far the biggest person-to-person link share on the planet,
       and a private message, which suits a product people share sideways.
     Facebook — its cannabis restrictions live in the ADVERTISING policy;
       sharer.php takes an organic link like any other. Kept for reach.
     Email — no policy surface at all, and the only target that works with no
       account anywhere.
   DELIBERATELY NOT INCLUDED: Instagram and TikTok have no link-share
   endpoint on the web at all (an SDK-free "share" to either is not a thing
   that exists), so a button for them would be a lie. Pinterest and LinkedIn
   both do have endpoints, and both are the wrong room for a nightlife
   elixir — LinkedIn additionally restricts cannabis-adjacent content in a
   way the other five do not.

   WHAT GETS SHARED IS A DEEP LINK TO THE FILM ON SCREEN. The per-video link
   this comment used to describe as "recommendation, not built" is built: the
   share targets all carry this page's URL with ?v=<id> on it, the page reads
   that back on load and opens on that film, and the link is assembled from
   the live origin so it is correct from S3, from drinkblackmarket.com and
   from a Shopify embed without a constant to keep in step. See shareLink().
   The FILE is offered as well, on its own two items — see THE FILM AS A FILE.

   POPUP BLOCKERS ARE A NON-ISSUE HERE BY CONSTRUCTION: every social target
   is a real <a target="_blank">, so the browser is handling a navigation the
   person clicked, not a scripted window.open() arriving after an await. The
   only thing the click handler does for those is close the menu, and it does
   even that on a zero timeout so the anchor's own default action is well
   clear of the element being hidden. */
var shareWrap = $('shareWrap'), sharePop = $('sharePop');
var shareIsOpen = false;
var SHARE_TEXT = 'Own the night — BLACK MARKET';
/* one function per target, so the encoding of each parameter is visible at
   the point it is built rather than assembled by string concatenation
   somewhere else */
var SHARE_NETS = {
  x:        function(u,t){ return 'https://x.com/intent/post?url=' + u + '&text=' + t; },
  facebook: function(u)  { return 'https://www.facebook.com/sharer/sharer.php?u=' + u; },
  reddit:   function(u,t){ return 'https://www.reddit.com/submit?url=' + u + '&title=' + t; },
  whatsapp: function(u,t){ return 'https://api.whatsapp.com/send?text=' + t + '%20' + u; },
  telegram: function(u,t){ return 'https://t.me/share/url?url=' + u + '&text=' + t; },
  email:    function(u,t){ return 'mailto:?subject=' + t + '&body=' + t + '%0A%0A' + u; }
};
/* ── WHAT GETS SHARED — THE FILM ON SCREEN, NOT JUST THE PAGE ──────────────
   CLIENT: "I want the link to the specific video to be what's shared."
   So this is the page URL with ?v=<the id of the film playing> on it, which
   the page reads back on load and opens on — see DEEP_ID and chDeepLink().

   BUILT FROM THE LIVE ORIGIN, NEVER FROM A CONSTANT. The production home is
   drinkblackmarket.com, but this same file is served from an S3 bucket today
   and is going into a Shopify theme later, so hardcoding either one would ship
   links that point at the wrong host from whichever place it is NOT. location
   .origin + location.pathname is correct in all three by construction, and it
   carries the path as well as the host, so an embed at /pages/tv shares
   /pages/tv rather than the site root.

   THE SEARCH STRING IS REBUILT, NOT APPENDED TO. Whatever brought this page
   up — ?demo=tv from the harness, a marketing ?utm_source, the ?v= the viewer
   themselves arrived on — is not what the recipient should be handed. The
   shared link carries exactly one parameter.

   NO ID MEANS NO PARAMETER, AND THAT IS A REAL CASE, NOT A GUARD.
   current.id is empty for a photo film (deliberately — that flow keeps no
   reference to the render at all) and for the several seconds a custom film
   is on screen before the library has filed it and claimOwnFilmId() has
   collected the id. Both share the plain page, which still opens on a working
   channel. A ?v= with nothing after it would just be a worse version of the
   same link. */
/* THE SHARE LANDING SERVICE, NOT THIS PAGE'S OWN URL — and that swap is the
   entire reason the service exists.

   THE PROBLEM IT FIXES. This page cannot carry a per-film preview card. Every
   preview crawler — iMessage, Facebook, X, Slack, WhatsApp, Discord — reads
   meta tags out of the HTML as DELIVERED and none of them run JavaScript, so
   tags written by script are invisible to all six. On S3 the delivered HTML is
   one static file, and inside a Shopify theme it is worse: Liquid has no
   access to the query string at all, so the storefront could never vary its
   tags by ?v= even in principle. A link to this page therefore gets the SAME
   card for every film, whichever host it is served from.

   WHAT IT POINTS AT INSTEAD. highlights.drinkblackmarket.com/<id> is a
   pre-baked page per film on infrastructure we own: a real 200 (never a
   redirect — every one of those crawlers follows 3xx and would read the
   destination's tags instead) carrying THAT film's poster frame, and its MP4
   in og:video where the file is small enough for iMessage to auto-play it.
   Humans are moved straight on to this page by a script the crawlers ignore.

   IT SURVIVES THE SHOPIFY MOVE UNCHANGED, which the old link could not: it
   never touches the storefront, so nothing here has to be built twice.

   NO ID STILL MEANS THIS PAGE. current.id is empty for a photo film (that flow
   deliberately keeps no reference) and for the few seconds before a custom
   film has been filed. Both share the plain channel URL, which now carries its
   own static card — see the LINK PREVIEW block in <head>. */
var SHARE_HOST = 'https://highlights.drinkblackmarket.com';
function shareLink(){
  var id = current && current.id ? String(current.id) : '';
  if(id) return SHARE_HOST + '/' + encodeURIComponent(id);
  return location.origin + location.pathname;
}
/* ── A FILM WITH NO ADDRESS YET ────────────────────────────────────────────
   shareLink() falls back to the plain channel URL whenever current.id is
   empty. For an ORDINARY channel film that is never reached — /next always
   carries an id. For a film the VISITOR COMMISSIONED it is reached for real,
   because /custom answers 7-9 seconds before the pipeline files the film into
   the library and mints the id (see claimOwnFilmId). During that window the
   fallback would hand somebody a link to the generic channel while they
   believed they were sending their own film. That is the one outcome worth
   preventing: a wrong link that LOOKS right travels, gets opened by somebody
   else, and cannot be taken back.

   TRUE ONLY FOR THE VISITOR'S OWN FILMS. current.own is set by adopt() for
   the custom and photo routes and for nothing else, so the homepage channel
   never sees this state and its menu is byte-for-byte what it always was.

   A PHOTO FILM IS PERMANENTLY IN THIS STATE, ON PURPOSE. That flow keeps no
   reference to the film at all — deliberately, because the render is built
   from a photograph of a real person and the page must not be able to hand
   out a way back to it — so there is no id coming, ever. The honest menu for
   it is the same one: no link, and the file itself still saveable and
   sendable by the person who made it. */
function shareFilmLinkPending(){
  return !!(current && current.own && !current.id);
}

/* One class on the panel; the stylesheet decides what it hides. Run from
   shareSetOpen() so every open is correct, and from shareRefresh() so an
   ALREADY-OPEN menu corrects itself the moment the id lands. */
function shareSyncLinkItems(){
  if(!sharePop) return;
  sharePop.classList.toggle('is-link-pending', shareFilmLinkPending());
}

/* Called when the film on screen gains (or loses) its library id.

   IF THE MENU IS SHUT there is nothing to do beyond the class: shareSetOpen()
   re-reads shareLink() for every anchor on the way up, so the next open is
   correct by construction.

   IF THE MENU IS OPEN it has to change UNDER the visitor, and re-opening it is
   how: shareSetOpen(true) is idempotent — it re-syncs the six network hrefs,
   re-syncs the file items, re-syncs this class, and then re-runs the
   flip-up/flip-down placement measurement, which matters here because taking
   eight items off the panel (or putting them back) changes its height. It
   does not move focus, so a visitor part-way through the menu stays where
   they are. Closing and reopening it under them would be the wrong fix: the
   whole failure this guards against is somebody tapping a stale item a second
   before the correct one arrives. */
function shareRefresh(){
  if(!sharePop) return;
  shareSyncLinkItems();
  if(shareIsOpen) shareSetOpen(true);
}

function shareSyncHrefs(){
  if(!sharePop) return;
  var u = encodeURIComponent(shareLink()), t = encodeURIComponent(SHARE_TEXT);
  var as = sharePop.querySelectorAll('a[data-net]');
  for(var i = 0; i < as.length; i++){
    var f = SHARE_NETS[as[i].getAttribute('data-net')];
    if(f) as[i].href = f(u, t);
  }
}
/* the items actually on screen, in DOM order. The only item ever display:none
   is the native button on a device with no navigator.share — that has no
   layout box at all, which is exactly the test — while visibility:hidden
   items, which is what the CLOSED menu is, still report rects, so this stays
   correct while the menu is shut too. The social grid and Copy link are
   never display:none; they are always part of this list. */
function shareMenuItems(){
  if(!sharePop) return [];
  var all = sharePop.querySelectorAll('.share-item'), out = [];
  for(var i = 0; i < all.length; i++){
    if(all[i].getClientRects().length) out.push(all[i]);
  }
  return out;
}
function shareSetOpen(on){
  if(!shareWrap || !sharePop || !shareBtn) return;
  shareIsOpen = on;
  shareWrap.classList.toggle('is-open', on);
  /* lets the popup out of .hero-copy's clip on a phone — see the rule on
     body.share-open in the stylesheet */
  BMVH_ROOT.classList.toggle('share-open', on);
  shareBtn.setAttribute('aria-expanded', on ? 'true' : 'false');
  if(!on){ sharePop.style.right = ''; sharePop.classList.remove('is-below'); return; }
  shareSyncHrefs();
  /* BEFORE the placement measurement below, not after: these can add or remove
     rows, which changes the panel's height, and the flip-up/flip-down
     decision is made off that height. shareSyncLinkItems() can take EIGHT
     rows off, so it matters here more than the file pair does. */
  shareSyncFileItems();
  shareSyncLinkItems();
  /* PLACEMENT. Default is upward — above the dock there is nothing but
     video, and below it is the question strip. Measured, not assumed,
     because the pill's width changes with its state and the dock itself
     moves between the centre of the frame and the bottom of the phone
     stack: read the panel's real rect and only then flip or nudge it. */
  sharePop.classList.remove('is-below');
  sharePop.style.right = '';
  var pad = 8;
  var r = sharePop.getBoundingClientRect();
  if(r.top < pad && r.height + pad * 2 < window.innerHeight){
    sharePop.classList.add('is-below');
    r = sharePop.getBoundingClientRect();
  }
  /* `right` is measured from the wrap's right edge, so a POSITIVE nudge
     moves the panel left. -5px is the value the stylesheet starts from. */
  var shift = 0;
  if(r.left < pad) shift = -(pad - r.left);
  else if(r.right > window.innerWidth - pad) shift = r.right - (window.innerWidth - pad);
  if(shift) sharePop.style.right = (-5 + shift) + 'px';
  var items = shareMenuItems();
  if(items.length) items[0].focus();
}
/* focusBack is for the paths that end ON this page (Escape, click-outside,
   copy, the native sheet). A social target opens a new tab and takes focus
   with it, but the menu it came from is about to become visibility:hidden —
   leaving focus on a hidden element — so focus comes back to the trigger
   whenever it was inside the panel, whatever closed it. */
function shareClose(focusBack){
  if(!shareIsOpen) return;
  var inside = sharePop && sharePop.contains(document.activeElement);
  shareSetOpen(false);
  if((focusBack || inside) && shareBtn){ try{ shareBtn.focus(); }catch(e){} }
}
function shareNative(){
  /* The item is display:none in this state, so this is a backstop rather than
     a path anybody can take — but "share the wrong link" is the exact failure
     being designed out, and a second line of defence for it is cheap. */
  if(shareFilmLinkPending()){ shareFlash('That link is not ready yet'); return; }
  try{
    var p = navigator.share({ title: document.title, text: SHARE_TEXT, url: shareLink() });
    /* a person backing out of the OS sheet rejects this promise; that is not
       a failure worth reporting to them */
    if(p && p.catch) p.catch(function(){});
  }catch(e){ shareFallbackCopy(shareLink()); }
}

/* ── THE FILM AS A FILE ─────────────────────────────────────────────────────
   Two features share this one block, because they need the identical bytes:
   "Download this video" saves the MP4, and "Send the video" hands it to the
   OS share sheet. Fetched ONCE and cached per URL, so using both in one
   sitting is one 4-9MB download, not two.

   WHICH COPY. current.s3Url — the WATERMARKED mirror, never current.videoUrl.
   The renderer's own URL is signed and expires, so a file saved from it is a
   file that stops working; the S3 copy does not expire and carries the
   branding wherever the thing gets reposted, which is the entire point of
   letting people take it. No S3 copy means no file to offer, and both items
   are hidden rather than shown broken — see shareSyncFileItems().

   NEVER FETCHED ON PAGE LOAD. Nothing here runs until a person clicks one of
   the two items. These are 4-9MB files and this page already streams video;
   speculatively pulling another 9MB on a phone connection would cost the
   viewer real money and slow the thing they actually came for. */
var SHARE_FILE_MAX = 64 * 1024 * 1024;   /* a library MP4 runs 4-9MB. This is
                                            not a policy, it is a tripwire: if
                                            a URL ever answers with something
                                            enormous, stop before buffering it
                                            into the tab's memory. */
var shareFileCache = { url:'', promise:null };

/* The name the file lands under. NOT "1.mp4", which is what every one of these
   objects is called on S3 — a person's downloads folder is a shared namespace
   and the second one would be "1 (1).mp4". Brand, product line, and the id, so
   it is identifiable on sight and two of them never collide. Sanitised because
   this string becomes a filename on someone else's machine. */
function shareFileName(){
  var id = (current && current.id) ? String(current.id).replace(/[^0-9]/g, '') : '';
  return 'black-market-own-the-night' + (id ? '-' + id : '') + '.mp4';
}

function shareFileUrl(){
  return (current && current.s3Url) ? current.s3Url : '';
}

/* Progress, written into the item's own label. It is the only visible surface
   in the menu, and a 9MB fetch on a phone is a wait long enough that a button
   which just sits there reads as broken. shareStatus (the aria-live region)
   gets the same information for a screen reader, but only at the ends — a
   live region that announces every percent is unusable. */
function shareItemLabel(item, text){
  if(!item) return;
  var lb = item.querySelector('.share-lb');
  if(lb) lb.textContent = text;
}

function shareFetchFile(item, restoreLabel){
  var url = shareFileUrl();
  if(!url) return Promise.reject(new Error('no file'));
  if(shareFileCache.url === url && shareFileCache.promise) return shareFileCache.promise;

  shareItemLabel(item, 'Preparing…');
  if(shareStatus) shareStatus.textContent = 'Preparing the video';

  var p = fetch(url, { mode:'cors', credentials:'omit' }).then(function(res){
    if(!res.ok) throw new Error('HTTP ' + res.status);
    var total = parseInt(res.headers.get('Content-Length') || '0', 10);
    if(total > SHARE_FILE_MAX) throw new Error('too large');
    /* Streamed so the label can count up. A browser without ReadableStream
       body support (or a response with no Content-Length, which S3 always
       sends but a proxy might strip) falls straight through to res.blob() and
       simply shows "Preparing…" with no number — slower to explain, never
       broken. */
    if(!res.body || !res.body.getReader || !total) return res.blob();
    var reader = res.body.getReader(), chunks = [], got = 0;
    return (function pump(){
      return reader.read().then(function(r){
        if(r.done) return new Blob(chunks, { type:'video/mp4' });
        chunks.push(r.value);
        got += r.value.length;
        shareItemLabel(item, 'Preparing… ' + Math.min(99, Math.round(got / total * 100)) + '%');
        return pump();
      });
    })();
  }).then(function(blob){
    shareItemLabel(item, restoreLabel);
    return blob;
  }, function(err){
    /* a failed fetch must not be cached, or the retry can never succeed */
    if(shareFileCache.promise === p){ shareFileCache.url = ''; shareFileCache.promise = null; }
    shareItemLabel(item, restoreLabel);
    throw err;
  });

  shareFileCache.url = url;
  shareFileCache.promise = p;
  return p;
}

/* ── DOWNLOAD ───────────────────────────────────────────────────────────────
   WHY A PLAIN <a download> WAS NEVER GOING TO WORK, and what does.
   The MP4 is on S3 — a different origin from this page — and every browser
   IGNORES the `download` attribute on a cross-origin href. The click would
   have navigated the tab to the video file instead of saving it, which loses
   the page. The other two routes were both worse: S3's
   response-content-disposition override only applies to a SIGNED request, so
   it would need a new signing endpoint and a round trip before every download;
   and streaming 4-9MB back through the API Lambda would pay for the bytes
   twice and sits near API Gateway's response ceiling.
   So: fetch the file (the bucket already answers CORS GET with
   Access-Control-Allow-Origin *, verified against the live object, so no
   bucket change was needed), wrap it in a blob: URL — which is SAME-ORIGIN,
   and `download` is honoured on same-origin hrefs — click it, and revoke.

   THE FAILURE PATH IS A SECOND PRESS, NOT A DEAD END. If the fetch fails
   (offline, a CORS change, a 403 on a moved object) the item says so and
   ARMS ITSELF: the next press does not preventDefault, so the browser follows
   the anchor's real href and opens the MP4 in a new tab, where the OS save
   still works. That is popup-blocker-safe by construction — it is the
   browser's own handling of an anchor the person clicked, never a scripted
   window.open arriving after an await, which is the thing blockers stop. */
function shareDownload(item){
  var url = shareFileUrl();
  if(!url){ shareFlash('No file for this one'); return; }
  var name = shareFileName();
  shareFetchFile(item, 'Download this video').then(function(blob){
    var href = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = href;
    a.download = name;
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    /* the browser needs the object alive until it has started reading it;
       one turn of the event loop past the click is enough, and leaving it
       alive would pin 9MB for the life of the tab */
    setTimeout(function(){ try{ URL.revokeObjectURL(href); }catch(e){} }, 60000);
    shareFlash('Video saved');
  }, function(){
    if(item) item.setAttribute('data-direct', '1');
    shareItemLabel(item, 'Open the video');
    shareFlash('Could not save it — press again to open the video');
  });
}

/* ── SEND THE FILE ITSELF ───────────────────────────────────────────────────
   navigator.share({files}) — the OS sheet, carrying the MP4 rather than a URL.
   canShare is asked about a REAL File of this exact type, because that is the
   only honest test: navigator.share exists on plenty of desktops that cannot
   take a file, and canShare({files:[…]}) is the call that answers per type.
   Falls back to the link share rather than dying, and a person dismissing the
   OS sheet (AbortError) is not a failure worth reporting. */
function shareCanSendFile(){
  try{
    if(!navigator.share || !navigator.canShare || !window.File) return false;
    return navigator.canShare({ files: [new File([new Blob([])], 'v.mp4', { type:'video/mp4' })] });
  }catch(e){ return false; }
}

function shareSendFile(item){
  if(!shareFileUrl()){ shareFlash('No file for this one'); return; }
  shareFetchFile(item, 'Send the video').then(function(blob){
    var file;
    try{ file = new File([blob], shareFileName(), { type:'video/mp4' }); }
    catch(e){ shareNative(); return; }
    if(!navigator.canShare || !navigator.canShare({ files:[file] })){ shareNative(); return; }
    var p = navigator.share({ files:[file], title: document.title, text: SHARE_TEXT });
    if(p && p.catch) p.catch(function(err){
      if(err && err.name === 'AbortError') return;   /* they backed out */
      shareFlash('Could not send the video');
    });
  }, function(){
    shareFlash('Could not load the video — sharing the link instead');
    shareFallbackCopy(shareLink());
  });
}

/* Both file items are only ever offered when there is a file to offer and,
   for the send, a device that can take one. Run on every menu open, because
   the film on screen changes underneath a closed menu. */
function shareSyncFileItems(){
  if(!sharePop) return;
  var has = !!shareFileUrl();
  var dl = sharePop.querySelector('[data-share="download"]');
  var fs = sharePop.querySelector('[data-share="file"]');
  if(dl){
    dl.style.display = has ? '' : 'none';
    /* the real href, for the browser's own Save-link-as and for the
       second-press fallback in shareDownload() */
    dl.href = has ? shareFileUrl() : '#';
    dl.setAttribute('download', shareFileName());
    /* a fresh film gets a fresh attempt: the "press again to open it" state is
       about ONE failed fetch of ONE file, not a permanent verdict */
    dl.removeAttribute('data-direct');
    shareItemLabel(dl, 'Download this video');
  }
  if(fs) fs.style.display = (has && shareCanSendFile()) ? '' : 'none';
}
function shareItemOf(node){
  while(node && node !== sharePop){
    if(node.classList && node.classList.contains('share-item')) return node;
    node = node.parentNode;
  }
  return null;
}
if(shareBtn && shareWrap && sharePop){
  /* capability, never a UA string */
  if(navigator.share) shareWrap.classList.add('has-native');
  shareSyncHrefs();

  shareBtn.addEventListener('click', function(e){
    e.preventDefault();
    heroHoldSkip();        /* a press is a press — end the opening hold early, same as sound */
    chNoteInteraction();   /* ...and it resets the still-watching counter, same as any other */
    if(shareIsOpen) shareClose(true); else shareSetOpen(true);
  });
  shareBtn.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && shareIsOpen){ e.preventDefault(); shareClose(true); return; }
    if(!shareIsOpen && (e.key === 'ArrowDown' || e.key === 'ArrowUp')){
      e.preventDefault(); shareSetOpen(true);
    }
  });

  sharePop.addEventListener('click', function(e){
    var item = shareItemOf(e.target);
    if(!item) return;
    var act = item.getAttribute('data-share');
    /* THE LINK ITEMS REFUSE WHILE THERE IS NO LINK. All eight are display:none
       in that state (see .share-pop.is-link-pending), so this is a backstop for
       a press that raced the class on — never a route a visitor can find. The
       two FILE items are deliberately not covered: they work off current.s3Url
       and are exactly what stays usable while the address is still being
       filed. */
    if(shareFilmLinkPending() && (act === 'native' || act === 'copy' || item.hasAttribute('data-net'))){
      e.preventDefault(); shareFlash('That link is not ready yet'); return;
    }
    if(act === 'native'){ e.preventDefault(); shareNative(); shareClose(true); return; }
    if(act === 'copy'){ e.preventDefault(); shareFallbackCopy(shareLink()); shareClose(true); return; }
    /* THE MENU STAYS OPEN FOR THESE TWO, unlike every other item. They are the
       only ones that take time: the label counts the fetch up in place, and
       closing the panel would hide the one piece of feedback there is. Both
       flash their result through shareFlash(), which paints the trigger and
       writes the live region whether the panel is up or not. */
    if(act === 'download'){
      /* ARMED BY A FAILED FETCH — see shareDownload(). Not preventing the
         default here lets the browser follow the anchor's real href and open
         the MP4 in a new tab, which is a navigation it was asked for rather
         than a scripted popup, so no blocker is involved. */
      if(item.getAttribute('data-direct')){ setTimeout(function(){ shareClose(false); }, 0); return; }
      e.preventDefault(); shareDownload(item); return;
    }
    if(act === 'file'){ e.preventDefault(); shareSendFile(item); return; }
    /* a social anchor: let the browser navigate, then close on the next tick */
    setTimeout(function(){ shareClose(false); }, 0);
  });

  /* ARIA menu-button keyboard contract: arrows (both axes, because the
     social targets are a grid) wrap through the items, Home/End jump the
     ends, Escape closes and hands focus back, Tab closes and lets focus
     move on naturally rather than trapping it in a transient popup. */
  sharePop.addEventListener('keydown', function(e){
    if(e.key === 'Escape'){ e.preventDefault(); e.stopPropagation(); shareClose(true); return; }
    if(e.key === 'Tab'){ shareClose(false); return; }
    var items = shareMenuItems();
    if(!items.length) return;
    var i = items.indexOf(document.activeElement), next = null;
    if(e.key === 'ArrowDown' || e.key === 'ArrowRight') next = items[(i + 1 + items.length) % items.length];
    else if(e.key === 'ArrowUp' || e.key === 'ArrowLeft') next = items[(i - 1 + items.length) % items.length];
    else if(e.key === 'Home') next = items[0];
    else if(e.key === 'End') next = items[items.length - 1];
    if(next){ e.preventDefault(); next.focus(); }
  });

  /* dismiss on anything that is not the menu. Capture phase so it runs
     before the page's own handlers, and pointerdown as well as click so a
     drag that starts outside still closes it. */
  document.addEventListener('pointerdown', function(e){
    if(!shareIsOpen || shareWrap.contains(e.target)) return;
    shareClose(false);
  }, true);
  document.addEventListener('keydown', function(e){
    if(shareIsOpen && e.key === 'Escape') shareClose(true);
  });
  /* the panel's placement was measured for one viewport and one pill width,
     and a resize can invalidate both — including the 760px cut that moves
     the whole pill out of the dock and into the copy block. */
  window.addEventListener('resize', function(){ shareClose(false); });
}

/* ──────────────────────────────────────────────────────────────
   FLOWS
   ────────────────────────────────────────────────────────────── */
/* Every presentation takes a ticket. Two can overlap — a viewer hits BACK
   while a commit is still buffering — and both would resolve off the SAME
   video element, so the loser would go on to paint its own film's title over
   the winner's and write a phantom entry into the reel. The loser stops here
   instead, and its caller's success/failure handlers never run. */
var presentGen = 0;

/* `gate` — OPTIONAL, AND ONLY THE COLD LOAD PASSES ONE.
   A function returning a promise that this presentation waits on AFTER the
   film has fully buffered and BEFORE it is cut in. boot() passes heroHold()
   through it, and that single argument is the whole fix for the client's
   "still too long from bottle to video."

   WHAT IT REPLACED. The hold used to sit in boot()'s own chain, one link
   ahead of present(). That put the brand moment and the film's download in
   SERIES: the page fetched the film's URL, then sat with an idle network for
   the length of the hold, and only then started pulling the bytes. Timed on
   the live page, the film was not so much as REQUESTED until 2,809ms on a
   fast line, and the ~635ms of buffering that followed was pure addition on
   top of the hold — 2,020ms of the wait was a completely idle connection.

   MOVING IT HERE PUTS THE TWO IN PARALLEL. loadVideo() starts the moment the
   URL is known, so the bytes come down while the bottle is still up, and what
   is left of the floor — if anything — is waited out with a decoded, playable
   film already in hand. The cut itself is unchanged: it still only happens
   once readyState is HAVE_FUTURE_DATA (loadVideo's own gate), so this buys
   time without ever risking a stall or a black frame at the dissolve.

   THE FAILURE PATH IS BETTER FOR IT TOO. A film whose bytes are damaged now
   reaches the error card without first serving out a brand hold nobody is
   waiting for, which is what the hold's own comment always said should
   happen. Every other caller passes no gate and is byte-for-byte unaffected —
   regen, custom, photo, history, and the channel's own seamless cut (which
   does not come through here at all; see chFastCut/adopt). */
function present(data, mode, gate){
  var ticket = ++presentGen;
  /* Falsy entries are dropped rather than passed through: a row carrying only
     the mirror used to put a null in front of the real file, which the player
     dutifully requested (resolving it against the page URL), failed on, and
     only then fell through to the copy that was there all along. */
  var srcs = [];
  if(data.videoUrl) srcs.push(data.videoUrl);
  if(data.s3Url && data.s3Url !== data.videoUrl) srcs.push(data.s3Url);
  /* replaying something from the viewer's own reel: S3 first. A fal URL is
     signed and expires, the S3 copy does not, and an hour-old entry is far
     likelier to still play off S3. */
  if(mode === 'history') srcs.reverse();

  return loadVideo(srcs).then(function(){
    if(ticket !== presentGen) return new Promise(function(){});   /* superseded */
    setRail('100%');
    return gate ? gate() : null;
  }).then(function(){
    if(ticket !== presentGen) return new Promise(function(){});   /* superseded */
    /* THE OPENING GETS A TIGHTER CEILING THAN EVERY OTHER PRESENTATION.
       Anywhere else this hold is the payoff of a progress bar the viewer has
       been watching for 8-30 seconds and letting it land is the point. On the
       cold load it is the last thing between the page opening and the film,
       inside a 3-second budget the client set — and on a phone the cold-load
       strip-back has the plate hidden, so the full hold is time spent
       resolving something nobody can see. 260ms still reads as a resolve
       rather than a cut. Keyed on is-coldload, which boot() clears only after
       this promise chain has finished, so it is reliably set here. */
    return sleep(Plate.rush(body.classList.contains('is-coldload') ? 260 : 0));
  }).then(function(){
    if(ticket !== presentGen) return new Promise(function(){});   /* superseded */
    adopt(data, mode);
  });
}

/* ── THE ID OF A FILM THE VIEWER COMMISSIONED THEMSELVES ───────────────────
   A film somebody ordered — a custom render, or a regenerate — has to reach
   the "already seen" list, or /next stays free to hand it back to them later
   as somebody's random pick. That list is keyed on the LIBRARY ID, and
   NEITHER route that delivers such a film can carry the id in its answer:
   the render pipeline files the finished film into the library 7-9 seconds
   AFTER the page has already been handed it (measured across every custom
   render on 2026-09-05). There is no id in existence yet at the moment the
   film arrives, so it cannot travel with it.

   It is collected a moment later instead. /job answers "which library row is
   this film" when asked with the film's own URL, and replies status:"pending"
   — a truthful state, not an error — until the filing lands. This asks a few
   times across the half-minute that covers it, then gives up in silence. It
   is bookkeeping; it must never put an error card in front of anyone.

   IT MARKS THE FILM SEEN EITHER WAY, because the viewer watched it whatever
   is on screen by the time the answer arrives. It only writes current.id back
   if that film is STILL the one playing — the viewer may have moved on, and
   stamping this id onto their NEXT film would make the page lie about what it
   is showing. The reel entry is found by URL for the same reason. */
var OWN_ID_TRIES = [4000, 5000, 8000, 12000, 16000];   /* ~45s of cover */

function claimOwnFilmId(videoUrl, s3Url){
  var url = videoUrl || s3Url;
  if(!url) return;
  var i = 0;
  (function attempt(){
    if(i >= OWN_ID_TRIES.length) return;
    setTimeout(function(){
      post(API.job, { videoUrl: url }, T_SHORT).then(
        function(d){
          if(!d || d.status !== 'done' || !d.id){ attempt(); return; }
          var id = String(d.id);
          chSeenMark(id);                       /* the whole point of this */
          if(videoUrl && current.videoUrl === videoUrl){
            current.id = id;
            /* THE FILM ON SCREEN JUST BECAME LINKABLE. Inside this guard on
               purpose: the guard is already the answer to "is this still the
               film we are looking at". If the visitor has since commissioned a
               SECOND film, current.videoUrl is that one, this branch does not
               run, and the first film's late id can neither overwrite the
               record nor turn the second film's menu back on — the second film
               runs its own chase and lights its own links when its own id
               lands. */
            shareRefresh();
          }
          for(var k = 0; videoUrl && k < chHist.length; k++){
            if(chHist[k].videoUrl === videoUrl) chHist[k].id = id;
          }
        },
        function(){ attempt(); }                /* a blip is not fatal */
      );
    }, OWN_ID_TRIES[i++]);
  })();
}

/* ── ADOPT — "this film is now the programme" ──────────────────────────────
   Everything that has to be true once a film is on screen: the current-film
   record, the prompt panel, the status line, the readout, the late-failure
   watcher, playback, and the reel bookkeeping. Lifted out of present()
   unchanged so the seamless cut (chFastCut) can run the IDENTICAL tail without
   a second copy of it drifting away from this one. present() reaches here
   after loading a film into the live player; chFastCut reaches here after
   swapping to the player that already had it loaded. Same ending either way. */
function adopt(data, mode){
    if(mode === 'next'){
      current.id      = data.id ? String(data.id) : '';
      current.jobId   = '';
      current.product = data.product ? String(data.product) : '';
      current.oneOff  = false;
      current.own     = false;
    } else if(mode === 'custom'){
      /* A CUSTOM FILM GOES INTO PUBLIC ROTATION — the client's own decision —
         so it MUST be recorded as seen or /next can serve the viewer their
         own film back later as a random pick. That needs the library id, and
         the id is filed seconds after this film was handed over, so it is
         taken here when it happens to be present and chased when it is not.
         Leaving it at '' was the whole defect: chSeenMark('') does nothing. */
      current.id      = data.id ? String(data.id) : '';
      current.jobId   = data.jobId ? String(data.jobId) : '';
      current.product = '';
      current.oneOff  = true;
      current.own     = true;
      if(!current.id) claimOwnFilmId(data.videoUrl, data.s3Url);
    } else if(mode === 'photo'){
      /* NO REFERENCE IS KEPT FOR A PHOTO FILM, deliberately. A photo render's
         prompt is a written description of a real person's face, and this flow
         has never been re-pressable — the old build could not do it because no
         prompt came back, and keeping a handle here would quietly create the
         ability. The API refuses a photo job on /regen for the same reason. */
      current.id      = '';
      current.jobId   = '';
      current.product = '';
      current.oneOff  = true;
      current.own     = true;
    } else if(mode === 'history'){
      current.id      = data.id ? String(data.id) : '';
      current.jobId   = data.jobId ? String(data.jobId) : '';
      current.product = data.product ? String(data.product) : '';
      current.oneOff  = !!data.oneOff;
      /* NOT current.own — walking back into a film you already watched,
         even your own, is a deliberate replay, not a fresh commission
         finishing. The hold is for the moment it first lands, once. */
      current.own     = false;
    } else if(mode === 'regen'){
      /* REGEN KEEPS jobId / product / oneOff / own EXACTLY AS THEY WERE —
         regenerating an ordinary channel film must not turn it "own", and
         regenerating your own film is still fairly yours.

         THE ID IS THE ONE FIELD THAT SHOULD NOT SIMPLY CARRY OVER. A
         regenerate is a NEW film with its own library row, so holding the
         previous film's id got two things wrong at once: the film actually
         on screen was never recorded as seen, and the reel entry pointed a
         replay at the film this one REPLACED.

         IT IS REPLACED, NEVER CLEARED. current.id is also the handle regen()
         itself needs — with both it and jobId empty, the regen button falls
         through to a full reboot — so blanking it while the new id is still
         being filed would break re-pressing a regenerated film. Overwriting
         only once a real id exists is strictly better than the old behaviour
         and cannot be worse than it. */
      if(data.id) current.id = String(data.id);
      else claimOwnFilmId(data.videoUrl, data.s3Url);
    }

    current.videoUrl = data.videoUrl;
    current.s3Url    = data.s3Url || '';
    /* The flow that made this film, straight from the payload — the photo
       route answers source:"photo". The reel check below trusts EITHER this or
       the call-site mode, so a photo film is still kept out of storage if one
       of the two ever goes missing.
       REGEN IS ONE EXCEPTION, same "kept exactly as it was" contract as
       jobId/product/oneOff/own above: it re-presses the SAME prompt, so a
       regenerated custom film is still a custom film, but /regen's own
       response is not confirmed to echo `source` back (api-contract.md does
       not list it, unlike /next which builds it field-by-field). Falling
       back to the value already on `current` — set when THIS film first
       adopted, moments ago — rather than to '' means an absent field can
       never silently blank the ★ USER badge on a video that was already
       correctly badged; a real `source` in the response still wins outright.

       CUSTOM IS THE OTHER: /custom's own documented response (api-contract.md
       ENDPOINT 3) does not list `source` either, and this is the highest-risk
       gap of the two — a viewer who just answered three questions and got
       their own film back is exactly the person who would notice a missing
       ★ USER badge. Same fix as the photo check two branches up (mode OR
       current.source, either is proof enough): the browser calling /custom is
       itself first-hand proof this film is custom-sourced, so mode==='custom'
       is hardcoded as the fallback rather than inherited from a prior value
       the way regen's is — there IS no prior value worth trusting here, this
       is a brand new film. A real `source` in the response still wins first. */
    current.source   = String((data && data.source) ||
                               (mode === 'regen' ? current.source : '') ||
                               (mode === 'custom' ? 'custom' : '') ||
                               '').trim().toLowerCase();
    leaveLoading();
    setState('playing');
    setStatus(
      mode === 'custom'  ? 'Yours · it will never exist again' :
      mode === 'regen'   ? 'Second pressing · same prompt, new night' :
      mode === 'history' ? 'From your reel · you have seen this one' :
                           /* DELETED. The client struck this byline out, so
                              it is emptied at the source as well as hidden by
                              CSS in the playing state — belt and braces, so no
                              state transition can ever put it back on screen.
                              The other three lines above are the same slot for
                              custom / regen / replay films and are equally
                              unpainted while a film is on; they are left in
                              place because they are not the deleted line. */
                           ''
    );
    setReadout('1344×768  ·  8S  ·  ' + chTapeLabel() +
      (current.oneOff ? '  ·  ONE OFF'
                      : (current.product ? '  ·  ' + current.product.toUpperCase() : '')));
    watchVideoForLateFailure();
    play();
    chAfterPresent(mode);
}

/* COLD-LOAD STRIP-BACK — client: "get rid of the loading text at the top and
   the make yours / controls [...] right now i want to see the bottle more
   on load." body.is-coldload is scoped to exactly this one window: from the
   moment boot() (the ONE call site that ever runs, per page load, per
   heroHoldUsed) kicks off the first request, through the mandatory
   heroHold() stare, until present() has cut the first film in and this same
   chain's .then/.catch removes the class again. Every other data-state
   "loading" moment — the seamless channel cut (LINES_CUT), regen, the
   still-watching gate's own break, a genuine render (already handled by its
   own is-rendering strip-back above) — runs through beginRequest() too but
   NEVER through boot(), so none of them ever see this class. See the
   body.is-coldload rules in the @media(max-width:760px) block for what it
   hides. */
/* ── THE DEEP-LINKED FILM ──────────────────────────────────────────────────
   Resolves ?v=<id> to a playable film, ONCE, for the first film of the page.
   Everything after it is the ordinary channel.

   IT DOES NOT SPEND THE ONE FRESH REQUEST, AND THAT IS THE WHOLE POINT OF
   DOING IT HERE RATHER THAN INSIDE getNext(). Asking for `fresh` is what
   consumes a never-served library row and commissions its replacement render,
   and getNext() spends that slot through chFreshMode(). A deep link is not a
   request for new stock — it names a film the library already holds — so it
   sends neither `mode` nor `exclude`, the API answers it from a single
   GetItem, and the page's fresh slot is untouched afterwards. The page
   therefore does its normal one fresh request on the SECOND film instead of
   the first, and a shared link costs exactly what a plain page load costs.
   Confirmed by capturing the request bodies, not by reading this comment.

   FAILURE IS SILENT AND FALLS THROUGH TO THE NORMAL CHANNEL. A dead id — one
   that never existed, one an operator has muted, a photo film (refused by the
   API, and refused with the same bytes as "no such video" so a link cannot be
   used to discover which ids are customer photo videos), or a network blip —
   resolves to null and boot() carries on into getNext() as though there had
   been no parameter at all.

   WHY SILENT AND NOT "THAT LINK IS DEAD". A share link outlives the thing it
   points at: it gets reposted months later, after an operator has muted a
   film, and it gets pasted with a chat client's punctuation stuck to the end.
   The person clicking it did not choose the id and cannot do anything about
   it. Showing them an error would trade a working channel — the actual
   product, and the thing that can still sell them a bottle — for an apology
   about a number they never saw. A stale link quietly landing on BLACK MARKET
   playing is the better outcome for the viewer AND for the client. The failure
   is not swallowed everywhere: it is logged to the console for whoever is
   debugging a link, which is the audience that can act on it. */
function chDeepLink(){
  if(!DEEP_ID) return Promise.resolve(null);
  /* post(), not submit(): submit's extra job is to follow a `queued` answer
     into the render-queue poller, and a lookup of a film the library already
     holds is never queued. One call, one answer. */
  return post(API.next, { id: DEEP_ID }, T_SHORT).then(
    function(data){
      /* same two-copies rule as getNext(): either URL is a playable film */
      if(data && data.ok && (data.videoUrl || data.s3Url)){
        unpinLine();
        return data;
      }
      /* ok:false with notFound, or an ok:true with nothing to play. Both are
         "this link does not resolve", both fall through. */
      if(window.console && console.info){
        console.info('[bm] deep link ?v=' + DEEP_ID +
                     ' did not resolve (' + ((data && data.code) || 'no video') +
                     ') — opening the normal channel instead');
      }
      return null;
    },
    function(err){
      if(window.console && console.info){
        console.info('[bm] deep link ?v=' + DEEP_ID + ' failed (' +
                     ((err && err.detail) || (err && err.message) || 'network') +
                     ') — opening the normal channel instead');
      }
      return null;
    }
  );
}

function boot(){
  if(busy) return;
  body.classList.add('is-coldload');
  beginRequest(LINES_FIRST, LINES, 4);
  /* is-coldfade scopes the 400ms opening dissolve to the FIRST bottle-to-video
     cut only (see
     the body.is-coldfade rule on .layer-video/.layer-brand above) without
     touching is-coldload's own "cleared the instant the film cuts in"
     contract for the mobile strip-back below — is-coldload's own add/remove
     calls are untouched. It has to be a SEPARATE class: is-coldload is
     cleared in the same microtask as setState('playing') runs inside
     present()/adopt(), so by the time the browser captures the "after"
     style for the opacity transition it is already gone and a duration
     scoped to it is never seen — confirmed by measuring the rendered fade
     before landing on this split. transitionend on the video layer's own
     opacity is the correct signal to clear is-coldfade instead: it only
     fires once that one dissolve has actually finished, however long
     present()'s own buffering and then the remainder of heroHold()
     (interruptible) took to get there. If the dissolve is itself interrupted by a later state
     change inside that 400ms, transitionend never fires for it, so
     is-coldfade is also cleared in the catch below as a backstop. */
  var coldFadeLayer = BMVH_ROOT.querySelector('.layer-video');
  body.classList.add('is-coldfade');
  if(coldFadeLayer){
    coldFadeLayer.addEventListener('transitionend', function onColdFade(e){
      if(e.propertyName !== 'opacity') return;
      coldFadeLayer.removeEventListener('transitionend', onColdFade);
      body.classList.remove('is-coldfade');
    });
  }
  /* THE DEEP LINK GOES FIRST, AND ONLY ON THE FIRST FILM OF THE PAGE.
     boot() is also the retry path for a failed load and the archive-reset
     path, so DEEP_ID is cleared the moment it has been used — a second boot()
     in the same session must open on the channel, not replay the link. The
     parameter comes off the address bar in the same step, whether or not it
     resolved: a link that pointed at a muted film should not still be in the
     URL for the viewer to copy and pass on. */
  chDeepLink()
    .then(function(deep){
      if(DEEP_ID){ deepLinkStripUrl(); DEEP_ID = null; }
      /* null means no parameter, or a parameter that did not resolve. Either
         way this is the ordinary first pull, fresh request and all. */
      return deep || getNext();
    })
    /* THE HOLD IS HANDED TO present() RATHER THAN RUN AHEAD OF IT. Only the
       film's URL is in hand at this point; its bytes are not. Waiting here
       meant waiting with an idle connection and only then starting the
       download — the two costs in series, which is what made the opening feel
       long. As a gate it runs on the far side of the buffering instead, so
       the film downloads behind the bottle and the floor is whatever, if
       anything, is still owed once the film is playable. See present(). */
    .then(function(data){ return present(data, 'next', heroHold); })
    .then(function(){ setBusy(false); body.classList.remove('is-coldload'); })
    .catch(function(err){
      setBusy(false);
      body.classList.remove('is-coldload');
      body.classList.remove('is-coldfade');
      if(isEndOfReel(err)){ chShowEnd(); return; }
      fail(err, boot);
    });
}

/* THE regen() FUNCTION USED TO LIVE HERE AND IS DELETED, NOT JUST UNHOOKED.
   It was this page's only caller of /regen, the route that re-renders a film
   from its stored prompt — a real, billable render every time it ran. Its two
   buttons were removed at the client's request a while back, which left the
   'R' key as its single surviving trigger, and that key is now gone too. A
   function with no callers that can still spend money is worse than no
   function at all: the next person to wire a button to it has no idea what it
   costs.

   WHAT IS DELIBERATELY LEFT. API.regen, T_REGEN, LINES_REGEN, present()'s
   'regen' presentation mode and demoPost's isRegen branch all stay. Without a
   caller they are inert — no timer, no request, no cost — and the 'regen'
   mode branch in particular is threaded through the own-film and `source`
   handling that the custom and photo flows also depend on. Unpicking that is
   a refactor with a real chance of breaking two working flows, and it buys
   nothing: the money is in the request, and the request is gone. */

/* ── custom: three questions, one film ── */
var lastCustom = null;

/* Only the answered fields go in the body. An empty-but-present key reads
   differently to the model than an absent one, so blanks are omitted. */
function readCustom(){
  var a = {};
  var loc = (fLocation.value || '').trim().slice(0,200);
  var ppl = (fPeople.value   || '').trim().slice(0,200);
  var act = (fActivity.value || '').trim().slice(0,200);
  if(loc) a.location = loc;
  if(ppl) a.people   = ppl;
  if(act) a.activity = act;
  return a;
}
/* Any subset is valid — one answer, two, or all three. Only a completely
   empty form is refused: with nothing to go on this is just a random pull,
   which is what the other button already does. */
function validateCustom(a){
  var any = !!(a.location || a.people || a.activity);
  [fLocation, fPeople, fActivity].forEach(function(el){
    el.classList.toggle('bad', !any);
    el.setAttribute('aria-invalid', !any ? 'true' : 'false');
  });
  if(!any){
    formErr.textContent = 'Give us one thing to go on — any one of the three will do.';
    try{ fLocation.focus(); }catch(e){}
    return false;
  }
  formErr.textContent = '';
  return true;
}

/* ── RENDER PROGRESS ROW SWAP ─────────────────────────────────────────────
   Scoped to runCustom()/runPhoto() ONLY — see the CSS comment on
   body.is-rendering. Keyed on a dedicated class rather than data-state
   because data-state="loading" also covers the cold-start hold, a plain
   channel cut and the "random pull" regen, none of which are a render and
   none of which should ever swap this row. */
/* ── BACK TO THE TOP THE MOMENT A RENDER IS COMMISSIONED ──────────────────
   CLIENT: "after I submit a customs video via form, the page should scroll
   back to the top automatically." The form is at the BOTTOM of the hero and
   the three questions push the page down further on a phone, so a visitor
   submits from well below the film and would otherwise spend the whole render
   looking at a collapsed form instead of at the stage their film is about to
   appear on.

   WHERE "THE TOP" IS. The channel's own top, clamped so it can never scroll
   PAST the top of the document, and snapped to 0 when the channel already
   starts within a header's height of it — which on the homepage it does. So
   this is the plain "back to the top" the client asked for, and on any
   template that ever puts the channel further down the page it still lands the
   film in the viewport rather than parking on somebody's header.

   IT DOES NOT FIGHT THE PRESENCE GATE. That gate pauses the channel when it is
   scrolled out of view and resumes it when it comes back; this scroll only
   ever moves the channel INTO view, so the two agree rather than race — the
   observer fires once at the end of the scroll and the gate's answer changes
   from "gone" to "here", which is the direction it already handles. Nothing
   here touches data-state, and nothing here plays or pauses anything.

   REDUCED MOTION IS HONOURED using the flag this file already computes once at
   parse time; a visitor who has asked for no animation is jumped, not slid. */
function chScrollToStage(){
  if(!BMVH_ROOT || !BMVH_ROOT.getBoundingClientRect) return;
  var top = 0;
  try{
    var page = window.pageYOffset ||
               (document.documentElement && document.documentElement.scrollTop) || 0;
    top = Math.max(0, BMVH_ROOT.getBoundingClientRect().top + page - 8);
  }catch(e){ top = 0; }
  if(top < 120) top = 0;   /* a header's worth of offset IS the top of the page */
  try{ window.scrollTo({ top: top, left: 0, behavior: REDUCED ? 'auto' : 'smooth' }); }
  catch(e){ try{ window.scrollTo(0, top); }catch(e2){} }
}

/* The MAKE YOURS disclosure, shut. Called when a render FINISHES (see
   exitRendering) rather than when it starts: #makeRowProgress — the only
   progress display left on screen during a render — is a descendant of
   #makeFold, and #makeFold collapsed is opacity:0, so shutting the fold on
   submit would hide the very readout the visitor is waiting on. Shutting it on
   the way out is what "goes back to regular controls" actually means: the film
   comes up and the transport dock is a chip and three buttons again, not a
   form. Above 760px .m-form-shut selects nothing at all, so desktop is
   untouched by this in either direction. */
function chShutFormFold(){
  if(!body.classList.contains('m-form-shut')) body.classList.add('m-form-shut');
  if(formToggle){
    formToggle.setAttribute('aria-expanded','false');
    var lbl = formToggle.getAttribute('data-shut-label');
    if(lbl) formToggle.setAttribute('aria-label', lbl);
  }
}

function enterRendering(){
  var a = document.activeElement;
  /* setBusy(true) (already called by beginRequest, just before this runs)
     disables the three fields and both make-row buttons, and a browser
     blurs a focused control the instant it is disabled — so by the time
     this runs, a focus that started in the row has usually already landed
     on <body>. Catching either that OR a focus still literally inside the
     row covers both the raced and unraced case, and never steals focus
     that was legitimately somewhere else (the photo path's own modal, a
     nav link, etc.) — the only way into runCustom() is this row's own
     submit, so if focus isn't in the row or on body, it was never ours. */
  var wasOurs = a === fLocation || a === fPeople || a === fActivity ||
                a === customBtn || a === photoTgl || a === document.body;
  body.classList.add('is-rendering');
  if(makeRowProgress){
    makeRowProgress.hidden = false;
    /* preventScroll:true is what lets the scroll below own the scroll position
       outright — without it the browser would jump this element into view and
       land somewhere other than the top. */
    if(wasOurs){ try{ makeRowProgress.focus({preventScroll:true}); }catch(e){} }
  }
  chScrollToStage();
  /* the badge BECOMES the loading animation off this class, and its accessible
     name is written by chRender() — so the class going on has to repaint it */
  chRender();
}
function exitRendering(){
  body.classList.remove('is-rendering');
  if(makeRowProgress) makeRowProgress.hidden = true;
  /* Reached on success AND on failure — every runCustom()/runPhoto() path ends
     here — so a render that errors or times out puts the ordinary transport
     back exactly as a successful one does. The visitor is never left on a
     stripped screen with nothing to press. */
  chShutFormFold();
  /* and the class coming off has to put the badge back to LIVE or USER, and
     clear the "loading" accessible name with it */
  chRender();
}

function runCustom(answers){
  var a = answers || lastCustom;
  if(!a) return;
  lastCustom = a;
  var voice = customLines(a);
  beginRequest(voice.seed, voice.cycle, 30);
  enterRendering();
  submit(API.custom, a, T_CUSTOM)
    .then(function(data){
      if(!data.ok || !data.videoUrl){
        throw new AppError(msgForCode(data.code, data.error),
                           'CUSTOM · ' + (data.code || 'ok:' + data.ok));
      }
      return present(data, 'custom');
    })
    .then(function(){ setBusy(false); exitRendering(); })
    .catch(function(err){
      setBusy(false);
      exitRendering();
      fail(err, function(){ runCustom(lastCustom); });
    });
}

customForm.addEventListener('submit', function(e){
  e.preventDefault();
  chNoteInteraction();
  if(busy) return;
  var a = readCustom();
  if(!validateCustom(a)) return;
  runCustom(a);
});
/* The refusal is form-level — "any one of the three will do" — so it is
   cleared form-level too. Filling ANY field satisfies it, which means all
   three must drop the invalid mark together. Clearing only the field being
   typed in would leave the other two outlined red under an empty message,
   i.e. an error state with nothing left explaining it. */
[fLocation, fPeople, fActivity].forEach(function(el){
  el.addEventListener('input', function(){
    var fields = [fLocation, fPeople, fActivity];
    var any = fields.some(function(f){ return f.value.trim(); });
    if(!any) return;
    var wasBad = false;
    fields.forEach(function(f){
      if(f.classList.contains('bad')){ wasBad = true; }
      f.classList.remove('bad');
      f.setAttribute('aria-invalid','false');
    });
    if(wasBad){ formErr.textContent = ''; }
  });
});
/* typing any of the three questions is a present human — a still-watching
   gate has no business appearing under someone mid-sentence */
[fLocation, fPeople, fActivity].forEach(function(el){
  el.addEventListener('input', chNoteInteraction);
});

/* ══════════════════════════════════════════════════════════════════════════
   PHOTO — pick, check, upload straight to S3, render
   Every limit below is also enforced server-side. It is repeated here because
   a photo that cannot possibly render should be refused in the browser, for
   free, instead of after an upload and a paid render slot.
   ══════════════════════════════════════════════════════════════════════════ */
/* HEIC is deliberately absent. The renderer would take it, but the vision model
   that reads the photo first refuses to fetch a HEIC URL, so accepting one would
   mean an upload that fails a step later. iPhones are unaffected in practice:
   iOS converts to JPEG when a photo is picked through a file input. */
var PHOTO_TYPES = ['image/jpeg','image/jpg','image/png','image/webp'];
var PHOTO_MAX_BYTES = 30 * 1024 * 1024;
var PHOTO_MIN_AXIS  = 256;
var PHOTO_MAX_AXIS  = 5760;
/* The render provider refuses a seed frame outside this band before it starts
   work. The video also comes back in whatever shape the photo was — there is no
   way to ask for a different one — so a portrait photo makes a portrait film. */
var PHOTO_RATIO_MIN = 0.4;
var PHOTO_RATIO_MAX = 2.5;

var photoFile = null, photoObjUrl = null, photoDimsOk = null;

function photoTypeOk(t){
  t = String(t||'').toLowerCase().split(';')[0];
  for(var i=0;i<PHOTO_TYPES.length;i++){ if(PHOTO_TYPES[i] === t) return true; }
  return false;
}

function setPhotoErr(msg){
  photoErr.textContent = msg || '';
  dropZone.classList.toggle('bad', !!msg);
}

function clearPhoto(){
  photoFile = null; photoDimsOk = null;
  if(photoObjUrl){ try{ URL.revokeObjectURL(photoObjUrl); }catch(e){} photoObjUrl = null; }
  try{ photoInput.value = ''; }catch(e){}
  photoPrev.classList.remove('on');
  photoThumb.removeAttribute('src');
  photoName.textContent = ''; photoDims.textContent = '';
  /* back to the full-size, empty drop target */
  dropZone.classList.remove('has-file');
  dzTitle.textContent = 'Drop a photo here, or tap to choose one';
  setPhotoErr('');
}

/* Decode the file locally to read its real pixel size. HEIC does not decode in
   most browsers; that is not a rejection, it just means the size and shape are
   checked server-side instead. */
function measurePhoto(file){
  return new Promise(function(resolve){
    var url = URL.createObjectURL(file);
    var img = new Image();
    var done = false;
    var finish = function(w,h){ if(done) return; done = true; resolve({ w:w, h:h, url:url }); };
    img.onload  = function(){ finish(img.naturalWidth||0, img.naturalHeight||0); };
    img.onerror = function(){ finish(0,0); };
    setTimeout(function(){ finish(0,0); }, 8000);
    img.src = url;
  });
}

function acceptPhoto(file){
  if(!file) return;
  clearPhoto();
  if(!photoTypeOk(file.type)){
    setPhotoErr(CODE_MSG.bad_content_type); return;
  }
  if(file.size > PHOTO_MAX_BYTES){
    setPhotoErr(CODE_MSG.file_too_large); return;
  }
  measurePhoto(file).then(function(m){
    photoObjUrl = m.url;
    if(m.w && m.h){
      if(m.w < PHOTO_MIN_AXIS || m.h < PHOTO_MIN_AXIS){
        setPhotoErr('That photo is ' + m.w + '×' + m.h + ' — too small to build from. ' +
                    'Each side needs to be at least ' + PHOTO_MIN_AXIS + 'px.');
        return;
      }
      if(m.w > PHOTO_MAX_AXIS || m.h > PHOTO_MAX_AXIS){
        setPhotoErr('That photo is ' + m.w + '×' + m.h + ' — too big to build from. ' +
                    'Each side has to be ' + PHOTO_MAX_AXIS + 'px or under.');
        return;
      }
      var r = m.w / m.h;
      if(r < PHOTO_RATIO_MIN || r > PHOTO_RATIO_MAX){
        setPhotoErr('That photo is too ' + (r > PHOTO_RATIO_MAX ? 'wide' : 'tall') +
                    ' to become a video (' + m.w + '×' + m.h + '). ' +
                    'A normal phone photo works.');
        return;
      }
      photoDims.textContent = m.w + ' × ' + m.h + ' · ' +
        (r < 1 ? 'portrait — your film comes back portrait'
               : (r > 1 ? 'landscape — your film comes back landscape'
                        : 'square — your film comes back square'));
      photoThumb.src = m.url;
    } else {
      /* the file declared an accepted type but would not decode here */
      photoDims.textContent = 'we will check the size once it is uploaded';
      photoThumb.removeAttribute('src');
    }
    photoFile = file;
    photoDimsOk = m;
    photoName.textContent = file.name || 'your photo';
    photoPrev.classList.add('on');
    /* the big target has done its job — collapse it, the preview above now
       carries the visual weight */
    dropZone.classList.add('has-file');
    dzTitle.textContent = 'Tap to replace, or drop a new photo';
    setPhotoErr('');
  });
}

function readPhotoAnswers(){
  var a = {};
  var loc = (pLocation.value || '').trim().slice(0,200);
  var ppl = (pPeople.value   || '').trim().slice(0,200);
  var act = (pActivity.value || '').trim().slice(0,200);
  if(loc) a.location = loc;
  if(ppl) a.people   = ppl;
  if(act) a.activity = act;
  return a;
}

/* The photo never travels through the API. It goes browser -> S3 on a URL the
   API signs, which is the only way a 3-8MB phone photo gets through at all. */
function uploadPhoto(file){
  return post(API.upload, { contentType: file.type, size: file.size }, T_SHORT)
    .then(function(d){
      if(!d.ok || !d.uploadUrl || !d.imageUrl){
        throw new AppError('We could not open a slot for that photo. Try again.',
                           'UPLOAD-URL ok:' + d.ok);
      }
      return fetch(d.uploadUrl, {
        method:'PUT', body:file, mode:'cors',
        headers:{ 'Content-Type': file.type }
      }).then(function(res){
        if(!res.ok){
          throw new AppError('That photo did not finish uploading. Try again.',
                             'S3 PUT ' + res.status);
        }
        return d.imageUrl;
      });
    });
}

function showSeedFrame(url){
  if(!url || !seedFrame) return;
  seedFrame.src = url;
  body.classList.add('has-seed');
}
function hideSeedFrame(){
  if(!seedFrame) return;
  body.classList.remove('has-seed');
  seedFrame.removeAttribute('src');
}

function runPhoto(){
  if(!photoFile){ setPhotoErr('Choose a photo first.'); return; }
  var a = readPhotoAnswers();
  var voice = customLines(a);
  voice.seed = ['Reading your photograph', 'Finding everyone in frame', 'Writing what happens next'];
  beginRequest(voice.seed, voice.cycle, 75);
  enterRendering();
  /* their own picture holds the screen while the film is built from it */
  showSeedFrame(photoObjUrl);

  uploadPhoto(photoFile)
    .then(function(imageUrl){
      var b = { imageUrl: imageUrl };
      if(a.location) b.location = a.location;
      if(a.people)   b.people   = a.people;
      if(a.activity) b.activity = a.activity;
      return submit(API.photo, b, T_PHOTO);
    })
    .then(function(data){
      if(!data.ok || !data.videoUrl){
        throw new AppError(msgForCode(data.code, data.error),
                           'PHOTO · ' + (data.code || 'ok:' + data.ok));
      }
      return present(data, 'photo');
    })
    .then(function(){
      setBusy(false);
      exitRendering();
      hideSeedFrame();
      photoWrap.classList.remove('open');
      photoTgl.setAttribute('aria-expanded','false');
    })
    .catch(function(err){
      setBusy(false);
      exitRendering();
      hideSeedFrame();
      fail(err, runPhoto);
    });
}

photoInput.addEventListener('change', function(){
  acceptPhoto(photoInput.files && photoInput.files[0]);
});
photoClear.addEventListener('click', function(e){ e.preventDefault(); clearPhoto(); });
['dragenter','dragover'].forEach(function(ev){
  dropZone.addEventListener(ev, function(e){
    e.preventDefault(); e.stopPropagation(); dropZone.classList.add('drag');
  });
});
['dragleave','drop'].forEach(function(ev){
  dropZone.addEventListener(ev, function(e){
    e.preventDefault(); e.stopPropagation(); dropZone.classList.remove('drag');
  });
});
dropZone.addEventListener('drop', function(e){
  var dt = e.dataTransfer;
  if(dt && dt.files && dt.files.length) acceptPhoto(dt.files[0]);
});
photoForm.addEventListener('submit', function(e){
  e.preventDefault();
  if(busy) return;
  runPhoto();
});
photoTgl.addEventListener('click', function(){
  chNoteInteraction();
  var open = photoWrap.classList.toggle('open');
  photoTgl.setAttribute('aria-expanded', open ? 'true' : 'false');
});
/* NEW POUR / RUN IT BACK buttons are gone (client request) — their click
   handlers went with them, and so, now, have the 'R' key that was regen()'s
   last surviving trigger and regen() itself. boot() is NOT dead code — it is
   still called by the first load, by the archive running out, and by
   getNext() with no history yet. */
retryBtn.addEventListener('click', function(){ retryAction(); });
if(buyNowLink) buyNowLink.addEventListener('click', chNoteInteraction);

/* SHOPIFY PORT -- WHY THE TV KEYS ARE NOW CONDITIONAL.
   On the standalone page the channel WAS the whole document, so claiming
   space and the arrows at document level cost nothing: there was nothing
   to scroll. The homepage now carries the image banners and the featured
   collection underneath, and Space is the browser's own page-down key.
   Left as it was, the preventDefault() below would have silently killed
   keyboard scrolling for the entire homepage, from anywhere on it,
   including while the visitor was reading the section at the bottom.
   So the channel only claims these keys while it is actually the thing on
   screen, and hands them straight back to the browser once it is not.
   Half the viewport is the threshold: generous enough that the shortcuts
   still work while watching, strict enough that they are released as soon
   as the visitor has scrolled on to the content below. */
/* ONE definition of "the channel is on screen", and two things read it: the
   keyboard shortcuts below and the presence gate under them. When an
   IntersectionObserver is available it OWNS the answer (chInView), so the
   keys and playback can never end up disagreeing about where the visitor
   is. The rect math stays as the fallback for a browser without one, and it
   computes the same rule the observer's rootMargin encodes: on screen means
   the channel still covers the middle of the viewport, which for a
   full-height hero is "at least half of it is showing".
   null, not false: it means NO OBSERVER HAS REPORTED YET, which is a third
   state and must fall through to the rect math rather than read as "gone". */
var chInView = null;

function bmvhChannelInView(){
  if(chInView !== null) return chInView;
  if(!BMVH_ROOT || !BMVH_ROOT.getBoundingClientRect) return true;
  var r  = BMVH_ROOT.getBoundingClientRect();
  var vh = window.innerHeight || document.documentElement.clientHeight || 0;
  if(!vh) return true;
  var visible = Math.min(r.bottom, vh) - Math.max(r.top, 0);
  return visible >= vh * 0.5;
}

document.addEventListener('keydown', function(e){
  if(e.metaKey || e.ctrlKey || e.altKey) return;
  var tag = (e.target && e.target.tagName || '').toLowerCase();
  if(tag === 'input' || tag === 'textarea') return;
  if(!bmvhChannelInView()) return;
  if((e.key === 'm' || e.key === 'M') && body.getAttribute('data-state') === 'playing'){
    chNoteInteraction();
    setSound(video.muted);
  }
  /* 'R' USED TO SIT HERE AND IT SPENT MONEY. It called regen(), which posts
     to /regen and renders a new film on the spot — a paid render reachable
     by pressing one unlabelled key, outside the one-render-per-page-load
     rule entirely. Removed on the client's instruction ("kill the keyboard R
     shortcut"), which finishes what removing the NEW POUR / RUN IT BACK
     buttons started: nothing in the UI advertised the key, so nothing in the
     UI has to change with it. The function went with it — see below. */

  /* it is a TV: space, left, right. A focused button keeps space and enter,
     otherwise the transport buttons would fire twice on their own key. */
  var onButton = (tag === 'button' || tag === 'a');
  if((e.key === ' ' || e.key === 'Spacebar') && !onButton){ e.preventDefault(); chNoteInteraction(); chTogglePlay(); }
  if(e.key === 'ArrowLeft'){  e.preventDefault(); chNoteInteraction(); chBack(); }
  if(e.key === 'ArrowRight'){ e.preventDefault(); chNoteInteraction(); chNext(); }
});

/* ══ PRESENCE — IS ANYBODY ACTUALLY WATCHING ════════════════════════
   TWO ways to stop watching without saying so, and ONE piece of code that
   answers both, because two copies of a rule drift apart:
     • the tab goes to the background — visibilitychange, the original case.
     • the visitor scrolls past the hero to the sections underneath — a
       state that did not exist on the standalone page, where the channel
       WAS the whole document. IntersectionObserver, wired up below.
   Either one means the film on screen is playing to nobody, so it pauses,
   and pausing is what suspends auto-advance for free: chOnEnded() is the
   only thing that rolls the channel forward by itself, and a paused video
   never fires 'ended'. The held-ahead fetch is stood down at the same time
   (see chSchedulePrefetch) so walking away from the hero also stops the
   channel quietly drawing films out of this viewer's library.

   WHAT THIS DOES NOT DO IS SAVE RENDER MONEY, and that is worth saying
   plainly rather than leaving implied: only the FIRST /next of a page load
   asks for mode "fresh", and only a "fresh" request commissions a render
   (~$0.27). Every advance after it asks for "archive", which the API serves
   from rows already rendered and bills nothing for. Scrolling past the hero
   was never spending renders — it was spending bandwidth, battery and this
   viewer's own unseen library. */
var videoAutoPausedByPresence = false;

/* ══ THE AGE GATE OUTRANKS THE CHANNEL ════════════════════════════════
   snippets/age-verification-modal.liquid puts a two-step 21+ gate over every
   page of this store, the homepage included. Nothing here styles it, moves
   it, reads its answer or weakens it — it is a compliance control and it
   stays exactly as the rest of the store has it. What the CHANNEL has to do
   is stay off behind it, and that is two separate things:

     • Nothing plays. A film running under a modal nobody has answered is a
       film shown to somebody who has not said they are 21. This costs no new
       mechanism at all: chPresent() already answers "is anybody watching",
       and "the gate is up" is simply another way of not watching, so the
       existing pause-and-resume path handles it.

     • NOTHING IS COMMISSIONED. That one is NOT free, and pausing does not
       achieve it — the page's single render is bought by the first /next,
       which boot() fires before a frame ever plays. So boot() is HELD until
       the gate is gone (see chBootWhenAgeAllows) rather than fired and then
       paused. A visitor who lands, is asked their age and leaves now costs
       nothing at all. */
/* WHY THIS DOES NOT ASK WHETHER THE MODAL IS ON SCREEN.
   That was the first attempt and it silently did nothing. This file is
   loaded with `defer`, and a deferred script runs BEFORE DOMContentLoaded —
   which is when the age snippet initialises and actually shows its modal. So
   at the moment the channel asked, the modal was still sitting at its
   stylesheet default of display:none, the question came back "no gate", and
   the channel booted and spent its render behind a gate that appeared a
   moment later. Measured: two /next calls, the first of them `fresh`, all
   while the gate was up.

   So the question asked here is the one the snippet itself asks, from the
   same two places it reads — and neither of them depends on when anything
   ran. A visitor is either on record as having passed the gate or they are
   not.

   THE ESCAPE HATCH MATTERS AS MUCH AS THE GATE. "Present and unverified"
   would deadlock a page whose age snippet failed to run at all: the modal
   would never be shown, nobody could ever pass it, and the channel would
   wait forever. So once the document has finished loading, a modal that is
   still not displayed is a modal that is never going to be, and the channel
   stops waiting. Before that point it waits, which covers the whole window
   the first attempt fell through. */
function chAgeVerified(){
  if(window.__bmAgeVerified) return true;
  try{ if(localStorage.getItem('age_verified') === 'true') return true; }catch(e){}
  return /(?:^|;\s*)age_verified=true(?:\s*;|$)/.test(document.cookie || '');
}

function chAgeGateUp(){
  var el = document.getElementById('bm-age-modal');
  if(!el) return false;                 /* no gate on this template at all */
  if(chAgeVerified()) return false;     /* already passed it */
  if(window.getComputedStyle(el).display !== 'none') return true;  /* on screen */
  /* not on screen and not verified: still coming, unless the page is done */
  return document.readyState !== 'complete';
}

/* ── THE SLIDE-OUT MENU COUNTS AS NOT WATCHING ────────────────────────────
   The theme's drawer covers the film with an opaque panel and a dimmed
   backdrop, so a film still running behind it is playing to nobody — the same
   situation as a backgrounded tab or a hero scrolled past, and it gets the
   same answer rather than a new one. Folding it into chPresent() means the
   existing pause/resume path handles it for free: playback stops on open and
   picks up on close, and because a paused film never fires 'ended', the
   channel cannot quietly advance behind the menu either.

   READ OFF THE ELEMENT THE THEME ITSELF DRIVES — the <details> open attribute
   — rather than a flag of ours kept in step by hand. global.js owns the
   opening and closing; this only asks. */
function chMenuDrawerOpen(){
  return !!(navDrawer && navDrawer.classList.contains('open'));
}

function chPresent(){
  return !document.hidden && !chAgeGateUp() && !chMenuDrawerOpen() && bmvhChannelInView();
}

/* Held, not fired-and-paused — see chAgeGateUp for why the difference costs
   money. Called instead of boot() at the very bottom of this file. */
function chBootWhenAgeAllows(){
  var el = document.getElementById('bm-age-modal');

  /* The gate going up or coming down changes the answer to "is anybody
     watching", so it feeds the presence gate for as long as the page lives —
     not just until the channel boots. Without this, a film paused behind the
     gate stays paused after the visitor passes it. */
  if(el && typeof MutationObserver === 'function'){
    new MutationObserver(function(){ chApplyPresence(); })
      .observe(el, { attributes:true, attributeFilter:['style','class'] });
  }

  if(!chAgeGateUp()){ boot(); return; }

  var booted = false;
  function go(){
    if(booted || chAgeGateUp()) return;
    booted = true;
    clearInterval(poll);
    boot();
  }
  /* A poll, not an observer, as the primary: the gate can end in ways that
     never touch an attribute on that node — the snippet writing its cookie
     first and hiding a beat later, the node being removed outright, or the
     document simply finishing loading with no gate ever shown. All of those
     change chAgeGateUp()'s answer, and only re-asking catches them. Cheap:
     two DOM reads every 400ms, and it stops the moment the channel boots. */
  var poll = setInterval(go, 400);
  if(document.readyState !== 'complete') window.addEventListener('load', go);
}

function chApplyPresence(){
  var here  = chPresent();
  var state = body.getAttribute('data-state');
  if(state === 'loading'){ if(here) Plate.start(); else Plate.stop(); }
  /* Only resume what WE paused — a viewer who hit pause themselves right
     before switching tabs or scrolling off should not have playback restart
     under them when they come back. */
  if(state === 'playing'){
    if(!here){
      clearTimeout(chLead);            /* stand the held-ahead fetch down */
      if(!video.paused){
        videoAutoPausedByPresence = true;
        try{ video.pause(); }catch(e){}
      }
    } else if(videoAutoPausedByPresence){
      videoAutoPausedByPresence = false;
      play();
      chSchedulePrefetch();            /* re-arm what leaving stood down */
    }
  }
}

document.addEventListener('visibilitychange', chApplyPresence);

/* the drawer opening or closing changes the answer to "is anybody watching",
   so it feeds the presence gate exactly like the age gate and the scroll
   observer already do. 'toggle' fires on <details> for both directions. */
/* ── THE SLIDE-OUT ────────────────────────────────────────────────────────
   Everything the theme's own drawer would have done, minus its dependency on a
   header this page does not render: open and close, the backdrop, Escape, a
   focus trap, a scroll lock, and the presence gate so the film behind an opaque
   panel is not playing to nobody.

   ONE BUTTON DOES BOTH. The client asked for the two rules to become an X and
   for that X to close the menu, so #navBurger toggles rather than only opening;
   aria-expanded is what the stylesheet reads to draw the cross, so the state
   and the drawing can never disagree.

   THE FOCUS TRAP IS DELIBERATELY SMALL. It cycles the panel's own focusables on
   Tab and hands focus back to the trigger on close, which is what a dialog owes
   a keyboard user. It does not try to be a general-purpose trap. */
(function(){
  if(!navDrawer || !navBurger) return;
  var lastFocus = null;

  /* THE TRIGGER IS PART OF THE CYCLE, not just the panel's contents. It is the
     close control now and it lives OUTSIDE .navDrawer (it has to, to paint above
     the panel), so a trap built only from the panel's own children would leave
     a keyboard user unable to reach the X at all. Escape still closes too; this
     is about not making Escape the only way. */
  function focusables(){
    var list = Array.prototype.slice.call(navDrawer.querySelectorAll(
      'a[href], button:not([disabled])'));
    list.unshift(navBurger);
    return list.filter(function(el){ return el.getClientRects().length; });
  }

  function setOpen(on){
    if(on === navDrawer.classList.contains('open')) return;
    navDrawer.classList.toggle('open', on);
    navDrawer.setAttribute('aria-hidden', on ? 'false' : 'true');
    navBurger.setAttribute('aria-expanded', on ? 'true' : 'false');
    navBurger.setAttribute('aria-label', on ? 'Close the menu' : 'Open the menu');
    /* the page behind a full-height panel must not scroll under it */
    try{ document.documentElement.style.overflow = on ? 'hidden' : ''; }catch(e){}
    if(on){
      lastFocus = document.activeElement;
      var f = focusables();
      if(f.length){ try{ f[0].focus(); }catch(e){} }
    }else if(lastFocus){
      try{ lastFocus.focus(); }catch(e){}
      lastFocus = null;
    }
    chNoteInteraction();
    chApplyPresence();     /* pause behind the panel, resume when it closes */
  }

  navBurger.addEventListener('click', function(e){
    e.preventDefault();
    setOpen(!navDrawer.classList.contains('open'));
  });
  if(navDrawerClose) navDrawerClose.addEventListener('click', function(e){
    e.preventDefault(); setOpen(false);
  });
  if(navDrawerBackdrop) navDrawerBackdrop.addEventListener('click', function(){ setOpen(false); });
  /* following a link leaves the page anyway; closing first stops the panel
     flashing back into view if the browser restores this page from cache */
  navDrawer.addEventListener('click', function(e){
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if(a) setOpen(false);
  });
  document.addEventListener('keydown', function(e){
    if(!navDrawer.classList.contains('open')) return;
    if(e.key === 'Escape'){ e.preventDefault(); setOpen(false); return; }
    if(e.key !== 'Tab') return;
    var f = focusables();
    if(!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if(e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
    else if(!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
  });
})();

/* rootMargin of -50% top and bottom shrinks the observer's box down to the
   viewport's horizontal midline, so "intersecting" reads as "the channel is
   still covering the middle of the screen" — the same rule the rect
   fallback in bmvhChannelInView() computes, but expressed as geometry the
   browser evaluates itself instead of work done on every scroll frame.
   Skipped when BMVH_ROOT fell back to documentElement: observing the whole
   document would report "in view" forever, and the rect fallback already
   answers that case correctly. */
if(BMVH_ROOT && BMVH_ROOT !== document.documentElement &&
   typeof IntersectionObserver === 'function'){
  new IntersectionObserver(function(entries){
    for(var i = 0; i < entries.length; i++){
      if(entries[i].target !== BMVH_ROOT) continue;
      chInView = entries[i].isIntersecting;
    }
    chApplyPresence();
  }, { rootMargin: '-50% 0px -50% 0px', threshold: 0 }).observe(BMVH_ROOT);
}

/* ══════════════════════════════════════════════════════════════════════════
   THE CHANNEL
   The page stopped being a video and became a station: one film ends, the
   next one starts, forever.

   THE SESSION IS THE UNIT
     One film per page load is FRESH — a row nobody has ever been served. That
     single request is what commissions a replacement render, so it is asked
     once and never again. Every film after it is drawn at random from the
     archive, costs nothing, and renders nothing. chHist (the reel) and chPre
     (the one held-ahead film) are still plain session memory — a reload
     starts THOSE over, which is exactly the client's own instruction: "on
     reload, start over" was about the reel and the session flow, never about
     forgetting what someone has already watched. chSeen is the one exception
     — see THE SEEN SET below — because a viewer must never be served the
     same film twice, reload or not. When the shared library itself runs out
     for a viewer, the client's own call is: wipe chSeen and keep going with a
     freshly randomised run, never a dead end — see getNext()'s handling of
     `exhausted`.

   STATE
     chHist    every film shown THIS SESSION, oldest first, in memory only.
               URLs, never bytes. Capped at CH_MAX. Resets on reload.
     chSeen    every id this viewer has ever been shown, persisted to
               localStorage (CH_SEEN_KEY) so a reload cannot repeat one.
               Sent with every /next so the server can pick at random from
               what is LEFT. Separate from chHist because chHist is capped,
               and a forgotten film is one you get shown twice.
     chCursor  which one is on screen. chHist.length-1 IS the live edge.
     chPre     exactly ONE film held ahead. Never two — every viewer sitting
               on a buffered film drains a five-deep shared cache twice as
               fast, so one ahead is the entire budget.
     chGen     bumped by every transition. Work that finishes against a stale
               generation is discarded rather than yanking the screen around.

   THE FRONTIER RULE
     Behind the edge, NEXT is a seek through films already seen.
     AT the edge nothing newer exists yet, so NEXT is not a skip button:
     if the held film is ready it plays now; if it is not, the channel goes
     to a BREAK and cuts back in by itself the moment the render lands.
     A control that cannot do anything says why instead of pretending.
   ══════════════════════════════════════════════════════════════════════════ */
/* CH_KEY is LEGACY. Nothing writes it any more; it is named here only so
   chPurgeLegacyStorage can delete what older builds left behind — it once
   held reel entries carrying photo-film URLs of real people, so purging it
   on every boot is a privacy control, not tidying.
   CH_SEEN_KEY is ACTIVE — see THE SEEN SET below — and chPurgeLegacyStorage
   must never touch it. */
var CH_KEY  = 'bm.tv.history.v1';
var CH_SEEN_KEY = 'bm.tv.seen.v1';
var CH_MAX  = 50;      /* films kept in the session reel */
var CH_SEEN_MAX = 5000;   /* ids kept per session — matches the API's cap */
var CH_LEAD = 1400;    /* let the film on screen buffer before we go get the next */

var chHist    = [];
var chCursor  = -1;
var chGen     = 0;
var chWaiting = false;   /* on the break */
var chLead    = 0;

/* OFF-REEL — a film is on screen that is deliberately NOT in the reel.
   A photo film is built from a photograph of a real person, so it is shown
   once and never written to disk. That leaves the transport in a state the
   frontier rule never had to describe: the screen is showing something the
   cursor does not point at. chCursor stays parked on the last real programme,
   so BACK steps OUT of the one-off rather than back THROUGH it, and NEXT is
   still at the live edge. */
var chOffReel = false;

var chPre = { state:'idle', data:null, promise:null, q:null,
              /* warm     the STANDBY PLAYER holding the next film
                 warmUrl  the source it was told to buffer
                 warmReady it has reached HAVE_FUTURE_DATA — i.e. the cut
                          to it can be instant. Only then does chFastCut go. */
              warm:null, warmUrl:'', warmReady:false };
var chPreBlocked = false;   /* a prefetch failed — no retry until the next boundary */

/* ── STILL-WATCHING GATE ─────────────────────────────────────────────────
   The client's own decisions: 20 consecutive AUTO-advances (no wall clock),
   no interaction anywhere resets to zero. Counts every film the channel
   moved to BY ITSELF via chOnEnded — never a film the viewer asked for by
   clicking/tapping/typing, so twenty manual NEXTs in a row never gates.
   Time the viewer is not actually watching does not count: the presence
   gate above pauses playback before an 'ended' event can even fire, so a
   backgrounded tab — or a hero the visitor has scrolled clean past — simply
   stops accumulating rather than needing its own carve-out here.

   Whether the gate is on screen is read straight off data-state==='idlecheck'
   rather than a second boolean kept in step with it by hand — a separate
   flag is exactly the kind of thing a quiet interaction (a keystroke in a
   field) resets while the card is still visually up, which would leave the
   real resume button unable to tell it is live. One source of truth. */
var STILL_WATCHING_LIMIT = 20;
var autoAdvanceCount = 0;
function chGateIsShowing(){ return body.getAttribute('data-state') === 'idlecheck'; }

/* Any sign of a present human. Only clears the counter — it never touches
   data-state or the video itself, so it is safe to call from a plain field
   keystroke without side effects. Where a click also has to resume playback
   (the transport buttons, the dedicated resume button) that follow-through
   is the caller's own existing logic, which already drives data-state. */
function chNoteInteraction(){
  autoAdvanceCount = 0;
  /* a deliberate press also ends the opening hero hold early, if one is
     still running — see heroHold() */
  heroHoldSkip();
}

var tpBack = $('tpBack'), tpPlay = $('tpPlay'), tpNext = $('tpNext'),
    tpPos  = $('tpPos'),  tpWhy  = $('tpWhy'),  tpPlayPath = $('tpPlayPath');

var ICON_PLAY  = 'M7.6 5.2v13.6L18.8 12z';
var ICON_PAUSE = 'M7.4 5h3.4v14H7.4zM13.2 5h3.4v14h-3.4z';
/* USER-MADE BADGE star. Inline SVG rather than a text glyph (★, U+2605) on
   purpose — a text star pulls a different, inconsistently-shaped glyph from
   each platform's own font (noticeably heavier on iOS than desktop Chrome),
   which is exactly the kind of thing a badge that has to "stick out"
   the same way everywhere cannot afford. fill="currentColor" so it always
   matches .tp-pos.is-badge's own yellow with nothing to keep in sync by
   hand. aria-hidden — the badge's accessible name is set explicitly in
   chRender() instead, so the shape itself never needs to be described. */
var ICON_STAR_BADGE = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
  '<path fill="currentColor" d="M12 2l2.9 6.26L22 9.27l-5 4.87 1.18 6.86L12 17.77l-6.18 3.23L7 14.14l-5-4.87 7.1-1.01z"/></svg>';

/* ══ THE STATE GLYPHS ══════════════════════════════════════════════════════
   One per thing the dock can actually be saying. The sentence that used to be
   painted here is still assembled in full below and still reaches BACK and
   NEXT through aria-describedby — these only replace the PIXELS it used to
   occupy. Every branch chRender can take resolves to exactly one of these:

     start     the first film of the night, nothing held behind it yet
     edge      at the live edge — this is the newest thing that exists
     incoming  the next one is being fetched
     ready     the next one is fetched AND buffered — the cut will be instant
     break     on a commercial break, waiting for a render to land
     busy      a render this viewer asked for is on its way
     replay    behind the live edge, walking back through the reel
     oneoff    a one-off (a photo film) that is not in the reel at all
     end       the archive is spent for this session

   Stroked, single weight, no fill — they read at 18px over moving video,
   which a filled glyph at this size does not. */
var TP_ICONS = {
  start:    ['M6 3.2v17.6','M6 4.4h11.4l-2.4 3.7 2.4 3.7H6z'],
  edge:     ['M12 10.9a1.1 1.1 0 1 0 0 2.2 1.1 1.1 0 0 0 0-2.2',
             'M8.7 8.7a4.7 4.7 0 0 0 0 6.6','M15.3 15.3a4.7 4.7 0 0 0 0-6.6',
             'M6.1 6.1a8 8 0 0 0 0 11.8','M17.9 17.9a8 8 0 0 0 0-11.8'],
  incoming: ['M4.2 14.6v3.2a2 2 0 0 0 2 2h11.6a2 2 0 0 0 2-2v-3.2',
             'M12 4v8.6','m8.2 9 3.8 3.8L15.8 9'],
  ready:    ['M4.2 14.6v3.2a2 2 0 0 0 2 2h11.6a2 2 0 0 0 2-2v-3.2',
             'm8.4 9.1 2.7 2.7 5.1-5.4'],
  break:    ['M6.6 3.4h10.8','M6.6 20.6h10.8',
             'M16.4 3.4v3.1L12 12l4.4 5.5v3.1','M7.6 3.4v3.1L12 12l-4.4 5.5v3.1'],
  busy:     ['M20 12a8 8 0 1 1-2.7-6','M20.2 2.9v4.2H16'],
  replay:   ['M4 12a8 8 0 1 0 2.7-6','M3.8 2.9v4.2H8'],
  oneoff:   ['M12 3.4 14 9.1l5.7 1.9-5.7 1.9-2 5.7-2-5.7L4.3 11 10 9.1z'],
  end:      ['M12 3.7a8.3 8.3 0 1 0 0 16.6 8.3 8.3 0 0 0 0-16.6','M6.2 6.2 17.8 17.8']
};
/* the two states worth colouring, and the one worth dimming */
var TP_TONE = { ready:'is-ready', incoming:'is-working',
                break:'is-working', busy:'is-working', end:'is-done' };
var tpIcKey = '';

function paintTpIcon(key, text){
  if(!tpIc || !tpIcArt) return;
  if(key !== tpIcKey){
    tpIcKey = key;
    var ds = TP_ICONS[key] || TP_ICONS.edge;
    while(tpIcArt.firstChild) tpIcArt.removeChild(tpIcArt.firstChild);
    for(var i = 0; i < ds.length; i++){
      var pth = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      pth.setAttribute('d', ds[i]);
      tpIcArt.appendChild(pth);
    }
    tpIc.setAttribute('class', 'tp-ic ' + (TP_TONE[key] || ''));
  }
  /* the words, in full, on hover — nothing the sentence said is unavailable */
  tpIc.setAttribute('title', text);
}

var LINES_CUT        = ["Cutting to the next one", "Coming up", "Next on the channel"];
var LINES_BREAK_SEED = ["We’ll be right back", "Short break", "Don’t go anywhere"];
var LINES_BREAK = [
  "Nothing newer exists yet · we’re pressing it",
  "This is the part where you wait",
  "It cuts back in on its own",
  "Purple is a temperature, not a colour",
  "The good stuff never shows up on time",
  "Back after this"
];
var LINES_REWIND = ["Back in your reel", "Rewinding", "Pulling it off the shelf again"];

/* ── STORAGE — ONE KEY PURGED, ONE KEY KEPT ─────────────────────────────
   The reel (CH_KEY) is still exactly what the comment below used to say for
   both lists: session-only, and actively deleted on every boot if an older
   build left it behind. It carries whole payloads, which can include the URL
   of a film built from a real person's uploaded photograph — deleting it is
   a privacy control, not tidying, and this function must keep doing that.

   The seen-set (CH_SEEN_KEY) is different on purpose: it holds nothing but
   ids, never a payload, never a URL, so there is nothing in it to protect
   anyone from. Wiping it on every boot was the actual bug — it made
   "never show the same film twice" true only until the tab was reloaded.
   It is now read on boot (chSeenHydrate) and written on every new id
   (chSeenMark), and this function must never remove it. ──────────────── */
function chStore(){ try{ return window.localStorage; }catch(e){ return null; } }

function chPurgeLegacyStorage(){
  var s = chStore();
  if(!s) return;
  try{ s.removeItem(CH_KEY); }catch(e){}
}


/* ── THE SEEN SET — ids only, and it never forgets ───────────────────────
   Kept apart from the reel above on purpose. The reel carries whole payloads,
   which is why it is capped at
   CH_MAX and sheds its OLDEST entries first — and that is exactly the wrong
   shape for "never show me this one twice", because the film it forgets first
   is the film you would then be offered again. This list is nothing but ids:
   5,000 of them cost about 30KB, so it never has to forget anything.

   It is also the only per-viewer state this product has. /next cannot tell one
   visitor from another, so the browser sends this list and the server picks at
   random from whatever is not on it. The library itself is shared and
   permanent — a film someone else watched is still new to you, and one you
   watched is still new to them. Clearing browser data resets you to a
   first-time visitor, which is the honest behaviour for a page that asks for
   no account and stores no identity.

   PERSISTED, unlike everything else the channel keeps. A reload must not
   hand a viewer a film they were already shown, so this is the one list
   written to localStorage (CH_SEEN_KEY) as well as kept in memory. */
var chSeen    = [];      /* ids, oldest first — the order is only for pruning */
var chSeenIdx = new Set();

/* Read once, on boot, before the first getNext() call — see chInit(). Any
   failure (storage disabled, quota, corrupt JSON, a non-array value) is
   swallowed and treated as a first-time visitor rather than allowed to break
   boot; every member is coerced to a string so a malformed entry cannot
   poison chSeenIdx's identity checks against ids the server sends back. */
function chSeenHydrate(){
  var s = chStore();
  if(!s) return;
  try{
    var raw = s.getItem(CH_SEEN_KEY);
    if(!raw) return;
    var arr = JSON.parse(raw);
    if(!Array.isArray(arr)) return;
    var clean = [];
    for(var i = 0; i < arr.length; i++){
      var id = String(arr[i] == null ? '' : arr[i]).trim();
      if(id && !chSeenIdx.has(id)){ chSeenIdx.add(id); clean.push(id); }
    }
    chSeen = clean;
  }catch(e){ chSeen = []; chSeenIdx = new Set(); }
}

function chSeenPersist(){
  var s = chStore();
  if(!s) return;
  try{ s.setItem(CH_SEEN_KEY, JSON.stringify(chSeen)); }catch(e){}
}

/* THE CLIENT'S OWN CALL: "if it gets to where they've seen them all then
   wipe their session data and start over with random videos." Clears both
   the in-memory set and the persisted key — see getNext()'s handling of the
   server's `exhausted` signal, the only caller. */
function chSeenReset(){
  chSeen = [];
  chSeenIdx = new Set();
  var s = chStore();
  if(s){ try{ s.removeItem(CH_SEEN_KEY); }catch(e){} }
}

/* returns true if this id was not already on the list */
function chSeenMark(id){
  id = String(id == null ? '' : id).trim();
  if(!id || chSeenIdx.has(id)) return false;
  chSeenIdx.add(id);
  chSeen.push(id);
  /* The cap only exists so a pathological session cannot grow this without
     bound. It sits above the API's own limit and far above the library, so
     nothing is dropped in practice; if it ever bites, the oldest go first.
     The server enforces the SAME cap and hard-400s anything larger, so the
     two must stay aligned — do not raise one without the other. */
  if(chSeen.length > CH_SEEN_MAX){
    var drop = chSeen.splice(0, chSeen.length - CH_SEEN_MAX);
    for(var k=0; k<drop.length; k++) chSeenIdx['delete'](drop[k]);
  }
  chSeenPersist();
  return true;
}


/* what /next filters against. Safe before load: an empty list just means
   "show me anything", which is the right answer for a first-time visitor. */
function chSeenList(){ return chSeen; }

/* ── WARMING — the payload is a URL; this pulls the BYTES into the browser
   cache while the current film plays, so the cut is a beat and not a wait.
   A detached element, never in the DOM: no second player, no second audio,
   and every existing error/sound/readyState path stays exactly as it was.
   Entirely best-effort — if a browser declines, the cut is just slower. ── */
/* whichever player is NOT on screen — the one free to buffer the next film */
function chStandby(){ return video === videoA ? videoB : videoA; }

function chWarm(url){
  chCool();
  if(!url) return;
  var sb = chStandby();
  try{
    /* muted while it buffers, or the page would have two soundtracks the
       moment a browser decided to start it. The cut sets the real value. */
    sb.muted = true;
    sb.preload = 'auto';
    var onOk = function(){
      if(sb !== chPre.warm) return;             /* superseded warm-up */
      if(sb.readyState < 3) return;             /* HAVE_FUTURE_DATA or nothing */
      if(chPre.warmReady) return;
      chPre.warmReady = true;
      chRender();                               /* the dock can now say "buffered" */
    };
    var onErr = function(){
      /* a warm-up that fails is not a failure — the channel simply takes the
         ordinary path for this one and loads it the slow way. */
      if(sb !== chPre.warm) return;
      chPre.warmReady = false; chPre.warmUrl = '';
      chRender();
    };
    sb.__warmOk = onOk; sb.__warmErr = onErr;
    sb.addEventListener('canplaythrough', onOk);
    sb.addEventListener('canplay', onOk);
    sb.addEventListener('loadeddata', onOk);
    sb.addEventListener('error', onErr);
    chPre.warm = sb; chPre.warmUrl = url; chPre.warmReady = false;
    sb.src = url;
    try{ sb.load(); }catch(e){}
    /* it may already be sitting in the browser cache from a previous pass */
    if(sb.readyState >= 3) onOk();
  }catch(e){ chPre.warm = null; chPre.warmUrl = ''; chPre.warmReady = false; }
}

function chCool(){
  var v = chPre.warm;
  chPre.warm = null; chPre.warmUrl = ''; chPre.warmReady = false;
  if(!v) return;
  if(v.__warmOk){
    v.removeEventListener('canplaythrough', v.__warmOk);
    v.removeEventListener('canplay', v.__warmOk);
    v.removeEventListener('loadeddata', v.__warmOk);
    v.__warmOk = null;
  }
  if(v.__warmErr){ v.removeEventListener('error', v.__warmErr); v.__warmErr = null; }
  /* NEVER strip the player that is on screen. After a seamless cut the element
     that was the warm one IS the live one, and chAfterPresent calls straight
     through to here — without this guard the cut would blank its own film. */
  if(v === video) return;
  try{ v.removeAttribute('src'); v.load(); }catch(e){}
}

/* ── THE SEAMLESS CUT ──────────────────────────────────────────────────────
   Only possible when the held film is already DECODED in the standby player.
   When it is, there is nothing left to wait for, so the channel skips the
   whole loading apparatus — no stopPlayback, no plate, no rush delay — and
   simply lights the other player. The outgoing frame stays painted underneath
   until the incoming one has faded in over it, so there is no black between
   films at all.

   It COMMISSIONS NOTHING. The payload it plays was already fetched by
   chEnsurePrefetch, so this path issues no request of any kind — it cannot
   reach getNext(), which is the only thing that can ever ask for a fresh film.
   Returns false if it cannot go, and the ordinary path runs untouched. */
function chFastCut(d){
  var sb  = chPre.warm;
  var url = d && (d.videoUrl || d.s3Url);
  if(!sb || !url) return false;
  if(sb === video) return false;                 /* nothing to swap to */
  if(!chPre.warmReady || chPre.warmUrl !== url) return false;
  if(sb.readyState < 3) return false;
  if(body.getAttribute('data-state') !== 'playing') return false;

  var outgoing = video;
  chHideEnd();
  chPre.state = 'idle'; chPre.data = null; chPre.promise = null; chPre.q = null;
  chWaiting = false;
  ++chGen;                  /* any in-flight transition is now stale */
  ++presentGen;             /* and so is any present() still buffering */
  detachLiveErr();

  try{ sb.currentTime = 0; }catch(e){}
  sb.muted = !soundOn;
  /* light the incoming FIRST, on top — the outgoing film is still painted
     beneath it, so the dissolve never shows the hero's black floor */
  sb.classList.add('is-live');
  sb.removeAttribute('aria-hidden');
  video = sb;                                    /* the pair have swapped roles */
  chPre.warm = null; chPre.warmUrl = ''; chPre.warmReady = false;

  adopt(d, 'next');                              /* the identical tail present() runs */
  setBusy(false);

  window.setTimeout(function(){
    if(video === outgoing) return;               /* cut again mid-dissolve */
    outgoing.classList.remove('is-live');
    outgoing.setAttribute('aria-hidden', 'true');
    try{ outgoing.pause(); }catch(e){}
    try{ outgoing.removeAttribute('src'); outgoing.load(); }catch(e){}
  }, 420);

  chRender();
  return true;
}

/* ── PREFETCH — one ahead, and only one ────────────────────────────────── */
function chEnsurePrefetch(foreground){
  if(chPre.state === 'ready') return Promise.resolve(chPre.data);
  if(chPre.state === 'inflight'){
    /* the call already running becomes the main event: let it narrate */
    if(foreground && chPre.q) chPre.q.quiet = false;
    return chPre.promise;
  }
  if(chPreBlocked && !foreground) return null;

  chPre.state = 'inflight';
  chPre.q = { quiet: !foreground };
  var p = getNext(chPre.q).then(function(d){
    chPre.state = 'ready'; chPre.data = d; chPre.promise = null;
    chPreBlocked = false;
    chWarm(d.videoUrl || d.s3Url);
    chRender();
    return d;
  }, function(err){
    /* degrade quietly: the viewer is still watching something. One more go
       at the next film boundary, and not a moment before. */
    chPre.state = 'idle'; chPre.data = null; chPre.promise = null;
    /* The archive is spent. There is nothing for a retry at the next film
       boundary to find, so remember that instead of arming one. */
    if(isEndOfReel(err)){ chEnded = true; chPreBlocked = false; }
    else chPreBlocked = true;
    chRender();
    throw err;
  });
  chPre.promise = p;
  p.catch(function(){});   /* a background failure never reaches the console */
  chRender();
  return p;
}

function chSchedulePrefetch(){
  clearTimeout(chLead);
  if(chCursor < chHist.length - 1) return;   /* not at the edge — the next one is already ours */
  if(chPre.state !== 'idle' || chPreBlocked) return;
  chLead = setTimeout(function(){
    if(busy || chWaiting) return;
    if(chCursor < chHist.length - 1) return;
    if(chPre.state !== 'idle' || chPreBlocked) return;
    chEnsurePrefetch(false);
  }, CH_LEAD);
}

/* ── TRANSITIONS ───────────────────────────────────────────────────────── */

/* ── SESSION SHAPE ────────────────
   ONE fresh film per session, and it is the first. Everything after it is a
   random walk through the archive with no repeats, and when that runs out the
   session is over and says so. Both flags are plain memory, so a reload starts
   the cycle again — which is the entire point. */
var chEnded     = false;   /* the archive is spent too — terminal */

/* THE END CARD. Terminal and small on purpose: it floats over the last frame
   rather than taking the hero, so BUY NOW and the make-row stay reachable
   underneath it. It also stops the channel dead — no prefetch, no polling, no
   renders — because there is nothing left for any of that to find. */
function chShowEnd(){
  chEnded = true;
  chWaiting = false;
  clearTimeout(chLead);
  chPre.state = 'idle'; chPre.data = null; chPre.promise = null; chPre.q = null;
  chPreBlocked = false;
  chCool();
  setBusy(false);
  unpinLine();
  setStatus('That is the lot');
  setReadout('END OF REEL');
  body.classList.add('is-ended');
  try{ video.pause(); }catch(e){}
  chRender();
}

/* anything that puts a film back on the screen leaves the card behind */
function chHideEnd(){ body.classList.remove('is-ended'); }

/* START OVER — a new lap of the library without a reload. The reel and the
   seen-set are session memory, so emptying them hands the viewer the whole
   library to walk again. What it does NOT do is buy another render: it is not
   a page load, and the rule is one render per page load. chFreshMode() has
   already spent this load's slot, so boot() below asks the archive — which,
   with the seen-set now empty, is the entire library. */
function chRestart(){
  if(busy) return;
  chHideEnd();
  chEnded = false;
  chSeen = []; chSeenIdx = new Set();
  chHist = []; chCursor = -1; chOffReel = false;
  chPre.state = 'idle'; chPre.data = null; chPre.promise = null; chPre.q = null;
  chCool();                /* drop the buffered next film too — new session */
  chPreBlocked = false;
  chRender();
  boot();
}

/* a brand new film takes the live edge */
function chCommit(d){
  /* already decoded in the other player? then there is nothing to load and
     nothing to narrate — swap to it and keep playing. */
  if(chFastCut(d)) return;
  chHideEnd();
  chPre.state = 'idle'; chPre.data = null; chPre.promise = null; chPre.q = null;
  chWaiting = false;
  var myGen = ++chGen;
  if(body.getAttribute('data-state') !== 'loading') beginRequest(LINES_CUT, LINES, 2);
  else setBusy(true);
  chRender();
  present(d, 'next').then(function(){
    if(myGen !== chGen) return;
    setBusy(false);
  }, function(err){
    if(myGen !== chGen) return;
    setBusy(false);
    fail(err, boot);
  });
}

/* the commercial break: nothing newer exists, so we hold the air and cut
   back in the moment it lands. BACK still works the whole time. */
function chEnterBreak(){
  if(chWaiting) return;
  chWaiting = true;
  var myGen = ++chGen;
  chPreBlocked = false;                /* the break IS the retry */
  beginRequest(LINES_BREAK_SEED, LINES_BREAK, 25);
  chRender();

  var p = chEnsurePrefetch(true);
  if(!p){ chWaiting = false; setBusy(false); chRender(); return; }

  p.then(function(d){
    if(myGen !== chGen) return;        /* viewer walked out of the break — the
                                          film stays parked in the slot */
    chWaiting = false;
    chCommit(d);
  }, function(err){
    if(myGen !== chGen) return;
    chWaiting = false;
    setBusy(false);
    if(isEndOfReel(err)){ chShowEnd(); return; }
    fail(err, chNext);
  });
}

/* replay something already in the reel — no network, no cache consumed */
function chPlayHistory(idx){
  var e = chHist[idx];
  if(!e) return;
  chHideEnd();
  var myGen = ++chGen;
  chWaiting = false;
  /* if this is how the viewer walked OUT of a break, the fetch it was
     narrating goes back to being a background job and shuts up */
  if(chPre.state === 'inflight' && chPre.q) chPre.q.quiet = true;
  chCursor = idx;
  beginRequest(LINES_REWIND, LINES_REWIND, 2);
  chRender();
  present(e, 'history').then(function(){
    if(myGen !== chGen) return;
    setBusy(false);
  }, function(err){
    if(myGen !== chGen) return;
    setBusy(false);
    chOffReel = false;   /* the one-off is off screen either way now */
    /* a dead link in the reel: drop it rather than keep offering it */
    chHist.splice(idx, 1);
    chCursor = Math.min(Math.max(0, idx - 1), chHist.length - 1);
    chRender();
    fail(err, boot);
  });
}

/* every film that reaches the screen is written into the reel — except one */
function chAfterPresent(mode){
  if(mode === 'history'){ chOffReel = false; chRender(); return; }
  chCool();

  /* A photo film is built from a photograph of a real person, and the photo
     itself is deleted within a day. Writing the film into the reel would put
     its URL in localStorage indefinitely and let anyone at this browser replay
     it long after the source photo was destroyed, which is the exact outcome
     the deletion policy exists to prevent. It is shown once, to the person who
     uploaded the picture, and then it is gone.

     Two independent things identify it, and EITHER is enough:
       mode === 'photo'            the browser called /photo, so the call site
                                   knows first-hand — this cannot drift.
       current.source === 'photo'  the finished job answers source:"photo",
                                   so the server says it too.
     One signal would do. Both are checked because the cost of missing a photo
     film here is a person's likeness sitting in storage, and the cost of the
     extra comparison is nothing. (The prompt is not a concern either way: the
     photo flow returns it empty on purpose, so the written description of the
     person's face never reaches this browser at all.)

     chCursor is left parked on the last real programme so the transport still
     has somewhere honest to go. See chOffReel. */
  if(mode === 'photo' || current.source === 'photo'){
    chOffReel = true;
    chRender();
    chSchedulePrefetch();   /* the channel keeps priming, so NEXT still works */
    return;
  }

  chOffReel = false;
  /* Remember it FOREVER, separately from the reel. This is the record /next
     filters against, so it has to outlive the reel's 50-entry cap — otherwise
     the fifty-first film puts the first one back in the running. Custom, regen
     and photo films carry no library id and simply do not register here. */
  chSeenMark(current.id);
  /* NO PROMPT IS WRITTEN HERE. The reel used to carry the full prompt of
     every film in it, which made the viewer's own history a second copy of the
     thing the API now refuses to hand out. It stores the same REFERENCE the
     live record does, so a re-press from the reel still works. */
  /* source is current.source, not data.source — this runs from
     chAfterPresent(), after adopt() has already normalised it onto
     `current` for whichever mode just landed. Without it, chPlayHistory()
     (below) hands adopt() an entry with no .source at all on a replay,
     which silently resets current.source to '' and drops the ★ USER badge
     the moment a viewer scrubs BACK to their own film — the exact gap the
     badge has to not have. */
  chHist.push({
    id: current.id, jobId: current.jobId,
    videoUrl: current.videoUrl, s3Url: current.s3Url,
    product: current.product, source: current.source,
    oneOff: !!current.oneOff, src: mode, playedAt: Date.now()
  });
  if(chHist.length > CH_MAX) chHist.splice(0, chHist.length - CH_MAX);
  chCursor = chHist.length - 1;
  chRender();
  chSchedulePrefetch();
}

function chOnEnded(){
  if(body.getAttribute('data-state') !== 'playing') return;
  if(busy) return;
  chPreBlocked = false;    /* a film boundary — a failed prefetch gets one more go */
  /* end-of-archive always wins over the gate — there is nothing to keep
     watching FOR, so the end card is the honest thing to show, not a
     "still there?" prompt in front of a channel with nothing left to play. */
  if(chEnded && chCursor >= chHist.length - 1){ chShowEnd(); return; }
  if(!chHist.length){ boot(); return; }
  /* SHARED-LINK END SCREEN OUTRANKS EVERYTHING BELOW IT. Somebody followed a
     link to this exact film; the film has now finished; that is the most
     specific moment on this page and the one the client asked us to act on.
     It is decided before the own-film hold (a shared film may also be the
     viewer's own, and the link is why they are here) and before
     autoAdvanceCount is touched at all — a viewer looking at three explicit
     choices is not an unattended auto-advance, so the tally must not move.

     chShareHoldFilm() is false on the ordinary channel, so on the homepage
     this line is a single comparison that fails and the code below runs
     exactly as it always has. */
  if(chShareHoldFilm()){ chShowShareHold(); return; }
  /* OWN-VIDEO HOLD outranks the still-watching gate: a film this visitor
     commissioned just finished, which is a more specific and more relevant
     moment than a plain unattended-autoplay check, so it is decided first
     and does not itself add to autoAdvanceCount — the tally is for
     UNATTENDED auto-advances, and a viewer now looking at an explicit
     choice is not that, regardless of which button they pick next. */
  if(current.own){ chShowOwnHold(); return; }
  autoAdvanceCount++;
  if(autoAdvanceCount >= STILL_WATCHING_LIMIT){ chShowStillWatching(); return; }
  chNext();
}

/* Twenty in a row, untouched. Pause on the last frame and crossfade back to
   the brand still — reusing .layer-brand/data-state exactly as the video
   layer already does, not a second overlay mechanism. The reel itself
   (chHist/chCursor) is never touched, so BACK still walks history correctly
   whether the viewer resumes or wanders off from here. */
function chShowStillWatching(){
  if(chGateIsShowing()) return;
  try{ video.pause(); }catch(e){}
  setState('idlecheck');
  setStatus('Checking you\u2019re still there');
  chRender();
  if(gateResumeBtn){ try{ gateResumeBtn.focus(); }catch(e){} }
}

/* Resuming means continuing the CHANNEL, not rewinding the film that just
   finished — there is nothing left to replay in a video that already ended.
   chNext() picks up exactly where the frontier rule always would have. */
function chResumeFromGate(){
  if(!chGateIsShowing()) return;
  autoAdvanceCount = 0;
  if(chEnded && chCursor >= chHist.length - 1 && !chOffReel){ chShowEnd(); return; }
  chNext();
}

/* ── OWN-VIDEO HOLD ───────────────────────────────────────────────────────
   The visitor's own commissioned film (question form or photo upload) just
   ended. Reuses the still-watching gate's exact mechanism one rung up in
   chOnEnded()'s priority order: pause on the last frame, crossfade to the
   brand still via the SAME data-state-keyed layer machinery (own dedicated
   value, "ownhold", so the video layer's opacity rule needs no new case),
   and ask instead of rolling on. The reel (chHist/chCursor) is never
   touched, so both BACK and a normal advance out of this still land where
   the frontier rule always says they should. */
function chOwnHoldIsShowing(){ return body.getAttribute('data-state') === 'ownhold'; }

function chShowOwnHold(){
  if(chOwnHoldIsShowing()) return;
  try{ video.pause(); }catch(e){}
  setState('ownhold');
  setStatus('That one was yours');
  chRender();
  /* The hold is where somebody actually reaches for Share, so re-ask here
     rather than trusting that the id landed before the film finished. Costs
     one class toggle when nothing has changed. */
  shareRefresh();
  /* Focus the FIRST action, which is now Repeat — the same rule both other
     cards follow, so a keyboard visitor lands on the choices rather than
     hunting for them. */
  if(ownHoldRepeatBtn){ try{ ownHoldRepeatBtn.focus(); }catch(e){} }
  else if(ownHoldContinueBtn){ try{ ownHoldContinueBtn.focus(); }catch(e){} }
}

/* REPEAT — replay THIS film, the one still paused on its last frame behind the
   card. Byte-for-byte the shared-link card's own Repeat, one state along: no
   fetch, no reload, no /next — rewind the element that is already holding the
   frame and start it again. THE REEL IS NOT TOUCHED, so BACK and NEXT still
   mean what the frontier rule says they mean afterwards.

   Going back to "playing" is what re-arms chOnEnded(), which early-returns on
   every other state. current.own is still true, so when the film ends a second
   time the hold comes straight back — which is exactly what somebody who
   pressed Repeat is asking for, and it can be pressed as many times as they
   like without ever reaching the network. */
function chRepeatFromOwnHold(){
  if(!chOwnHoldIsShowing()) return;
  chNoteInteraction();
  shareClose(false);
  setState('playing');
  chRender();
  try{ video.currentTime = 0; }catch(e){}
  play();
}

/* KEEP WATCHING — continues the CHANNEL from here, exactly like the
   still-watching gate's own resume: autoAdvanceCount clears (a deliberate
   click is not an unattended auto-advance) and chNext() takes the frontier
   rule's normal next step. It cannot commission a render: the page's one fresh
   slot is spent on the very first film of the load, and chFreshMode() answers
   "archive" to everything after it — this path included. */
function chContinueFromOwnHold(){
  if(!chOwnHoldIsShowing()) return;
  autoAdvanceCount = 0;
  if(chEnded && chCursor >= chHist.length - 1 && !chOffReel){ chShowEnd(); return; }
  chNext();
}

/* MAKE ANOTHER ONE IS GONE FROM THIS CARD. The client replaced the two
   actions that used to live here with "repeat, next, and the live / share
   button", and this was the second of the two. Nothing else called
   chMakeAnotherFromOwnHold(), so the function went with the button rather than
   being left behind as an unreachable path back to the form. The MAKE YOURS
   row underneath the hold is still the way to commission another one, and it
   is still reachable: the hold card is pointer-events:none apart from the card
   itself, exactly like the two gates it is built on. */

/* ── SHARED-LINK END SCREEN ───────────────────────────────────────────────
   The client, verbatim: "when the video is done playing, their options should
   be the share button, repeat button, see more button that then takes you to
   the website."

   Built on the own-video hold's exact mechanism one state along: a dedicated
   data-state, the same .err/.gatecard card skin, the same non-blocking layer
   wrapper. The ONE difference is that this state keeps .layer-video up rather
   than crossfading to the brand still, so the film holds on its final frame
   behind the buttons — see the body[data-state="sharehold"] rules.

   THE HOMEPAGE CHANNEL IS COMPLETELY UNAFFECTED. chShareHoldFilm() returns
   false unless the visitor arrived on a link that named a film AND that same
   film is what is on screen, so on the channel none of this ever runs and the
   auto-advance is byte-for-byte the behaviour it was before. */
function chShareHoldIsShowing(){ return body.getAttribute('data-state') === 'sharehold'; }

/* True only while the film the shared link NAMED is the film on screen.
   Pinned to the id rather than being a session-wide boolean, so pressing
   NEXT out of the landing view drops straight into the ordinary channel and
   never sees this screen again, while Repeat (same film) shows it again. */
function chShareHoldFilm(){
  return !!(SHARE_FILM_ID && current && current.id &&
            String(current.id) === String(SHARE_FILM_ID));
}

function chShowShareHold(){
  if(chShareHoldIsShowing()) return;
  /* pause rather than letting it loop or blank: the last decoded frame stays
     on screen, which is what the video layer keeps showing while paused */
  try{ video.pause(); }catch(e){}
  setState('sharehold');
  setStatus('That one\u2019s the end of the link');
  setReadout('SHARED FILM');
  chRender();
  /* Focus the first action so a keyboard visitor lands ON the choices rather
     than having to hunt for them, matching what both gates already do. */
  if(shareHoldShareBtn){ try{ shareHoldShareBtn.focus(); }catch(e){} }
}

/* SHARE — opens the menu that already exists. There is exactly ONE share menu
   on this page and this is not a second one: it opens #sharePop, the same
   popup the pill's own Share button opens, with the same targets, the same
   native OS sheet and the same "send the video" item. shareSetOpen() also
   re-syncs every href from shareLink() on open, so the link it hands out is
   the one for the film still on screen. */
function chShareFromHold(){
  if(!chShareHoldIsShowing()) return;
  shareSetOpen(true);
}

/* REPEAT — replay THIS film. Not chNext(), not a reload: rewind the element
   that is already holding the last frame and start it again. The reel
   (chHist/chCursor) is untouched, so BACK and NEXT still mean exactly what
   the frontier rule says they mean afterwards. Returning to "playing" is what
   re-arms chOnEnded, which early-returns on any other state — so when this
   film ends a second time the end screen comes back, which is the behaviour
   somebody pressing Repeat is asking for. */
function chRepeatFromHold(){
  if(!chShareHoldIsShowing()) return;
  chNoteInteraction();
  shareClose(false);
  setState('playing');
  chRender();
  try{ video.currentTime = 0; }catch(e){}
  play();
}

/* SEE MORE — the client's "takes you to the website". The STOREFRONT, which
   is a different place from this player: drinkblackmarket.com is the Shopify
   shop and does not serve this channel. A real navigation, so Back returns
   them to the film they were just watching. */
var SHARE_HOLD_MORE_URL = 'https://drinkblackmarket.com';
function chMoreFromHold(){
  if(!chShareHoldIsShowing()) return;
  chNoteInteraction();
  location.href = SHARE_HOLD_MORE_URL;
}

/* ── CONTROLS ──────────────────────────────────────────────────────────── */
/* OFF-REEL TRANSPORT. While a one-off is on screen it is not in the reel and
   the cursor still points at the last real programme, so:
     BACK  steps OUT of the one-off and replays that programme — the cursor
           itself, not cursor-1. Stepping back one MORE would silently skip the
           very film the viewer is trying to get back to. It only needs the
           reel to be non-empty, not the cursor to be off zero, because even
           the first entry is somewhere real to land.
     NEXT  behaves exactly as it does at the live edge, which is where the
           cursor already is: play the held film, or take the break. It stays
           available with an empty reel, because "go get me a real programme"
           is still a truthful thing for it to do. */
function chCanBack(){
  if(chOffReel) return chHist.length > 0 && (!busy || chWaiting);
  return chCursor > 0 && (!busy || chWaiting);
}
function chCanNext(){
  if(chWaiting || busy) return false;
  /* at the live edge with the archive spent, NEXT has nowhere honest to go */
  if(chEnded && chCursor >= chHist.length - 1 && !chOffReel) return false;
  return chHist.length > 0 || chOffReel;
}

function chBack(){
  if(!chCanBack()) return;
  chPlayHistory(chOffReel ? chCursor : chCursor - 1);
}

function chNext(){
  if(!chCanNext()) return;
  /* 1. behind the edge — a seek through films already seen */
  if(chCursor < chHist.length - 1){ chPlayHistory(chCursor + 1); return; }
  /* 2. at the edge, one held and ready — play it now */
  if(chPre.state === 'ready' && chPre.data){ chCommit(chPre.data); return; }
  /* 3. at the edge with the archive spent — say so, rather than taking a break
        for material that is not coming inside this session */
  if(chEnded){ chShowEnd(); return; }
  /* 4. at the edge, nothing held yet — take the break, cut back in by itself */
  chEnterBreak();
}

function chTogglePlay(){
  if(body.getAttribute('data-state') !== 'playing') return;
  if(video.paused) play(); else { try{ video.pause(); }catch(e){} }
  chRender();
}

function chTapeLabel(){
  return (chCursor >= chHist.length - 1) ? 'LIVE'
       : 'REPLAY ' + (chCursor + 1) + '/' + chHist.length;
}

function chRender(){
  if(!tpBack) return;
  var atEdge = chCursor >= chHist.length - 1;
  var seen   = chHist.length;
  var state  = body.getAttribute('data-state');
  var canBack = chCanBack(), canNext = chCanNext();

  tpBack.disabled = !canBack;
  tpNext.disabled = !canNext;
  tpPlay.disabled = state !== 'playing';

  var paused = video.paused;
  if(tpPlayPath) tpPlayPath.setAttribute('d', paused ? ICON_PLAY : ICON_PAUSE);
  tpPlay.setAttribute('aria-label', paused ? 'Play' : 'Pause');
  tpPlay.title = (paused ? 'Play' : 'Pause') + '  ·  space';

  /* off-reel is neither LIVE nor a position in the reel — it is not IN the
     reel — so it says what it actually is rather than borrowing either label */
  /* the LIVE dot is a claim that more is still coming. At the end of the reel
     nothing is, so the chip says END and the dot goes out rather than lying. */
  var atEnd = chEnded && atEdge && !chOffReel;
  var isLiveEdge = !chOffReel && !atEnd && seen && atEdge;
  var baseLabel = chOffReel ? 'ONE OFF'
                : atEnd ? 'END'
                : seen ? (atEdge ? 'LIVE' : (chCursor + 1) + ' / ' + seen) : '—';

  /* ══ PILL CONTENT PRECEDENCE ══════════════════════════════════════════
     Three things can want this one pill. The order is fixed here, in the
     order they are written below, on purpose — so a later edit has to move
     code out of this order to invert it, rather than accidentally doing so
     by adding a branch in the wrong place:
       1. still-watching gate's "More?" — INTERACTIVE. Wins outright while
          the gate is showing. Written LAST below, unconditionally
          overwriting whatever 2/3 produced (chRender() runs on every
          relevant transition, so this self-corrects the instant the gate
          drops — no separate cleanup path to forget).
       2. ★ USER badge — INFORMATIONAL. Shows whenever current.source is
          'custom' for the film actually on screen, full stop — client:
          "every time a UGC video is playing", regardless of how the viewer
          got there (live edge, a BACK replay, a one-off that just
          finished). No longer gated on isLiveEdge.
       3. position/LIVE/ONE OFF/END readout (baseLabel) — INFORMATIONAL,
          ALWAYS computed. Client: "do not simply throw it away" — a replay
          position is real information. Rather than 2 replacing 3, they
          COEXIST in the one pill: "★ USER · <baseLabel>". Chosen over a
          second floating element because the transport row is tightest on
          a phone, where .tp-note is already the exact width of its own
          content — one pill that grows by a few characters costs nothing
          the row does not already have; a second chip beside it would need
          its own collision math against Share sitting right above. baseLabel
          is dropped from the combination only when it is the placeholder
          "—", which carries no information worth adding. */
  /* CLIENT, LATEST: "I want LIVE to be replaced with USER when it's a user
     video. Don't show both. (Even on desktop)". USER now REPLACES the label
     outright instead of prefixing it — the "USER · LIVE" pair this used to
     build is gone at every width, desktop included.

     THE STAR STAYS — the client asked for it back explicitly after seeing it
     go. What was removed is the " · LIVE" tail, not the glyph, so the badge
     reads "* USER" and its styling is untouched.

     WHAT DECIDES IT IS current.source === 'custom' — a UGC film — and NOT
     current.own, and the difference is deliberate. `own` is true only for the
     film THIS visitor just commissioned and is what gates the own-film hold;
     `source === 'custom'` is true for any visitor-made film on screen,
     including one reached by pressing BACK, which is what the client asked
     for when they said the badge should show "every time a UGC video is
     playing". Keying the badge to `own` would silently drop it on a replay.

     THE POSITION READOUT IS NOT LOST, only un-COMBINED. A channel film still
     reads LIVE / "2 / 5" / ONE OFF / END exactly as before; only the user
     badge now stands alone. */
  var isUserBadge = current.source === 'custom';
  /* CLIENT: "I want to keep the star". So the badge is the glyph plus the
     word and nothing else — the " · LIVE" tail is what was dropped, not the
     star, and the star's own markup and styling are byte-for-byte what they
     were. innerHTML for that branch because the star is an inline <svg>;
     textContent for every other, so a label can never carry markup. */
  if(isUserBadge) tpPos.innerHTML = ICON_STAR_BADGE + 'USER';
  else            tpPos.textContent = baseLabel;
  tpPos.className = 'tp-pos' + (isUserBadge ? ' is-badge' : (isLiveEdge ? ' is-live' : ''));

  /* ── A THIRD, NON-RESTING STATE: LOADING ───────────────────────────────
     While a render is in flight the badge stops being a label and becomes the
     page's loading indicator — violet liquid sloshing in a clear pill, drawn
     entirely in CSS off this class (see .is-rendering .tp-pos in the
     stylesheet). THE TEXT IS LEFT IN PLACE and only painted transparent
     there, which is what makes the swap cost zero layout: the box is still
     sized by exactly the glyphs that sized it before.

     Because the text is still in the accessibility tree, it would still be
     read — and "LIVE" is a lie while a film is being made. So the accessible
     name is overridden for precisely that window and cleared again the moment
     it closes. enterRendering()/exitRendering() both call chRender(), so this
     can never be left describing a state the page has already left. */
  var loadingBadge = body.classList.contains('is-rendering');

  var gateUp = chGateIsShowing();
  tpPos.disabled = !gateUp;
  if(loadingBadge){
    /* the liquid is decorative; this is the only thing that says what it is */
    tpPos.setAttribute('aria-label', 'Loading \u2014 your film is being made');
  } else if(gateUp){
    /* the gate wins outright, overwriting whatever the badge produced above */
    tpPos.textContent = 'More?';
    tpPos.className = 'tp-pos is-action';
    tpPos.setAttribute('aria-label', 'Play the next film');
  } else if(isUserBadge){
    /* four terse uppercase letters; this says what they mean */
    tpPos.setAttribute('aria-label', 'Your film');
  } else {
    tpPos.removeAttribute('aria-label');
  }

  /* The note exists so that no control ever lies about what it will do. It
     answers BACK's disabled state and NEXT's next move in the same breath,
     because those are the only two questions this bar can raise. */
  var why = [], key;
  if(chEnded && atEdge && !chOffReel){
    key = 'end';
    why.push('That is every one we had tonight — BACK to replay, or start over');
  } else if(chWaiting){
    key = 'break';
    why.push('Short break — still rendering. It starts on its own');
  } else if(busy){
    key = 'busy';
    why.push('Hold on — a render is on its way');
  } else if(chOffReel){
    key = 'oneoff';
    /* the one control that would otherwise lie: BACK is lit, but it does not
       go back a step — it leaves the one-off. Say so. */
    why.push('Yours alone — not saved to your reel');
    if(canBack)                         why.push('BACK returns to the channel');
    if(chPre.state === 'ready')         why.push('Next one is loaded and ready');
    else if(chPre.state === 'inflight') why.push('Next one is still coming in');
  } else {
    if(chCursor <= 0) why.push(seen <= 1 ? 'First one of the night' : 'Start of your reel');
    if(!atEdge){
      key = 'replay';
      why.push('Replaying ' + (chCursor + 1) + ' of ' + seen + ' — forward to catch up');
    } else if(chPre.state === 'ready'){
      key = 'ready';
      /* the payload landing and the BYTES landing are different events, and
         only the second one makes the next cut instant — so say which it is */
      why.push(chPre.warmReady ? 'Next one is loaded and buffered — it cuts straight in'
                               : 'Next one is loaded and ready');
    } else if(chPre.state === 'inflight'){
      key = 'incoming';
      why.push('Next one is still coming in');
    } else {
      /* nothing held behind it yet: the very first film of the night reads as
         a beginning, anything later reads as the live edge */
      key = (seen <= 1 && chCursor <= 0) ? 'start' : 'edge';
      why.push('You are at the live edge');
    }
  }
  /* still the full sentence, still in the accessibility tree, still what
     aria-describedby on BACK and NEXT resolves to — just no longer painted */
  tpWhy.textContent = why.join(' · ');
  paintTpIcon(key || 'edge', why.join(' · '));

  tpBack.title = !canBack  ? 'Start of your reel'
               : chOffReel ? 'Back to the channel  ·  ←'
                           : 'Back  ·  ←';
  tpNext.title = chWaiting ? 'Waiting on the next render'
               : !atEdge   ? 'Forward  ·  →'
               : (chPre.state === 'ready' ? 'Next up — ready  ·  →'
                                          : 'Next up — may need a short break  ·  →');
}

function chInit(){
  chPurgeLegacyStorage();
  /* the seen-list has to be in chSeen/chSeenIdx before boot()'s getNext()
     builds its first exclude list — hydrate here, synchronously, ahead of
     that call. See chSeenHydrate() for the corrupt/missing-data fallback. */
  chSeenHydrate();
  if(endRewindBtn) endRewindBtn.addEventListener('click', chBack);
  if(endAgainBtn)  endAgainBtn.addEventListener('click', chRestart);
  if(gateResumeBtn) gateResumeBtn.addEventListener('click', chResumeFromGate);
  if(ownHoldRepeatBtn) ownHoldRepeatBtn.addEventListener('click', chRepeatFromOwnHold);
  if(ownHoldContinueBtn) ownHoldContinueBtn.addEventListener('click', chContinueFromOwnHold);
  if(shareHoldShareBtn)  shareHoldShareBtn.addEventListener('click', chShareFromHold);
  if(shareHoldRepeatBtn) shareHoldRepeatBtn.addEventListener('click', chRepeatFromHold);
  if(shareHoldMoreBtn)   shareHoldMoreBtn.addEventListener('click', chMoreFromHold);
  if(!tpBack) return;
  /* clicking/tapping any transport control is a present human — note it
     before the control's own action runs, in the same click. chNoteInteraction
     only clears the counter; it is the control's own existing logic (which
     already drives data-state) that gets the gate off screen when one of
     these fires while it happens to be showing. */
  tpBack.addEventListener('click', function(){ chNoteInteraction(); chBack(); });
  tpNext.addEventListener('click', function(){ chNoteInteraction(); chNext(); });
  /* STILL-WATCHING GATE — the pill is a real (if usually disabled) <button>;
     a disabled button never dispatches click, so this is a no-op outside
     the gate and chResumeFromGate()'s own chGateIsShowing() guard makes it
     safe even if that ever stopped being true. */
  if(tpPos) tpPos.addEventListener('click', chResumeFromGate);
  tpPlay.addEventListener('click', function(){ chNoteInteraction(); chTogglePlay(); });
  /* Bound to BOTH players, because either can be the live one. Each listener
     ignores the player that is not currently lit, so a standby element
     buffering (or being torn down) can never be mistaken for the programme
     ending, starting or pausing. This is what lets `video` be swapped at all. */
  films.forEach(function(v){
    v.addEventListener('ended', function(e){ if(e.target !== video) return; chOnEnded(); });
    v.addEventListener('play',  function(e){ if(e.target !== video) return; chRender(); });
    v.addEventListener('pause', function(e){ if(e.target !== video) return; chRender(); });
  });
  chRender();
}

/* ── PHONE FOLDS ───────────────────────────────────────────────────────────
   One remaining disclosure — MAKE YOURS — shut on arrival (the class ships
   in the markup, see <body>). The copy block's own fold is gone: the client
   wants the headline and product line always visible, so there is nothing
   left to toggle there. Above 760px the class selects nothing, the button is
   display:none and none of this has any effect — desktop keeps every block
   visible exactly as before. */
function foldInit(btn, cls){
  if(!btn) return;
  btn.addEventListener('click', function(){
    var shut = body.classList.toggle(cls);   /* true once ADDED, i.e. now shut */
    btn.setAttribute('aria-expanded', shut ? 'false' : 'true');
    var lbl = btn.getAttribute(shut ? 'data-shut-label' : 'data-open-label');
    if(lbl) btn.setAttribute('aria-label', lbl);
    /* opening a fold is a person doing something — it resets the gate counter
       exactly like any other deliberate interaction on the page */
    chNoteInteraction();
  });
}
foldInit(formToggle, 'm-form-shut');

/* ── THE TWO PILL TOGGLES ──────────────────────────────────────────────────
   Both live inside .tp-note and are display:none above 760px, so everything
   below is inert on desktop even though it is wired unconditionally — one code
   path, no matchMedia to keep in step with the stylesheet's own breakpoint.

   SHOW THE CONTROLS (#tpCtl) — the client wants the back/play/next cluster off
   the film by default and revealed on tap. NOT PERSISTED: "default state
   hidden" is the whole point of the change, so every page load starts clean
   with the film unobstructed rather than restoring somebody's tap from last
   week. The class is the only state; the stylesheet decides what it means, and
   the own-film hold's own rule outranks it there so the two never fight over
   the same three buttons.

   THE KEYS ARE UNAFFECTED. Space / left / right are bound to the document and
   gated only on the channel being in view, never on this cluster being
   painted — so a hidden cluster is a hidden cluster, not a disabled one.

   FIT TO SCREEN (#tpFit) — cover (the default, cropped) vs contain (the whole
   16:9 frame, letterboxed). PERSISTED to localStorage, so it survives both an
   advance to the next film and a reload: it is a statement about how this
   visitor wants to watch, not a per-film choice, and having to re-set it after
   every reload would be the annoying half of a preference. It is one class on
   the root, which is what makes it land on BOTH <video> elements at once —
   the channel alternates them for seamless cuts, so a per-element toggle would
   silently snap back to cover on the next film. Wrapped in try/catch because
   Safari's private mode throws on localStorage rather than returning null. */
var CH_FIT_KEY = 'bm.tv.fit.v1';

function chSetCtlOpen(on){
  body.classList.toggle('is-ctl-open', !!on);
  if(tpCtl){
    tpCtl.setAttribute('aria-pressed', on ? 'true' : 'false');
    tpCtl.setAttribute('aria-label', on ? 'Hide the playback controls'
                                        : 'Show the playback controls');
    tpCtl.title = on ? 'Hide the controls' : 'Show the controls';
  }
}

var chPlaceControls = null;   /* set by the relocation block further down */

function chSetFit(on, persist){
  body.classList.toggle('is-fit', !!on);
  /* the transport cluster lives in a different parent in each mode */
  if(chPlaceControls) chPlaceControls();
  if(tpFit){
    tpFit.setAttribute('aria-pressed', on ? 'true' : 'false');
    tpFit.setAttribute('aria-label', on ? 'Fill the screen with the film'
                                        : 'Fit the whole film on screen');
    tpFit.title = on ? 'Zoomed out — whole frame' : 'Fit the whole film on screen';
  }
  if(persist){
    var st = chStore();
    if(st){ try{ on ? st.setItem(CH_FIT_KEY, '1') : st.removeItem(CH_FIT_KEY); }catch(e){} }
  }
}

(function(){
  var st = chStore(), saved = false;
  if(st){ try{ saved = st.getItem(CH_FIT_KEY) === '1'; }catch(e){} }
  chSetCtlOpen(false);
  chSetFit(saved, false);
  if(tpCtl) tpCtl.addEventListener('click', function(){
    chNoteInteraction();
    chSetCtlOpen(!body.classList.contains('is-ctl-open'));
  });
  if(tpFit) tpFit.addEventListener('click', function(){
    chNoteInteraction();
    chSetFit(!body.classList.contains('is-fit'), true);
  });
})();

/* ── WHICH OF THE TWO DOCK PIECES GOES UP TOP ON A PHONE ───────────────────
   THE TWO HAVE TRADED PLACES. This block used to lift the LIVE/Share pill
   (.tp-note) out of the dock and into .hero-copy on a phone. The client has
   since asked for the opposite arrangement, in his own words: "the pill with
   icons needs to move down to where the controls were to save space" and
   "have the controls show up on top when shown (where you have the pill
   now)". So on a phone it is now the TRANSPORT CLUSTER (.tpgroup) that is
   lifted, and the pill simply stays where the markup already puts it — in the
   dock, between MAKE YOURS and the mute button.

   WHY THE PILL HAD ITS OWN ROW AT ALL, AND WHY GIVING IT UP IS SAFE. It was
   moved up there because sitting beside the copy in a two-column row left the
   headline only ~220px at 360px wide, which is what wrapped "OWN THE NIGHT"
   and "ELEVATE EVERY EXPERIENCE" onto two lines. What fixed that was the COPY
   GETTING THE FULL GUTTER-TO-GUTTER SPAN, not the pill being above it — and
   the copy keeps that span here, because the cluster that replaces the pill up
   top is on its own row too, not in a column beside it.

   IT IS THE SAME NODE, MOVED, NEVER CLONED — so #tpBack/#tpPlay/#tpNext keep
   their ids, chRender() keeps writing to the elements it always has, and the
   aria-describedby wiring keeps resolving. appendChild is used because
   .hero-copy .tpgroup is placed by explicit CSS Grid coordinates, not by
   source order, so where among .hero-copy's children it lands makes no visual
   difference.

   NOTHING HERE DECIDES WHETHER THE CLUSTER IS VISIBLE. That stays entirely
   with #tpCtl and the data-state rules in the stylesheet: hidden by default on
   a phone, shown while .is-ctl-open is set, and gone outright during the
   own-film hold whatever the toggle says. This only decides WHERE it is when
   it is shown. */
(function(){
  var dock = BMVH_ROOT.querySelector('.tvbar');
  var grp  = BMVH_ROOT.querySelector('.tpgroup');
  var note = BMVH_ROOT.querySelector('.tp-note');
  var copy = BMVH_ROOT.querySelector('.hero-copy');
  var snd  = soundBtn;
  var hero = BMVH_ROOT.querySelector('.hero');
  var shareW = BMVH_ROOT.querySelector('.share-wrap');
  if(!dock || !grp || !copy || !hero || !window.matchMedia) return;
  var phone = window.matchMedia('(max-width:760px)');
  /* WHERE THE CLUSTER LIVES ON A PHONE DEPENDS ON THE FIT MODE, and it has to
     be a real move rather than a CSS offset. In 16:9 the client wants the
     controls over the film's bottom-right corner, which is well ABOVE
     .hero-copy — and .hero-copy is overflow:hidden, so a child positioned up
     there is clipped out of existence. (It was: the box measured correctly at
     the right coordinates and painted nothing, because the parent cropped it.)
     Re-parenting to .hero instead puts it in a box that actually contains the
     film, and drops the two workarounds the clipped version needed — the
     --copytop correction and the grid-area release — because .hero's padding
     box IS the coordinate space the film's geometry is written in. */
  function place(){
    if(phone.matches){
      var host = body.classList.contains('is-fit') ? hero : copy;
      if(grp.parentNode !== host) host.appendChild(grp);
      /* CLIENT: "add the sound toggle into the pill". Into .tp-note, ahead of
         .share-wrap — which is position:absolute under 761px and therefore out
         of flow, so "ahead of it" is a source-order statement about the tab
         sequence, not a visual one. Sound ends up the last VISIBLE item in the
         pill, after the two toggles.
         MOVED ONLY ON A PHONE, for the same reason the cluster is: above 760px
         the dock has room and the client's instruction was about the mobile
         view, so desktop keeps the button exactly where it has always been. */
      if(snd && snd.parentNode !== note && note){
        note.insertBefore(snd, shareW && shareW.parentNode === note ? shareW : null);
      }
    }else{
      if(grp.parentNode !== dock){
        /* back to its markup position: after MAKE YOURS, before the pill */
        dock.insertBefore(grp, note && note.parentNode === dock ? note : null);
      }
      /* and sound back to ITS markup position: the dock, after the pill */
      if(snd && snd.parentNode !== dock) dock.appendChild(snd);
    }
  }
  place();
  /* the fit toggle changes the answer, so it re-asks — see chSetFit() */
  chPlaceControls = place;
  if(phone.addEventListener) phone.addEventListener('change', place);
  else if(phone.addListener) phone.addListener(place);
})();

/* ── BUY NOW, UNDER THE HEADLINE (DESKTOP) ─────────────────────────────────
   CLIENT: move BUY NOW from under the transport dock to directly under
   "OWN THE NIGHT". Same relocation technique as the LIVE chip right above —
   moved, never cloned, so #buyNowLink keeps its id/href and every existing
   selector (the render strip-back rule, chNoteInteraction's click listener)
   keeps resolving exactly as before. At 1321px+ (this file's own
   desktop/tablet split — see the tablet .makerow media query) .cta is
   inserted into the copy column, right after the product line and before
   the body copy; the .hero-copy .cta CSS rule (CTA ROW, above) resizes it
   once it lands there. Below that it reverts to its proven spot after the
   transport dock — this never touches tablet (761-1320px) or phone.
   Moving the actual node, not just its CSS order, is what keeps keyboard
   tab order following the new visual order: `order` alone would not. */
(function(){
  var ctaHero = BMVH_ROOT.querySelector('.hero');
  var wrap = BMVH_ROOT.querySelector('.cta');
  /* SCOPED TO THE HERO. There are two .hero-product elements now — the panel's
     own line and the make-row heading, which reuses the class for its type.
     Both of these lookups want the hero one. It happens to come first in the
     DOM so a bare querySelector still finds it, but this is the node the BUY
     button gets re-parented against; leaving it to document order would make
     a future markup move silently relocate the button into the make-bar. */
  var product = BMVH_ROOT.querySelector('.hero-copy .hero-product');
  var form = BMVH_ROOT.querySelector('.makebar');
  if(!wrap || !product || !product.parentNode || !form || !ctaHero || !window.matchMedia) return;
  var host = product.parentNode;   /* #copyFold's inner flow container */
  var tag = BMVH_ROOT.querySelector('.hero-tag');
  var desktop = window.matchMedia('(min-width:1321px)');
  function placeCta(){
    if(desktop.matches){
      if(wrap.parentNode !== host) host.insertBefore(wrap, tag && tag.parentNode === host ? tag : null);
    }else if(wrap.parentNode !== ctaHero){
      ctaHero.insertBefore(wrap, form);
    }
  }
  placeCta();
  if(desktop.addEventListener) desktop.addEventListener('change', placeCta);
  else if(desktop.addListener) desktop.addListener(placeCta);
})();

/* ──────────────────────────────────────────────────────────────
   DEMO TRANSPORT
   ────────────────────────────────────────────────────────────── */
/* a queued render, poll by poll: the line advances, then it goes on the machine */
var DEMO_QUEUE = [
  { ok:true, status:'queued',  position:2, etaSeconds:34 },
  { ok:true, status:'queued',  position:1, etaSeconds:19 },
  { ok:true, status:'running',            etaSeconds:11 },
  { ok:true, status:'running',            etaSeconds:5  }
];
var demoQueueHits = 0;
var demoEmptyHits = 0, demoStatusHits = 0;
/* alternates the plain ?demo=1 channel between campaign and custom sources
   so the USER-MADE badge (see chRender()) — and the campaign-custom-campaign
   round trip it has to survive — can be exercised and demoed same as every
   other state here, without a single real render. */
var demoNextIdx = 0;

/* ?demo=tv — a whole channel offline. Five distinct programmes so BACK and
   NEXT are visibly moving through DIFFERENT films, and the fourth one is
   deliberately not rendered yet: reaching the live edge there forces the
   commercial break, ETA and all, without burning a single real render. */
var DEMO_TV = [
  { id:'tv-1011', product:'5mg'  },
  { id:'tv-1012', product:'10mg' },
  { id:'tv-1013', product:'5mg'  },
  { id:'tv-1014', product:'20mg' },
  { id:'tv-1015', product:'10mg' }
];
/* a longer line than the generic queue demo, so the break is properly visible */
var DEMO_TV_QUEUE = [
  { ok:true, status:'queued',  position:3, etaSeconds:52 },
  { ok:true, status:'queued',  position:2, etaSeconds:38 },
  { ok:true, status:'queued',  position:1, etaSeconds:22 },
  { ok:true, status:'running',            etaSeconds:14 },
  { ok:true, status:'running',            etaSeconds:6  }
];
var demoTvIdx = 0;
function demoTvProgramme(){
  var p = DEMO_TV[demoTvIdx % DEMO_TV.length];
  demoTvIdx++;
  return { ok:true, id:p.id, videoUrl:DEMO_MP4, s3Url:DEMO_MP4,
           product:p.product,
           cacheRemaining: Math.max(0, 4 - (demoTvIdx % 5)) };
}

function demoPost(url, bodyObj){
  var isStatus = url === API.status;
  var isCustom = url === API.custom;
  var isRegen  = url === API.regen;
  var isJob    = url === API.job;
  var isTv      = (DEMO === 'tv');
  var queueDemo = (DEMO === 'queued' || DEMO === 'queuefail');
  /* delays mirror the measured live latencies; a queued answer is instant */
  var delay = isJob ? 120
            : (isStatus ? 700
            : (queueDemo ? 400
            : (isCustom ? 30000 : (isRegen ? 7800 : (isTv ? 900 : 500)))));

  /* THE DEEP LINK, OFFLINE. /next carrying an `id` is the deep-link lookup
     (see chDeepLink) and the demo channel answers it the way the API does, so
     ?v= can be exercised — resolving, refused, and malformed — without a page
     load that commissions a render. Two reserved ids stand in for the two
     refusals the live API gives, which are byte-identical to each other there
     and are byte-identical here: 4040 is "no such video", 9999 is a muted or
     photo row. Everything else resolves. */
  var isNext = (url === API.next);
  var deepId = (isNext && bodyObj && bodyObj.id != null) ? String(bodyObj.id) : '';
  if(deepId){
    return sleep(300).then(function(){
      if(deepId === '4040' || deepId === '9999'){
        return { ok:false, notFound:true, error:'that video is not available',
                 code:'video_not_found' };
      }
      return { ok:true, id:deepId, videoUrl:DEMO_MP4, s3Url:DEMO_MP4,
               product:'10mg', source:(deepId === '432' ? 'custom' : 'campaign'),
               fresh:false, mode:'direct' };
    });
  }

  return sleep(delay).then(function(){
    if(DEMO === 'error' && !isStatus) throw new AppError('Demo failure path.', 'DEMO — forced error');

    if(isTv && isJob){
      var tvStep = DEMO_TV_QUEUE[demoQueueHits++];
      if(tvStep) return tvStep;
      var done = demoTvProgramme();
      done.status = 'done';
      return done;
    }
    if(isTv && !isStatus && !isCustom && !isRegen){
      /* every fourth programme has not been rendered yet, so the demo channel
         goes to a real commercial break — queue position, ETA and all — on a
         rhythm you can actually sit and watch */
      if(demoTvIdx % 4 === 3){
        demoQueueHits = 0;
        return { ok:true, queued:true, jobId:'demo-tv-job', position:4, etaSeconds:58 };
      }
      return demoTvProgramme();
    }

    if(isJob){
      var step = DEMO_QUEUE[demoQueueHits++];
      if(step) return step;
      if(DEMO === 'queuefail'){
        return { ok:false, status:'failed', error:'fal returned no video',
                 code:'render_failed' };
      }
      return { ok:true, status:'done', videoUrl:DEMO_MP4, s3Url:DEMO_MP4,
               id:'demo-q-88', product:'10mg' };
    }
    if(queueDemo && !isStatus){
      demoQueueHits = 0;
      return { ok:true, queued:true, jobId:'demo-job-77', position:3, etaSeconds:48 };
    }

    if(isStatus){
      demoStatusHits++;
      return { ok:true, ready: demoStatusHits >= 2 ? 1 : 0, target:5, rendering:1 };
    }
    if(isCustom){
      return { ok:true, videoUrl:DEMO_MP4, s3Url:DEMO_MP4,
               jobId:'demo-custom-42' };
    }
    if(isRegen){ return { ok:true, videoUrl:DEMO_MP4, s3Url:DEMO_MP4 }; }

    if(DEMO === 'empty' && demoEmptyHits < 1){
      demoEmptyHits++;
      return { ok:false, empty:true, error:'cache empty', cacheRemaining:0 };
    }
    return { ok:true, id:'demo-0417-' + demoNextIdx, videoUrl:DEMO_MP4, s3Url:DEMO_MP4,
             product:'5mg', cacheRemaining:4,
             source: (demoNextIdx++ % 2 === 0) ? 'campaign' : 'custom' };
  });
}

/* ── GO ──
   The reel is restored first so BACK works from the very first frame, then
   the channel opens on something FRESH. A reload is a channel you tuned back
   into, not a session you resumed mid-film. */
setSound(false);
chInit();
/* THE ENTRY POINT. Held behind the 21+ gate — see chBootWhenAgeAllows. */
chBootWhenAgeAllows();

/* ── AUTOFOCUS THE FIRST QUESTION ──────────────────────────────────────────
   Lands the cursor in fLocation on load. Two things it must never do:
     · fight the 5-second brand hold or the autoplay that follows — it can't,
       because focusing an input touches nothing those run off (heroHold()'s
       timer, the video element's own play()), and the keydown handler far
       above this already bails out on tag==='input', so a keystroke typed
       here cannot reach the m/r/space/arrow shortcuts either.
     · pop the keyboard or force the fold open on a phone, where the row
       starts folded shut (body starts with class m-form-shut — see the
       markup). matchMedia against the exact breakpoint that governs the
       fold (760px, see the phone media query above) is what decides that,
       not the class, since the class is present in the markup even on a
       desktop-width window and is a no-op there. preventScroll keeps this
       from moving the page at all on load. */
try{
  var foldedOnPhone = window.matchMedia && window.matchMedia('(max-width:760px)').matches;
  if(fLocation && !foldedOnPhone){
    var landFocus = function(){ try{ fLocation.focus({preventScroll:true}); }catch(e2){} };
    /* boot() — called just above — has already run beginRequest()
       synchronously, which disables the three fields for the length of the
       cold-start fetch; a disabled control cannot take focus, so focusing
       right here would silently no-op. Wait for setBusy(false) to lift that
       (success or failure both call it) rather than touching boot()/setBusy
       itself — this is the one and only autofocus, so it disconnects the
       instant the field is usable. */
    if(!fLocation.disabled){
      landFocus();
    } else {
      var focusWatch = new MutationObserver(function(){
        if(!fLocation.disabled){ focusWatch.disconnect(); landFocus(); }
      });
      focusWatch.observe(fLocation, { attributes:true, attributeFilter:['disabled'] });
    }
  }
}catch(e){}

})();
